// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
* Bootstrap overrides https://v4-alpha.getbootstrap.com/getting-started/options/
* All values defined in bootstrap source
* https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss can be overwritten here
* Make sure not to add !default to values here
*/
/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #ffffff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: #0a58ca;
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.15rem;
  --bs-border-radius-sm: 0.1rem;
  --bs-border-radius-lg: 0.125rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6ea8fe;
  --bs-secondary-text-emphasis: #a7acb1;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: #6edff6;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #031633;
  --bs-secondary-bg-subtle: #161719;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #084298;
  --bs-secondary-border-subtle: #41464b;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #087990;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6ea8fe;
  --bs-link-hover-color: #8bb9fe;
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}

@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}

@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}

@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}

@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

[dir="ltr"] ol,
[dir="ltr"] ul {
  padding-left: 2rem;
}

[dir="rtl"] ol,
[dir="rtl"] ul {
  padding-right: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
}

[dir="ltr"] dd {
  margin-left: 0;
}

[dir="rtl"] dd {
  margin-right: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}

a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}

a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.1rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
}

[dir="ltr"] caption {
  text-align: left;
}

[dir="rtl"] caption {
  text-align: right;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}

[dir="ltr"] legend {
  float: left;
}

[dir="rtl"] legend {
  float: right;
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}

[dir="ltr"] legend + * {
  clear: left;
}

[dir="rtl"] legend + * {
  clear: right;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

[dir="rtl"] [type="tel"],
[dir="rtl"] [type="url"],
[dir="rtl"] [type="email"],
[dir="rtl"] [type="number"] {
  direction: ltr;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  list-style: none;
}

[dir="ltr"] .list-unstyled {
  padding-left: 0;
}

[dir="rtl"] .list-unstyled {
  padding-right: 0;
}

.list-inline {
  list-style: none;
}

[dir="ltr"] .list-inline {
  padding-left: 0;
}

[dir="rtl"] .list-inline {
  padding-right: 0;
}

.list-inline-item {
  display: inline-block;
}

[dir="ltr"] .list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

[dir="rtl"] .list-inline-item:not(:last-child) {
  margin-left: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}

.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}

@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}

:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}

.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0 0%;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

[dir="ltr"] .offset-1 {
  margin-left: 8.33333333%;
}

[dir="rtl"] .offset-1 {
  margin-right: 8.33333333%;
}

[dir="ltr"] .offset-2 {
  margin-left: 16.66666667%;
}

[dir="rtl"] .offset-2 {
  margin-right: 16.66666667%;
}

[dir="ltr"] .offset-3 {
  margin-left: 25%;
}

[dir="rtl"] .offset-3 {
  margin-right: 25%;
}

[dir="ltr"] .offset-4 {
  margin-left: 33.33333333%;
}

[dir="rtl"] .offset-4 {
  margin-right: 33.33333333%;
}

[dir="ltr"] .offset-5 {
  margin-left: 41.66666667%;
}

[dir="rtl"] .offset-5 {
  margin-right: 41.66666667%;
}

[dir="ltr"] .offset-6 {
  margin-left: 50%;
}

[dir="rtl"] .offset-6 {
  margin-right: 50%;
}

[dir="ltr"] .offset-7 {
  margin-left: 58.33333333%;
}

[dir="rtl"] .offset-7 {
  margin-right: 58.33333333%;
}

[dir="ltr"] .offset-8 {
  margin-left: 66.66666667%;
}

[dir="rtl"] .offset-8 {
  margin-right: 66.66666667%;
}

[dir="ltr"] .offset-9 {
  margin-left: 75%;
}

[dir="rtl"] .offset-9 {
  margin-right: 75%;
}

[dir="ltr"] .offset-10 {
  margin-left: 83.33333333%;
}

[dir="rtl"] .offset-10 {
  margin-right: 83.33333333%;
}

[dir="ltr"] .offset-11 {
  margin-left: 91.66666667%;
}

[dir="rtl"] .offset-11 {
  margin-right: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0 0%;
  }

  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  [dir="ltr"] .offset-sm-0 {
    margin-left: 0;
  }

  [dir="rtl"] .offset-sm-0 {
    margin-right: 0;
  }

  [dir="ltr"] .offset-sm-1 {
    margin-left: 8.33333333%;
  }

  [dir="rtl"] .offset-sm-1 {
    margin-right: 8.33333333%;
  }

  [dir="ltr"] .offset-sm-2 {
    margin-left: 16.66666667%;
  }

  [dir="rtl"] .offset-sm-2 {
    margin-right: 16.66666667%;
  }

  [dir="ltr"] .offset-sm-3 {
    margin-left: 25%;
  }

  [dir="rtl"] .offset-sm-3 {
    margin-right: 25%;
  }

  [dir="ltr"] .offset-sm-4 {
    margin-left: 33.33333333%;
  }

  [dir="rtl"] .offset-sm-4 {
    margin-right: 33.33333333%;
  }

  [dir="ltr"] .offset-sm-5 {
    margin-left: 41.66666667%;
  }

  [dir="rtl"] .offset-sm-5 {
    margin-right: 41.66666667%;
  }

  [dir="ltr"] .offset-sm-6 {
    margin-left: 50%;
  }

  [dir="rtl"] .offset-sm-6 {
    margin-right: 50%;
  }

  [dir="ltr"] .offset-sm-7 {
    margin-left: 58.33333333%;
  }

  [dir="rtl"] .offset-sm-7 {
    margin-right: 58.33333333%;
  }

  [dir="ltr"] .offset-sm-8 {
    margin-left: 66.66666667%;
  }

  [dir="rtl"] .offset-sm-8 {
    margin-right: 66.66666667%;
  }

  [dir="ltr"] .offset-sm-9 {
    margin-left: 75%;
  }

  [dir="rtl"] .offset-sm-9 {
    margin-right: 75%;
  }

  [dir="ltr"] .offset-sm-10 {
    margin-left: 83.33333333%;
  }

  [dir="rtl"] .offset-sm-10 {
    margin-right: 83.33333333%;
  }

  [dir="ltr"] .offset-sm-11 {
    margin-left: 91.66666667%;
  }

  [dir="rtl"] .offset-sm-11 {
    margin-right: 91.66666667%;
  }

  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }

  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }

  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }

  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }

  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }

  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 768px) {
  .col-md {
    flex: 1 0 0%;
  }

  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  [dir="ltr"] .offset-md-0 {
    margin-left: 0;
  }

  [dir="rtl"] .offset-md-0 {
    margin-right: 0;
  }

  [dir="ltr"] .offset-md-1 {
    margin-left: 8.33333333%;
  }

  [dir="rtl"] .offset-md-1 {
    margin-right: 8.33333333%;
  }

  [dir="ltr"] .offset-md-2 {
    margin-left: 16.66666667%;
  }

  [dir="rtl"] .offset-md-2 {
    margin-right: 16.66666667%;
  }

  [dir="ltr"] .offset-md-3 {
    margin-left: 25%;
  }

  [dir="rtl"] .offset-md-3 {
    margin-right: 25%;
  }

  [dir="ltr"] .offset-md-4 {
    margin-left: 33.33333333%;
  }

  [dir="rtl"] .offset-md-4 {
    margin-right: 33.33333333%;
  }

  [dir="ltr"] .offset-md-5 {
    margin-left: 41.66666667%;
  }

  [dir="rtl"] .offset-md-5 {
    margin-right: 41.66666667%;
  }

  [dir="ltr"] .offset-md-6 {
    margin-left: 50%;
  }

  [dir="rtl"] .offset-md-6 {
    margin-right: 50%;
  }

  [dir="ltr"] .offset-md-7 {
    margin-left: 58.33333333%;
  }

  [dir="rtl"] .offset-md-7 {
    margin-right: 58.33333333%;
  }

  [dir="ltr"] .offset-md-8 {
    margin-left: 66.66666667%;
  }

  [dir="rtl"] .offset-md-8 {
    margin-right: 66.66666667%;
  }

  [dir="ltr"] .offset-md-9 {
    margin-left: 75%;
  }

  [dir="rtl"] .offset-md-9 {
    margin-right: 75%;
  }

  [dir="ltr"] .offset-md-10 {
    margin-left: 83.33333333%;
  }

  [dir="rtl"] .offset-md-10 {
    margin-right: 83.33333333%;
  }

  [dir="ltr"] .offset-md-11 {
    margin-left: 91.66666667%;
  }

  [dir="rtl"] .offset-md-11 {
    margin-right: 91.66666667%;
  }

  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }

  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }

  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }

  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }

  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }

  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 992px) {
  .col-lg {
    flex: 1 0 0%;
  }

  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  [dir="ltr"] .offset-lg-0 {
    margin-left: 0;
  }

  [dir="rtl"] .offset-lg-0 {
    margin-right: 0;
  }

  [dir="ltr"] .offset-lg-1 {
    margin-left: 8.33333333%;
  }

  [dir="rtl"] .offset-lg-1 {
    margin-right: 8.33333333%;
  }

  [dir="ltr"] .offset-lg-2 {
    margin-left: 16.66666667%;
  }

  [dir="rtl"] .offset-lg-2 {
    margin-right: 16.66666667%;
  }

  [dir="ltr"] .offset-lg-3 {
    margin-left: 25%;
  }

  [dir="rtl"] .offset-lg-3 {
    margin-right: 25%;
  }

  [dir="ltr"] .offset-lg-4 {
    margin-left: 33.33333333%;
  }

  [dir="rtl"] .offset-lg-4 {
    margin-right: 33.33333333%;
  }

  [dir="ltr"] .offset-lg-5 {
    margin-left: 41.66666667%;
  }

  [dir="rtl"] .offset-lg-5 {
    margin-right: 41.66666667%;
  }

  [dir="ltr"] .offset-lg-6 {
    margin-left: 50%;
  }

  [dir="rtl"] .offset-lg-6 {
    margin-right: 50%;
  }

  [dir="ltr"] .offset-lg-7 {
    margin-left: 58.33333333%;
  }

  [dir="rtl"] .offset-lg-7 {
    margin-right: 58.33333333%;
  }

  [dir="ltr"] .offset-lg-8 {
    margin-left: 66.66666667%;
  }

  [dir="rtl"] .offset-lg-8 {
    margin-right: 66.66666667%;
  }

  [dir="ltr"] .offset-lg-9 {
    margin-left: 75%;
  }

  [dir="rtl"] .offset-lg-9 {
    margin-right: 75%;
  }

  [dir="ltr"] .offset-lg-10 {
    margin-left: 83.33333333%;
  }

  [dir="rtl"] .offset-lg-10 {
    margin-right: 83.33333333%;
  }

  [dir="ltr"] .offset-lg-11 {
    margin-left: 91.66666667%;
  }

  [dir="rtl"] .offset-lg-11 {
    margin-right: 91.66666667%;
  }

  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }

  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }

  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }

  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }

  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }

  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0 0%;
  }

  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  [dir="ltr"] .offset-xl-0 {
    margin-left: 0;
  }

  [dir="rtl"] .offset-xl-0 {
    margin-right: 0;
  }

  [dir="ltr"] .offset-xl-1 {
    margin-left: 8.33333333%;
  }

  [dir="rtl"] .offset-xl-1 {
    margin-right: 8.33333333%;
  }

  [dir="ltr"] .offset-xl-2 {
    margin-left: 16.66666667%;
  }

  [dir="rtl"] .offset-xl-2 {
    margin-right: 16.66666667%;
  }

  [dir="ltr"] .offset-xl-3 {
    margin-left: 25%;
  }

  [dir="rtl"] .offset-xl-3 {
    margin-right: 25%;
  }

  [dir="ltr"] .offset-xl-4 {
    margin-left: 33.33333333%;
  }

  [dir="rtl"] .offset-xl-4 {
    margin-right: 33.33333333%;
  }

  [dir="ltr"] .offset-xl-5 {
    margin-left: 41.66666667%;
  }

  [dir="rtl"] .offset-xl-5 {
    margin-right: 41.66666667%;
  }

  [dir="ltr"] .offset-xl-6 {
    margin-left: 50%;
  }

  [dir="rtl"] .offset-xl-6 {
    margin-right: 50%;
  }

  [dir="ltr"] .offset-xl-7 {
    margin-left: 58.33333333%;
  }

  [dir="rtl"] .offset-xl-7 {
    margin-right: 58.33333333%;
  }

  [dir="ltr"] .offset-xl-8 {
    margin-left: 66.66666667%;
  }

  [dir="rtl"] .offset-xl-8 {
    margin-right: 66.66666667%;
  }

  [dir="ltr"] .offset-xl-9 {
    margin-left: 75%;
  }

  [dir="rtl"] .offset-xl-9 {
    margin-right: 75%;
  }

  [dir="ltr"] .offset-xl-10 {
    margin-left: 83.33333333%;
  }

  [dir="rtl"] .offset-xl-10 {
    margin-right: 83.33333333%;
  }

  [dir="ltr"] .offset-xl-11 {
    margin-left: 91.66666667%;
  }

  [dir="rtl"] .offset-xl-11 {
    margin-right: 91.66666667%;
  }

  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }

  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }

  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }

  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }

  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }

  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0 0%;
  }

  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  [dir="ltr"] .offset-xxl-0 {
    margin-left: 0;
  }

  [dir="rtl"] .offset-xxl-0 {
    margin-right: 0;
  }

  [dir="ltr"] .offset-xxl-1 {
    margin-left: 8.33333333%;
  }

  [dir="rtl"] .offset-xxl-1 {
    margin-right: 8.33333333%;
  }

  [dir="ltr"] .offset-xxl-2 {
    margin-left: 16.66666667%;
  }

  [dir="rtl"] .offset-xxl-2 {
    margin-right: 16.66666667%;
  }

  [dir="ltr"] .offset-xxl-3 {
    margin-left: 25%;
  }

  [dir="rtl"] .offset-xxl-3 {
    margin-right: 25%;
  }

  [dir="ltr"] .offset-xxl-4 {
    margin-left: 33.33333333%;
  }

  [dir="rtl"] .offset-xxl-4 {
    margin-right: 33.33333333%;
  }

  [dir="ltr"] .offset-xxl-5 {
    margin-left: 41.66666667%;
  }

  [dir="rtl"] .offset-xxl-5 {
    margin-right: 41.66666667%;
  }

  [dir="ltr"] .offset-xxl-6 {
    margin-left: 50%;
  }

  [dir="rtl"] .offset-xxl-6 {
    margin-right: 50%;
  }

  [dir="ltr"] .offset-xxl-7 {
    margin-left: 58.33333333%;
  }

  [dir="rtl"] .offset-xxl-7 {
    margin-right: 58.33333333%;
  }

  [dir="ltr"] .offset-xxl-8 {
    margin-left: 66.66666667%;
  }

  [dir="rtl"] .offset-xxl-8 {
    margin-right: 66.66666667%;
  }

  [dir="ltr"] .offset-xxl-9 {
    margin-left: 75%;
  }

  [dir="rtl"] .offset-xxl-9 {
    margin-right: 75%;
  }

  [dir="ltr"] .offset-xxl-10 {
    margin-left: 83.33333333%;
  }

  [dir="rtl"] .offset-xxl-10 {
    margin-right: 83.33333333%;
  }

  [dir="ltr"] .offset-xxl-11 {
    margin-left: 91.66666667%;
  }

  [dir="rtl"] .offset-xxl-11 {
    margin-right: 91.66666667%;
  }

  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }

  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }

  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }

  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }

  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }

  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}

.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}

.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}

.table > tbody {
  vertical-align: inherit;
}

.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}

.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}

.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #a6b5cc;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #b5b6b7;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #a7b9b1;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #a6c3ca;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #ccc2a4;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #c6acae;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #c6c7c8;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #4d5154;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}

.form-control[type=file] {
  overflow: hidden;
}

.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}

.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}

.form-control::-moz-placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}

.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}

.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}

.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}

.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}

.form-control-plaintext:focus {
  outline: 0;
}

.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}

textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}

.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}

.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}

.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}

.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
  display: block;
  width: 100%;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

[dir="ltr"] .form-select {
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  background-position: right 0.75rem center;
}

[dir="rtl"] .form-select {
  padding: 0.375rem 0.75rem 0.375rem 2.25rem;
  background-position: left 0.75rem center;
}

@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}

.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-select[multiple], .form-select[size]:not([size="1"]) {
  background-image: none;
}

[dir="ltr"] .form-select[multiple], [dir="ltr"] .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
}

[dir="rtl"] .form-select[multiple], [dir="rtl"] .form-select[size]:not([size="1"]) {
  padding-left: 0.75rem;
}

.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}

.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

[dir="ltr"] .form-select-sm {
  padding-left: 0.5rem;
}

[dir="rtl"] .form-select-sm {
  padding-right: 0.5rem;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[dir="ltr"] .form-select-lg {
  padding-left: 1rem;
}

[dir="rtl"] .form-select-lg {
  padding-right: 1rem;
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dee2e6' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
}

.form-check {
  display: block;
  min-height: 1.5rem;
  margin-bottom: 0.125rem;
}

[dir="ltr"] .form-check {
  padding-left: 1.5em;
}

[dir="rtl"] .form-check {
  padding-right: 1.5em;
}

[dir="ltr"] .form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

[dir="rtl"] .form-check .form-check-input {
  float: right;
  margin-right: -1.5em;
}

[dir="ltr"] .form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}

[dir="rtl"] .form-check-reverse {
  padding-left: 1.5em;
  padding-right: 0;
  text-align: left;
}

[dir="ltr"] .form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

[dir="rtl"] .form-check-reverse .form-check-input {
  float: left;
  margin-left: -1.5em;
  margin-right: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}

.form-check-input[type=radio] {
  border-radius: 50%;
}

.form-check-input:active {
  filter: brightness(90%);
}

.form-check-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
}

.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e");
}

.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e");
}

.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}

.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

[dir="ltr"] .form-switch {
  padding-left: 2.5em;
}

[dir="rtl"] .form-switch {
  padding-right: 2.5em;
}

.form-switch .form-check-input {
  --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e");
  width: 2em;
  background-image: var(--bs-form-switch-bg);
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}

[dir="ltr"] .form-switch .form-check-input {
  margin-left: -2.5em;
  background-position: left center;
}

[dir="rtl"] .form-switch .form-check-input {
  margin-right: -2.5em;
  background-position: right center;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}

.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386b7fe'/%3e%3c/svg%3e");
}

.form-switch .form-check-input:checked {
  --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
}

[dir="ltr"] .form-switch .form-check-input:checked {
  background-position: right center;
}

[dir="rtl"] .form-switch .form-check-input:checked {
  background-position: left center;
}

[dir="ltr"] .form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}

[dir="rtl"] .form-switch.form-check-reverse {
  padding-left: 2.5em;
  padding-right: 0;
}

[dir="ltr"] .form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

[dir="rtl"] .form-switch.form-check-reverse .form-check-input {
  margin-left: -2.5em;
  margin-right: 0;
}

.form-check-inline {
  display: inline-block;
}

[dir="ltr"] .form-check-inline {
  margin-right: 1rem;
}

[dir="rtl"] .form-check-inline {
  margin-left: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e");
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: transparent;
}

.form-range:focus {
  outline: 0;
}

.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-range::-moz-focus-outer {
  border: 0;
}

.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  -webkit-appearance: none;
          appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}

.form-range::-webkit-slider-thumb:active {
  background-color: #b6d4fe;
}

.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}

.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  -moz-appearance: none;
       appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}

.form-range::-moz-range-thumb:active {
  background-color: #b6d4fe;
}

.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}

.form-range:disabled {
  pointer-events: none;
}

.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}

.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}

.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}

.form-floating > label {
  position: absolute;
  top: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

[dir="ltr"] .form-floating > label {
  left: 0;
  transform-origin: 0 0;
}

[dir="rtl"] .form-floating > label {
  right: 0;
  transform-origin: 100% 0;
}

@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}

.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}

.form-floating > .form-control::-moz-placeholder, .form-floating > .form-control-plaintext::-moz-placeholder {
  color: transparent;
}

.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}

.form-floating > .form-control:not(:-moz-placeholder-shown), .form-floating > .form-control-plaintext:not(:-moz-placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control:not(:-moz-placeholder-shown) ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
}

.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
}

[dir="ltr"] .form-floating > .form-control:not(:-moz-placeholder-shown) ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

[dir="ltr"] .form-floating > .form-control:focus ~ label,
[dir="ltr"] .form-floating > .form-control:not(:placeholder-shown) ~ label,
[dir="ltr"] .form-floating > .form-control-plaintext ~ label,
[dir="ltr"] .form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

[dir="rtl"] .form-floating > .form-control:not(:-moz-placeholder-shown) ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(-0.15rem);
}

[dir="rtl"] .form-floating > .form-control:focus ~ label,
[dir="rtl"] .form-floating > .form-control:not(:placeholder-shown) ~ label,
[dir="rtl"] .form-floating > .form-control-plaintext ~ label,
[dir="rtl"] .form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(-0.15rem);
}

.form-floating > .form-control:not(:-moz-placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}

.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}

.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
}

[dir="ltr"] .form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

[dir="rtl"] .form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(-0.15rem);
}

.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}

.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}

.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}

.input-group .btn {
  position: relative;
  z-index: 2;
}

.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

[dir="ltr"] .input-group-lg > .form-select,
[dir="ltr"] .input-group-sm > .form-select {
  padding-right: 3rem;
}

[dir="rtl"] .input-group-lg > .form-select,
[dir="rtl"] .input-group-sm > .form-select {
  padding-left: 3rem;
}

[dir="ltr"] .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
[dir="ltr"] .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
[dir="ltr"] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
[dir="ltr"] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

[dir="rtl"] .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
[dir="rtl"] .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
[dir="rtl"] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
[dir="rtl"] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

[dir="ltr"] .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
[dir="ltr"] .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
[dir="ltr"] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
[dir="ltr"] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

[dir="rtl"] .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
[dir="rtl"] .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
[dir="rtl"] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
[dir="rtl"] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

[dir="ltr"] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

[dir="rtl"] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-right: calc(var(--bs-border-width) * -1);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

[dir="ltr"] .input-group > .form-floating:not(:first-child) > .form-control,
[dir="ltr"] .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

[dir="rtl"] .input-group > .form-floating:not(:first-child) > .form-control,
[dir="rtl"] .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

[dir="ltr"] .was-validated .form-control:valid, [dir="ltr"] .form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: right calc(0.375em + 0.1875rem) center;
}

[dir="rtl"] .was-validated .form-control:valid, [dir="rtl"] .form-control.is-valid {
  padding-left: calc(1.5em + 0.75rem);
  background-position: left calc(0.375em + 0.1875rem) center;
}

.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

[dir="ltr"] .was-validated textarea.form-control:valid, [dir="ltr"] textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

[dir="rtl"] .was-validated textarea.form-control:valid, [dir="rtl"] textarea.form-control.is-valid {
  padding-left: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) left calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}

.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

[dir="ltr"] .was-validated .form-select:valid:not([multiple]):not([size]), [dir="ltr"] .was-validated .form-select:valid:not([multiple])[size="1"], [dir="ltr"] .form-select.is-valid:not([multiple]):not([size]), [dir="ltr"] .form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
}

[dir="rtl"] .was-validated .form-select:valid:not([multiple]):not([size]), [dir="rtl"] .was-validated .form-select:valid:not([multiple])[size="1"], [dir="rtl"] .form-select.is-valid:not([multiple]):not([size]), [dir="rtl"] .form-select.is-valid:not([multiple])[size="1"] {
  padding-left: 4.125rem;
  background-position: left 0.75rem center, center left 2.25rem;
}

.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}

.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}

.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

[dir="ltr"] .form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

[dir="rtl"] .form-check-inline .form-check-input ~ .valid-feedback {
  margin-right: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

[dir="ltr"] .was-validated .form-control:invalid, [dir="ltr"] .form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: right calc(0.375em + 0.1875rem) center;
}

[dir="rtl"] .was-validated .form-control:invalid, [dir="rtl"] .form-control.is-invalid {
  padding-left: calc(1.5em + 0.75rem);
  background-position: left calc(0.375em + 0.1875rem) center;
}

.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

[dir="ltr"] .was-validated textarea.form-control:invalid, [dir="ltr"] textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

[dir="rtl"] .was-validated textarea.form-control:invalid, [dir="rtl"] textarea.form-control.is-invalid {
  padding-left: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) left calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}

.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

[dir="ltr"] .was-validated .form-select:invalid:not([multiple]):not([size]), [dir="ltr"] .was-validated .form-select:invalid:not([multiple])[size="1"], [dir="ltr"] .form-select.is-invalid:not([multiple]):not([size]), [dir="ltr"] .form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
}

[dir="rtl"] .was-validated .form-select:invalid:not([multiple]):not([size]), [dir="rtl"] .was-validated .form-select:invalid:not([multiple])[size="1"], [dir="rtl"] .form-select.is-invalid:not([multiple]):not([size]), [dir="rtl"] .form-select.is-invalid:not([multiple])[size="1"] {
  padding-left: 4.125rem;
  background-position: left 0.75rem center, center left 2.25rem;
}

.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}

.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}

.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

[dir="ltr"] .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

[dir="rtl"] .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-right: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}

.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}

.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}

.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}

.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b5ed7;
  --bs-btn-hover-border-color: #0a58ca;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5c636a;
  --bs-btn-hover-border-color: #565e64;
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #565e64;
  --bs-btn-active-border-color: #51585e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #157347;
  --bs-btn-hover-border-color: #146c43;
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #146c43;
  --bs-btn-active-border-color: #13653f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #31d2f2;
  --bs-btn-hover-border-color: #25cff2;
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3dd5f3;
  --bs-btn-active-border-color: #25cff2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffca2c;
  --bs-btn-hover-border-color: #ffc720;
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffcd39;
  --bs-btn-active-border-color: #ffc720;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bb2d3b;
  --bs-btn-hover-border-color: #b02a37;
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b02a37;
  --bs-btn-active-border-color: #a52834;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d3d4d5;
  --bs-btn-hover-border-color: #c6c7c8;
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7c8;
  --bs-btn-active-border-color: #babbbc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #424649;
  --bs-btn-hover-border-color: #373b3e;
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4d5154;
  --bs-btn-active-border-color: #373b3e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}

.btn-link:focus-visible {
  color: var(--bs-btn-color);
}

.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}

.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

[dir="ltr"] .dropdown-toggle::after {
  margin-left: 0.255em;
}

[dir="rtl"] .dropdown-toggle::after {
  margin-right: 0.255em;
}

[dir="ltr"] .dropdown-toggle:empty::after {
  margin-left: 0;
}

[dir="rtl"] .dropdown-toggle:empty::after {
  margin-right: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}

[dir="ltr"] .dropdown-menu {
  text-align: left;
}

[dir="rtl"] .dropdown-menu {
  text-align: right;
}

.dropdown-menu[data-bs-popper] {
  top: 100%;
  margin-top: var(--bs-dropdown-spacer);
}

[dir="ltr"] .dropdown-menu[data-bs-popper] {
  left: 0;
}

[dir="rtl"] .dropdown-menu[data-bs-popper] {
  right: 0;
}

.dropdown-menu-start {
  --bs-position: start;
}

[dir="ltr"] .dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

[dir="rtl"] .dropdown-menu-start[data-bs-popper] {
  left: auto;
  right: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}

[dir="ltr"] .dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

[dir="rtl"] .dropdown-menu-end[data-bs-popper] {
  left: 0;
  right: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }

  [dir="ltr"] .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  [dir="rtl"] .dropdown-menu-sm-start[data-bs-popper] {
    left: auto;
    right: 0;
  }

  .dropdown-menu-sm-end {
    --bs-position: end;
  }

  [dir="ltr"] .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }

  [dir="rtl"] .dropdown-menu-sm-end[data-bs-popper] {
    left: 0;
    right: auto;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }

  [dir="ltr"] .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  [dir="rtl"] .dropdown-menu-md-start[data-bs-popper] {
    left: auto;
    right: 0;
  }

  .dropdown-menu-md-end {
    --bs-position: end;
  }

  [dir="ltr"] .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }

  [dir="rtl"] .dropdown-menu-md-end[data-bs-popper] {
    left: 0;
    right: auto;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }

  [dir="ltr"] .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  [dir="rtl"] .dropdown-menu-lg-start[data-bs-popper] {
    left: auto;
    right: 0;
  }

  .dropdown-menu-lg-end {
    --bs-position: end;
  }

  [dir="ltr"] .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }

  [dir="rtl"] .dropdown-menu-lg-end[data-bs-popper] {
    left: 0;
    right: auto;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }

  [dir="ltr"] .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  [dir="rtl"] .dropdown-menu-xl-start[data-bs-popper] {
    left: auto;
    right: 0;
  }

  .dropdown-menu-xl-end {
    --bs-position: end;
  }

  [dir="ltr"] .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }

  [dir="rtl"] .dropdown-menu-xl-end[data-bs-popper] {
    left: 0;
    right: auto;
  }
}

@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }

  [dir="ltr"] .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  [dir="rtl"] .dropdown-menu-xxl-start[data-bs-popper] {
    left: auto;
    right: 0;
  }

  .dropdown-menu-xxl-end {
    --bs-position: end;
  }

  [dir="ltr"] .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }

  [dir="rtl"] .dropdown-menu-xxl-end[data-bs-popper] {
    left: 0;
    right: auto;
  }
}

.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

[dir="ltr"] .dropup .dropdown-toggle::after {
  margin-left: 0.255em;
}

[dir="rtl"] .dropup .dropdown-toggle::after {
  margin-right: 0.255em;
}

[dir="ltr"] .dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

[dir="rtl"] .dropup .dropdown-toggle:empty::after {
  margin-right: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  margin-top: 0;
}

[dir="ltr"] .dropend .dropdown-menu[data-bs-popper] {
  right: auto;
  left: 100%;
  margin-left: var(--bs-dropdown-spacer);
}

[dir="rtl"] .dropend .dropdown-menu[data-bs-popper] {
  left: auto;
  right: 100%;
  margin-right: var(--bs-dropdown-spacer);
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-bottom: 0.3em solid transparent;
}

[dir="ltr"] .dropend .dropdown-toggle::after {
  margin-left: 0.255em;
  border-right: 0;
  border-left: 0.3em solid;
}

[dir="rtl"] .dropend .dropdown-toggle::after {
  margin-right: 0.255em;
  border-left: 0;
  border-right: 0.3em solid;
}

[dir="ltr"] .dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}

[dir="rtl"] .dropend .dropdown-toggle:empty::after {
  margin-right: 0;
}

.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  margin-top: 0;
}

[dir="ltr"] .dropstart .dropdown-menu[data-bs-popper] {
  right: 100%;
  left: auto;
  margin-right: var(--bs-dropdown-spacer);
}

[dir="rtl"] .dropstart .dropdown-menu[data-bs-popper] {
  left: 100%;
  right: auto;
  margin-left: var(--bs-dropdown-spacer);
}

.dropstart .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
}

[dir="ltr"] .dropstart .dropdown-toggle::after {
  margin-left: 0.255em;
}

[dir="rtl"] .dropstart .dropdown-toggle::after {
  margin-right: 0.255em;
}

.dropstart .dropdown-toggle::after {
  display: none;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-bottom: 0.3em solid transparent;
}

[dir="ltr"] .dropstart .dropdown-toggle::before {
  margin-right: 0.255em;
  border-right: 0.3em solid;
}

[dir="rtl"] .dropstart .dropdown-toggle::before {
  margin-left: 0.255em;
  border-left: 0.3em solid;
}

[dir="ltr"] .dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}

[dir="rtl"] .dropstart .dropdown-toggle:empty::after {
  margin-right: 0;
}

.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}

.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}

.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}

.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}

[dir="ltr"] .btn-group > :not(.btn-check:first-child) + .btn,
[dir="ltr"] .btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}

[dir="rtl"] .btn-group > :not(.btn-check:first-child) + .btn,
[dir="rtl"] .btn-group > .btn-group:not(:first-child) {
  margin-right: calc(var(--bs-border-width) * -1);
}

[dir="ltr"] .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
[dir="ltr"] .btn-group > .btn.dropdown-toggle-split:first-child,
[dir="ltr"] .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

[dir="rtl"] .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
[dir="rtl"] .btn-group > .btn.dropdown-toggle-split:first-child,
[dir="rtl"] .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

[dir="ltr"] .btn-group > .btn:nth-child(n+3),
[dir="ltr"] .btn-group > :not(.btn-check) + .btn,
[dir="ltr"] .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

[dir="rtl"] .btn-group > .btn:nth-child(n+3),
[dir="rtl"] .btn-group > :not(.btn-check) + .btn,
[dir="rtl"] .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

[dir="ltr"] .dropdown-toggle-split::after, [dir="ltr"] .dropup .dropdown-toggle-split::after, [dir="ltr"] .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}

[dir="rtl"] .dropdown-toggle-split::after, [dir="rtl"] .dropup .dropdown-toggle-split::after, [dir="rtl"] .dropend .dropdown-toggle-split::after {
  margin-right: 0;
}

[dir="ltr"] .dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

[dir="rtl"] .dropstart .dropdown-toggle-split::before {
  margin-left: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}

.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}

.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  list-style: none;
}

[dir="ltr"] .nav {
  padding-left: 0;
}

[dir="rtl"] .nav {
  padding-right: 0;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}

.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}

.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}

.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}

.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}

.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}

.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}

.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}

.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}

.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}

.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}

.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}

[dir="ltr"] .navbar-brand {
  margin-right: var(--bs-navbar-brand-margin-end);
}

[dir="rtl"] .navbar-brand {
  margin-left: var(--bs-navbar-brand-margin-end);
}

.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  list-style: none;
}

[dir="ltr"] .navbar-nav {
  padding-left: 0;
}

[dir="rtl"] .navbar-nav {
  padding-right: 0;
}

.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}

.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}

.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}

@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}

.navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-sm .navbar-toggler {
    display: none;
  }

  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-md .navbar-toggler {
    display: none;
  }

  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-lg .navbar-toggler {
    display: none;
  }

  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xl .navbar-toggler {
    display: none;
  }

  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }

  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}

.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}

.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}

.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}

.card > hr {
  margin-right: 0;
  margin-left: 0;
}

.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

[dir="ltr"] .card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

[dir="rtl"] .card-link + .card-link {
  margin-right: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}

.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }

  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }

  [dir="ltr"] .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }

  [dir="rtl"] .card-group > .card + .card {
    margin-right: 0;
    border-right: 0;
  }

  [dir="ltr"] .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="rtl"] .card-group > .card:not(:last-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="ltr"] .card-group > .card:not(:last-child) .card-img-top,
  [dir="ltr"] .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }

  [dir="rtl"] .card-group > .card:not(:last-child) .card-img-top,
  [dir="rtl"] .card-group > .card:not(:last-child) .card-header {
    border-top-left-radius: 0;
  }

  [dir="ltr"] .card-group > .card:not(:last-child) .card-img-bottom,
  [dir="ltr"] .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }

  [dir="rtl"] .card-group > .card:not(:last-child) .card-img-bottom,
  [dir="rtl"] .card-group > .card:not(:last-child) .card-footer {
    border-bottom-left-radius: 0;
  }

  [dir="ltr"] .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .card-group > .card:not(:first-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .card-group > .card:not(:first-child) .card-img-top,
  [dir="ltr"] .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }

  [dir="rtl"] .card-group > .card:not(:first-child) .card-img-top,
  [dir="rtl"] .card-group > .card:not(:first-child) .card-header {
    border-top-right-radius: 0;
  }

  [dir="ltr"] .card-group > .card:not(:first-child) .card-img-bottom,
  [dir="ltr"] .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .card-group > .card:not(:first-child) .card-img-bottom,
  [dir="rtl"] .card-group > .card:not(:first-child) .card-footer {
    border-bottom-right-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23212529' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e");
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23052c65' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e");
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}

[dir="ltr"] .accordion-button {
  text-align: left;
}

[dir="rtl"] .accordion-button {
  text-align: right;
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}

.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}

.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}

[dir="ltr"] .accordion-button::after {
  margin-left: auto;
}

[dir="rtl"] .accordion-button::after {
  margin-right: auto;
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}

.accordion-button:hover {
  z-index: 2;
}

.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}

.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}

.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:not(:first-of-type) {
  border-top: 0;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}

.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}

.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}

.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

[dir="ltr"] .breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}

[dir="rtl"] .breadcrumb-item + .breadcrumb-item {
  padding-right: var(--bs-breadcrumb-item-padding-x);
}

.breadcrumb-item + .breadcrumb-item::before {
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/");
}

[dir="ltr"] .breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
}

[dir="rtl"] .breadcrumb-item + .breadcrumb-item::before {
  float: right;
  padding-left: var(--bs-breadcrumb-item-padding-x);
}

.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  list-style: none;
}

[dir="ltr"] .pagination {
  padding-left: 0;
}

[dir="rtl"] .pagination {
  padding-right: 0;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}

.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}

.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}

.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}

.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

[dir="ltr"] .page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}

[dir="rtl"] .page-item:not(:first-child) .page-link {
  margin-right: calc(var(--bs-border-width) * -1);
}

[dir="ltr"] .page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}

[dir="rtl"] .page-item:first-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

[dir="ltr"] .page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

[dir="rtl"] .page-item:last-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

[dir="ltr"] .alert-dismissible {
  padding-right: 3rem;
}

[dir="rtl"] .alert-dismissible {
  padding-left: 3rem;
}

.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

[dir="ltr"] .alert-dismissible .btn-close {
  right: 0;
}

[dir="rtl"] .alert-dismissible .btn-close {
  left: 0;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}

.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

[dir="ltr"] .progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}

[dir="rtl"] .progress-bar-striped {
  background-image: linear-gradient(-45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

[dir="ltr"] .list-group {
  padding-left: 0;
}

[dir="rtl"] .list-group {
  padding-right: 0;
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}

.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}

.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}

.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}

.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}

.list-group-item + .list-group-item {
  border-top-width: 0;
}

.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}

[dir="ltr"] .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}

[dir="rtl"] .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-right-radius: var(--bs-list-group-border-radius);
  border-top-left-radius: 0;
}

[dir="ltr"] .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}

[dir="rtl"] .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-left-radius: var(--bs-list-group-border-radius);
  border-bottom-right-radius: 0;
}

.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
}

[dir="ltr"] .list-group-horizontal > .list-group-item + .list-group-item {
  border-left-width: 0;
}

[dir="rtl"] .list-group-horizontal > .list-group-item + .list-group-item {
  border-right-width: 0;
}

[dir="ltr"] .list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

[dir="rtl"] .list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-right: calc(-1 * var(--bs-list-group-border-width));
  border-right-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }

  [dir="ltr"] .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  [dir="rtl"] .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--bs-list-group-border-radius);
    border-top-left-radius: 0;
  }

  [dir="ltr"] .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--bs-list-group-border-radius);
    border-bottom-right-radius: 0;
  }

  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
  }

  [dir="ltr"] .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-left-width: 0;
  }

  [dir="rtl"] .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-right-width: 0;
  }

  [dir="ltr"] .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }

  [dir="rtl"] .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--bs-list-group-border-width));
    border-right-width: var(--bs-list-group-border-width);
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }

  [dir="ltr"] .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  [dir="rtl"] .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--bs-list-group-border-radius);
    border-top-left-radius: 0;
  }

  [dir="ltr"] .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--bs-list-group-border-radius);
    border-bottom-right-radius: 0;
  }

  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
  }

  [dir="ltr"] .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-left-width: 0;
  }

  [dir="rtl"] .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-right-width: 0;
  }

  [dir="ltr"] .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }

  [dir="rtl"] .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--bs-list-group-border-width));
    border-right-width: var(--bs-list-group-border-width);
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }

  [dir="ltr"] .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  [dir="rtl"] .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--bs-list-group-border-radius);
    border-top-left-radius: 0;
  }

  [dir="ltr"] .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--bs-list-group-border-radius);
    border-bottom-right-radius: 0;
  }

  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
  }

  [dir="ltr"] .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-left-width: 0;
  }

  [dir="rtl"] .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-right-width: 0;
  }

  [dir="ltr"] .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }

  [dir="rtl"] .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--bs-list-group-border-width));
    border-right-width: var(--bs-list-group-border-width);
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }

  [dir="ltr"] .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  [dir="rtl"] .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--bs-list-group-border-radius);
    border-top-left-radius: 0;
  }

  [dir="ltr"] .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--bs-list-group-border-radius);
    border-bottom-right-radius: 0;
  }

  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
  }

  [dir="ltr"] .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-left-width: 0;
  }

  [dir="rtl"] .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-right-width: 0;
  }

  [dir="ltr"] .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }

  [dir="rtl"] .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--bs-list-group-border-width));
    border-right-width: var(--bs-list-group-border-width);
  }
}

@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }

  [dir="ltr"] .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  [dir="rtl"] .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--bs-list-group-border-radius);
    border-top-left-radius: 0;
  }

  [dir="ltr"] .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--bs-list-group-border-radius);
    border-bottom-right-radius: 0;
  }

  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
  }

  [dir="ltr"] .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-left-width: 0;
  }

  [dir="rtl"] .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-right-width: 0;
  }

  [dir="ltr"] .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }

  [dir="rtl"] .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--bs-list-group-border-width));
    border-right-width: var(--bs-list-group-border-width);
  }
}

.list-group-flush {
  border-radius: 0;
}

.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}

.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e");
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.15rem;
  opacity: var(--bs-btn-close-opacity);
}

.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}

.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}

.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}

.toast.showing {
  opacity: 0;
}

.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: -moz-max-content;
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}

.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}

[dir="ltr"] .toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

[dir="rtl"] .toast-header .btn-close {
  margin-left: calc(-0.5 * var(--bs-toast-padding-x));
  margin-right: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

[dir="ltr"] .modal {
  left: 0;
}

[dir="rtl"] .modal {
  right: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}

.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}

[dir="ltr"] .modal-backdrop {
  left: 0;
}

[dir="rtl"] .modal-backdrop {
  right: 0;
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
}

[dir="ltr"] .modal-header .btn-close {
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

[dir="rtl"] .modal-header .btn-close {
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) auto calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x));
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}

.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }

  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }

  .modal-sm {
    --bs-modal-width: 300px;
  }
}

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}

.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}

.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}

.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}

.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}

.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}

.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}

.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}

.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}

.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}

.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}

.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}

.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  display: block;
  width: var(--bs-popover-arrow-width);
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

[dir="ltr"] .bs-popover-bottom .popover-header::before, [dir="ltr"] .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  left: 50%;
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
}

[dir="rtl"] .bs-popover-bottom .popover-header::before, [dir="rtl"] .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  right: 50%;
  margin-right: calc(-0.5 * var(--bs-popover-arrow-width));
}

.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}

.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  width: 100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

[dir="ltr"] .carousel-item {
  float: left;
  margin-right: -100%;
}

[dir="rtl"] .carousel-item {
  float: right;
  margin-left: -100%;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

[dir="ltr"] .carousel-item-next:not(.carousel-item-start),
[dir="ltr"] .active.carousel-item-end {
  transform: translateX(100%);
}

[dir="rtl"] .carousel-item-next:not(.carousel-item-start),
[dir="rtl"] .active.carousel-item-end {
  transform: translateX(-100%);
}

[dir="ltr"] .carousel-item-prev:not(.carousel-item-end),
[dir="ltr"] .active.carousel-item-start {
  transform: translateX(-100%);
}

[dir="rtl"] .carousel-item-prev:not(.carousel-item-end),
[dir="rtl"] .active.carousel-item-start {
  transform: translateX(100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}

.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

[dir="ltr"] .carousel-control-prev {
  left: 0;
}

[dir="rtl"] .carousel-control-prev {
  right: 0;
}

[dir="ltr"] .carousel-control-next {
  right: 0;
}

[dir="rtl"] .carousel-control-next {
  left: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

[dir="ltr"] .carousel-control-prev-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e");
}

[dir="rtl"] .carousel-control-prev-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}

[dir="ltr"] .carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}

[dir="rtl"] .carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e");
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}

.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}

.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}

.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}

[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}

[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}

.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
}

[dir="ltr"] .spinner-border {
  border-right-color: transparent;
}

[dir="rtl"] .spinner-border {
  border-left-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
    transform: none;
  }
}

.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}

.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}

@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    width: var(--bs-offcanvas-width);
  }

  [dir="ltr"] .offcanvas-sm.offcanvas-start {
    left: 0;
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  [dir="rtl"] .offcanvas-sm.offcanvas-start {
    right: 0;
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  .offcanvas-sm.offcanvas-end {
    top: 0;
    width: var(--bs-offcanvas-width);
  }

  [dir="ltr"] .offcanvas-sm.offcanvas-end {
    right: 0;
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  [dir="rtl"] .offcanvas-sm.offcanvas-end {
    left: 0;
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }

  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }

  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }

  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}

@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-sm .offcanvas-header {
    display: none;
  }

  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    width: var(--bs-offcanvas-width);
  }

  [dir="ltr"] .offcanvas-md.offcanvas-start {
    left: 0;
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  [dir="rtl"] .offcanvas-md.offcanvas-start {
    right: 0;
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  .offcanvas-md.offcanvas-end {
    top: 0;
    width: var(--bs-offcanvas-width);
  }

  [dir="ltr"] .offcanvas-md.offcanvas-end {
    right: 0;
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  [dir="rtl"] .offcanvas-md.offcanvas-end {
    left: 0;
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }

  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }

  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }

  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}

@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-md .offcanvas-header {
    display: none;
  }

  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    width: var(--bs-offcanvas-width);
  }

  [dir="ltr"] .offcanvas-lg.offcanvas-start {
    left: 0;
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  [dir="rtl"] .offcanvas-lg.offcanvas-start {
    right: 0;
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  .offcanvas-lg.offcanvas-end {
    top: 0;
    width: var(--bs-offcanvas-width);
  }

  [dir="ltr"] .offcanvas-lg.offcanvas-end {
    right: 0;
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  [dir="rtl"] .offcanvas-lg.offcanvas-end {
    left: 0;
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }

  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }

  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }

  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}

@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-lg .offcanvas-header {
    display: none;
  }

  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    width: var(--bs-offcanvas-width);
  }

  [dir="ltr"] .offcanvas-xl.offcanvas-start {
    left: 0;
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  [dir="rtl"] .offcanvas-xl.offcanvas-start {
    right: 0;
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  .offcanvas-xl.offcanvas-end {
    top: 0;
    width: var(--bs-offcanvas-width);
  }

  [dir="ltr"] .offcanvas-xl.offcanvas-end {
    right: 0;
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  [dir="rtl"] .offcanvas-xl.offcanvas-end {
    left: 0;
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }

  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }

  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }

  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}

@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-xl .offcanvas-header {
    display: none;
  }

  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    width: var(--bs-offcanvas-width);
  }

  [dir="ltr"] .offcanvas-xxl.offcanvas-start {
    left: 0;
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  [dir="rtl"] .offcanvas-xxl.offcanvas-start {
    right: 0;
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  .offcanvas-xxl.offcanvas-end {
    top: 0;
    width: var(--bs-offcanvas-width);
  }

  [dir="ltr"] .offcanvas-xxl.offcanvas-end {
    right: 0;
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  [dir="rtl"] .offcanvas-xxl.offcanvas-end {
    left: 0;
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }

  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }

  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }

  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}

@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-xxl .offcanvas-header {
    display: none;
  }

  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}

@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}

.offcanvas.offcanvas-start {
  top: 0;
  width: var(--bs-offcanvas-width);
}

[dir="ltr"] .offcanvas.offcanvas-start {
  left: 0;
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}

[dir="rtl"] .offcanvas.offcanvas-start {
  right: 0;
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}

.offcanvas.offcanvas-end {
  top: 0;
  width: var(--bs-offcanvas-width);
}

[dir="ltr"] .offcanvas.offcanvas-end {
  right: 0;
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}

[dir="rtl"] .offcanvas.offcanvas-end {
  left: 0;
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}

.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}

.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}

.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}

.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

[dir="ltr"] .offcanvas-backdrop {
  left: 0;
}

[dir="rtl"] .offcanvas-backdrop {
  right: 0;
}

.offcanvas-backdrop.fade {
  opacity: 0;
}

.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}

.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
}

[dir="ltr"] .offcanvas-header .btn-close {
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

[dir="rtl"] .offcanvas-header .btn-close {
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) auto calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}

.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}

.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
          mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%;
  }
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}

.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}

@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

[dir="ltr"] .icon-link-hover:hover > .bi, [dir="ltr"] .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

[dir="rtl"] .icon-link-hover:hover > .bi, [dir="rtl"] .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(-0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}

.ratio > * {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

[dir="ltr"] .ratio > * {
  left: 0;
}

[dir="rtl"] .ratio > * {
  right: 0;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

[dir="ltr"] .float-start {
  float: left !important;
}

[dir="rtl"] .float-start {
  float: right !important;
}

[dir="ltr"] .float-end {
  float: right !important;
}

[dir="rtl"] .float-end {
  float: left !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  -o-object-fit: contain !important;
     object-fit: contain !important;
}

.object-fit-cover {
  -o-object-fit: cover !important;
     object-fit: cover !important;
}

.object-fit-fill {
  -o-object-fit: fill !important;
     object-fit: fill !important;
}

.object-fit-scale {
  -o-object-fit: scale-down !important;
     object-fit: scale-down !important;
}

.object-fit-none {
  -o-object-fit: none !important;
     object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

[dir="ltr"] .start-0 {
  left: 0 !important;
}

[dir="rtl"] .start-0 {
  right: 0 !important;
}

[dir="ltr"] .start-50 {
  left: 50% !important;
}

[dir="rtl"] .start-50 {
  right: 50% !important;
}

[dir="ltr"] .start-100 {
  left: 100% !important;
}

[dir="rtl"] .start-100 {
  right: 100% !important;
}

[dir="ltr"] .end-0 {
  right: 0 !important;
}

[dir="rtl"] .end-0 {
  left: 0 !important;
}

[dir="ltr"] .end-50 {
  right: 50% !important;
}

[dir="rtl"] .end-50 {
  left: 50% !important;
}

[dir="ltr"] .end-100 {
  right: 100% !important;
}

[dir="rtl"] .end-100 {
  left: 100% !important;
}

[dir="ltr"] .translate-middle {
  transform: translate(-50%, -50%) !important;
}

[dir="rtl"] .translate-middle {
  transform: translate(50%, -50%) !important;
}

[dir="ltr"] .translate-middle-x {
  transform: translateX(-50%) !important;
}

[dir="rtl"] .translate-middle-x {
  transform: translateX(50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

[dir="ltr"] .border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

[dir="rtl"] .border-end {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

[dir="ltr"] .border-end-0 {
  border-right: 0 !important;
}

[dir="rtl"] .border-end-0 {
  border-left: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

[dir="ltr"] .border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

[dir="rtl"] .border-start {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

[dir="ltr"] .border-start-0 {
  border-left: 0 !important;
}

[dir="rtl"] .border-start-0 {
  border-right: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

[dir="ltr"] .me-0 {
  margin-right: 0 !important;
}

[dir="rtl"] .me-0 {
  margin-left: 0 !important;
}

[dir="ltr"] .me-1 {
  margin-right: 0.25rem !important;
}

[dir="rtl"] .me-1 {
  margin-left: 0.25rem !important;
}

[dir="ltr"] .me-2 {
  margin-right: 0.5rem !important;
}

[dir="rtl"] .me-2 {
  margin-left: 0.5rem !important;
}

[dir="ltr"] .me-3 {
  margin-right: 1rem !important;
}

[dir="rtl"] .me-3 {
  margin-left: 1rem !important;
}

[dir="ltr"] .me-4 {
  margin-right: 1.5rem !important;
}

[dir="rtl"] .me-4 {
  margin-left: 1.5rem !important;
}

[dir="ltr"] .me-5 {
  margin-right: 3rem !important;
}

[dir="rtl"] .me-5 {
  margin-left: 3rem !important;
}

[dir="ltr"] .me-auto {
  margin-right: auto !important;
}

[dir="rtl"] .me-auto {
  margin-left: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

[dir="ltr"] .ms-0 {
  margin-left: 0 !important;
}

[dir="rtl"] .ms-0 {
  margin-right: 0 !important;
}

[dir="ltr"] .ms-1 {
  margin-left: 0.25rem !important;
}

[dir="rtl"] .ms-1 {
  margin-right: 0.25rem !important;
}

[dir="ltr"] .ms-2 {
  margin-left: 0.5rem !important;
}

[dir="rtl"] .ms-2 {
  margin-right: 0.5rem !important;
}

[dir="ltr"] .ms-3 {
  margin-left: 1rem !important;
}

[dir="rtl"] .ms-3 {
  margin-right: 1rem !important;
}

[dir="ltr"] .ms-4 {
  margin-left: 1.5rem !important;
}

[dir="rtl"] .ms-4 {
  margin-right: 1.5rem !important;
}

[dir="ltr"] .ms-5 {
  margin-left: 3rem !important;
}

[dir="rtl"] .ms-5 {
  margin-right: 3rem !important;
}

[dir="ltr"] .ms-auto {
  margin-left: auto !important;
}

[dir="rtl"] .ms-auto {
  margin-right: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

[dir="ltr"] .pe-0 {
  padding-right: 0 !important;
}

[dir="rtl"] .pe-0 {
  padding-left: 0 !important;
}

[dir="ltr"] .pe-1 {
  padding-right: 0.25rem !important;
}

[dir="rtl"] .pe-1 {
  padding-left: 0.25rem !important;
}

[dir="ltr"] .pe-2 {
  padding-right: 0.5rem !important;
}

[dir="rtl"] .pe-2 {
  padding-left: 0.5rem !important;
}

[dir="ltr"] .pe-3 {
  padding-right: 1rem !important;
}

[dir="rtl"] .pe-3 {
  padding-left: 1rem !important;
}

[dir="ltr"] .pe-4 {
  padding-right: 1.5rem !important;
}

[dir="rtl"] .pe-4 {
  padding-left: 1.5rem !important;
}

[dir="ltr"] .pe-5 {
  padding-right: 3rem !important;
}

[dir="rtl"] .pe-5 {
  padding-left: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

[dir="ltr"] .ps-0 {
  padding-left: 0 !important;
}

[dir="rtl"] .ps-0 {
  padding-right: 0 !important;
}

[dir="ltr"] .ps-1 {
  padding-left: 0.25rem !important;
}

[dir="rtl"] .ps-1 {
  padding-right: 0.25rem !important;
}

[dir="ltr"] .ps-2 {
  padding-left: 0.5rem !important;
}

[dir="rtl"] .ps-2 {
  padding-right: 0.5rem !important;
}

[dir="ltr"] .ps-3 {
  padding-left: 1rem !important;
}

[dir="rtl"] .ps-3 {
  padding-right: 1rem !important;
}

[dir="ltr"] .ps-4 {
  padding-left: 1.5rem !important;
}

[dir="rtl"] .ps-4 {
  padding-right: 1.5rem !important;
}

[dir="ltr"] .ps-5 {
  padding-left: 3rem !important;
}

[dir="rtl"] .ps-5 {
  padding-right: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  -moz-column-gap: 0 !important;
       column-gap: 0 !important;
}

.column-gap-1 {
  -moz-column-gap: 0.25rem !important;
       column-gap: 0.25rem !important;
}

.column-gap-2 {
  -moz-column-gap: 0.5rem !important;
       column-gap: 0.5rem !important;
}

.column-gap-3 {
  -moz-column-gap: 1rem !important;
       column-gap: 1rem !important;
}

.column-gap-4 {
  -moz-column-gap: 1.5rem !important;
       column-gap: 1.5rem !important;
}

.column-gap-5 {
  -moz-column-gap: 3rem !important;
       column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

[dir="ltr"] .text-start {
  text-align: left !important;
}

[dir="rtl"] .text-start {
  text-align: right !important;
}

[dir="ltr"] .text-end {
  text-align: right !important;
}

[dir="rtl"] .text-end {
  text-align: left !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
     -moz-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
     -moz-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
     -moz-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

[dir="ltr"] .rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

[dir="rtl"] .rounded-end {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

[dir="ltr"] .rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

[dir="rtl"] .rounded-end-0 {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

[dir="ltr"] .rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

[dir="rtl"] .rounded-end-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

[dir="ltr"] .rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

[dir="rtl"] .rounded-end-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

[dir="ltr"] .rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

[dir="rtl"] .rounded-end-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

[dir="ltr"] .rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

[dir="rtl"] .rounded-end-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

[dir="ltr"] .rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

[dir="rtl"] .rounded-end-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

[dir="ltr"] .rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

[dir="rtl"] .rounded-end-circle {
  border-top-left-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

[dir="ltr"] .rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

[dir="rtl"] .rounded-end-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

[dir="ltr"] .rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

[dir="rtl"] .rounded-start {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

[dir="ltr"] .rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

[dir="rtl"] .rounded-start-0 {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

[dir="ltr"] .rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

[dir="rtl"] .rounded-start-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

[dir="ltr"] .rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

[dir="rtl"] .rounded-start-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

[dir="ltr"] .rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

[dir="rtl"] .rounded-start-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

[dir="ltr"] .rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

[dir="rtl"] .rounded-start-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

[dir="ltr"] .rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

[dir="rtl"] .rounded-start-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

[dir="ltr"] .rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

[dir="rtl"] .rounded-start-circle {
  border-bottom-right-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

[dir="ltr"] .rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

[dir="rtl"] .rounded-start-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  [dir="ltr"] .float-sm-start {
    float: left !important;
  }

  [dir="rtl"] .float-sm-start {
    float: right !important;
  }

  [dir="ltr"] .float-sm-end {
    float: right !important;
  }

  [dir="rtl"] .float-sm-end {
    float: left !important;
  }

  .float-sm-none {
    float: none !important;
  }

  .object-fit-sm-contain {
    -o-object-fit: contain !important;
       object-fit: contain !important;
  }

  .object-fit-sm-cover {
    -o-object-fit: cover !important;
       object-fit: cover !important;
  }

  .object-fit-sm-fill {
    -o-object-fit: fill !important;
       object-fit: fill !important;
  }

  .object-fit-sm-scale {
    -o-object-fit: scale-down !important;
       object-fit: scale-down !important;
  }

  .object-fit-sm-none {
    -o-object-fit: none !important;
       object-fit: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-grid {
    display: grid !important;
  }

  .d-sm-inline-grid {
    display: inline-grid !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }

  .d-sm-none {
    display: none !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }

  .order-sm-first {
    order: -1 !important;
  }

  .order-sm-0 {
    order: 0 !important;
  }

  .order-sm-1 {
    order: 1 !important;
  }

  .order-sm-2 {
    order: 2 !important;
  }

  .order-sm-3 {
    order: 3 !important;
  }

  .order-sm-4 {
    order: 4 !important;
  }

  .order-sm-5 {
    order: 5 !important;
  }

  .order-sm-last {
    order: 6 !important;
  }

  .m-sm-0 {
    margin: 0 !important;
  }

  .m-sm-1 {
    margin: 0.25rem !important;
  }

  .m-sm-2 {
    margin: 0.5rem !important;
  }

  .m-sm-3 {
    margin: 1rem !important;
  }

  .m-sm-4 {
    margin: 1.5rem !important;
  }

  .m-sm-5 {
    margin: 3rem !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-sm-0 {
    margin-top: 0 !important;
  }

  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }

  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }

  .mt-sm-3 {
    margin-top: 1rem !important;
  }

  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }

  .mt-sm-5 {
    margin-top: 3rem !important;
  }

  .mt-sm-auto {
    margin-top: auto !important;
  }

  [dir="ltr"] .me-sm-0 {
    margin-right: 0 !important;
  }

  [dir="rtl"] .me-sm-0 {
    margin-left: 0 !important;
  }

  [dir="ltr"] .me-sm-1 {
    margin-right: 0.25rem !important;
  }

  [dir="rtl"] .me-sm-1 {
    margin-left: 0.25rem !important;
  }

  [dir="ltr"] .me-sm-2 {
    margin-right: 0.5rem !important;
  }

  [dir="rtl"] .me-sm-2 {
    margin-left: 0.5rem !important;
  }

  [dir="ltr"] .me-sm-3 {
    margin-right: 1rem !important;
  }

  [dir="rtl"] .me-sm-3 {
    margin-left: 1rem !important;
  }

  [dir="ltr"] .me-sm-4 {
    margin-right: 1.5rem !important;
  }

  [dir="rtl"] .me-sm-4 {
    margin-left: 1.5rem !important;
  }

  [dir="ltr"] .me-sm-5 {
    margin-right: 3rem !important;
  }

  [dir="rtl"] .me-sm-5 {
    margin-left: 3rem !important;
  }

  [dir="ltr"] .me-sm-auto {
    margin-right: auto !important;
  }

  [dir="rtl"] .me-sm-auto {
    margin-left: auto !important;
  }

  .mb-sm-0 {
    margin-bottom: 0 !important;
  }

  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }

  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }

  .mb-sm-auto {
    margin-bottom: auto !important;
  }

  [dir="ltr"] .ms-sm-0 {
    margin-left: 0 !important;
  }

  [dir="rtl"] .ms-sm-0 {
    margin-right: 0 !important;
  }

  [dir="ltr"] .ms-sm-1 {
    margin-left: 0.25rem !important;
  }

  [dir="rtl"] .ms-sm-1 {
    margin-right: 0.25rem !important;
  }

  [dir="ltr"] .ms-sm-2 {
    margin-left: 0.5rem !important;
  }

  [dir="rtl"] .ms-sm-2 {
    margin-right: 0.5rem !important;
  }

  [dir="ltr"] .ms-sm-3 {
    margin-left: 1rem !important;
  }

  [dir="rtl"] .ms-sm-3 {
    margin-right: 1rem !important;
  }

  [dir="ltr"] .ms-sm-4 {
    margin-left: 1.5rem !important;
  }

  [dir="rtl"] .ms-sm-4 {
    margin-right: 1.5rem !important;
  }

  [dir="ltr"] .ms-sm-5 {
    margin-left: 3rem !important;
  }

  [dir="rtl"] .ms-sm-5 {
    margin-right: 3rem !important;
  }

  [dir="ltr"] .ms-sm-auto {
    margin-left: auto !important;
  }

  [dir="rtl"] .ms-sm-auto {
    margin-right: auto !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .p-sm-1 {
    padding: 0.25rem !important;
  }

  .p-sm-2 {
    padding: 0.5rem !important;
  }

  .p-sm-3 {
    padding: 1rem !important;
  }

  .p-sm-4 {
    padding: 1.5rem !important;
  }

  .p-sm-5 {
    padding: 3rem !important;
  }

  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-sm-0 {
    padding-top: 0 !important;
  }

  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }

  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }

  .pt-sm-3 {
    padding-top: 1rem !important;
  }

  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }

  .pt-sm-5 {
    padding-top: 3rem !important;
  }

  [dir="ltr"] .pe-sm-0 {
    padding-right: 0 !important;
  }

  [dir="rtl"] .pe-sm-0 {
    padding-left: 0 !important;
  }

  [dir="ltr"] .pe-sm-1 {
    padding-right: 0.25rem !important;
  }

  [dir="rtl"] .pe-sm-1 {
    padding-left: 0.25rem !important;
  }

  [dir="ltr"] .pe-sm-2 {
    padding-right: 0.5rem !important;
  }

  [dir="rtl"] .pe-sm-2 {
    padding-left: 0.5rem !important;
  }

  [dir="ltr"] .pe-sm-3 {
    padding-right: 1rem !important;
  }

  [dir="rtl"] .pe-sm-3 {
    padding-left: 1rem !important;
  }

  [dir="ltr"] .pe-sm-4 {
    padding-right: 1.5rem !important;
  }

  [dir="rtl"] .pe-sm-4 {
    padding-left: 1.5rem !important;
  }

  [dir="ltr"] .pe-sm-5 {
    padding-right: 3rem !important;
  }

  [dir="rtl"] .pe-sm-5 {
    padding-left: 3rem !important;
  }

  .pb-sm-0 {
    padding-bottom: 0 !important;
  }

  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }

  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }

  [dir="ltr"] .ps-sm-0 {
    padding-left: 0 !important;
  }

  [dir="rtl"] .ps-sm-0 {
    padding-right: 0 !important;
  }

  [dir="ltr"] .ps-sm-1 {
    padding-left: 0.25rem !important;
  }

  [dir="rtl"] .ps-sm-1 {
    padding-right: 0.25rem !important;
  }

  [dir="ltr"] .ps-sm-2 {
    padding-left: 0.5rem !important;
  }

  [dir="rtl"] .ps-sm-2 {
    padding-right: 0.5rem !important;
  }

  [dir="ltr"] .ps-sm-3 {
    padding-left: 1rem !important;
  }

  [dir="rtl"] .ps-sm-3 {
    padding-right: 1rem !important;
  }

  [dir="ltr"] .ps-sm-4 {
    padding-left: 1.5rem !important;
  }

  [dir="rtl"] .ps-sm-4 {
    padding-right: 1.5rem !important;
  }

  [dir="ltr"] .ps-sm-5 {
    padding-left: 3rem !important;
  }

  [dir="rtl"] .ps-sm-5 {
    padding-right: 3rem !important;
  }

  .gap-sm-0 {
    gap: 0 !important;
  }

  .gap-sm-1 {
    gap: 0.25rem !important;
  }

  .gap-sm-2 {
    gap: 0.5rem !important;
  }

  .gap-sm-3 {
    gap: 1rem !important;
  }

  .gap-sm-4 {
    gap: 1.5rem !important;
  }

  .gap-sm-5 {
    gap: 3rem !important;
  }

  .row-gap-sm-0 {
    row-gap: 0 !important;
  }

  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }

  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }

  .column-gap-sm-0 {
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .column-gap-sm-1 {
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .column-gap-sm-2 {
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .column-gap-sm-3 {
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .column-gap-sm-4 {
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .column-gap-sm-5 {
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  [dir="ltr"] .text-sm-start {
    text-align: left !important;
  }

  [dir="rtl"] .text-sm-start {
    text-align: right !important;
  }

  [dir="ltr"] .text-sm-end {
    text-align: right !important;
  }

  [dir="rtl"] .text-sm-end {
    text-align: left !important;
  }

  .text-sm-center {
    text-align: center !important;
  }
}

@media (min-width: 768px) {
  [dir="ltr"] .float-md-start {
    float: left !important;
  }

  [dir="rtl"] .float-md-start {
    float: right !important;
  }

  [dir="ltr"] .float-md-end {
    float: right !important;
  }

  [dir="rtl"] .float-md-end {
    float: left !important;
  }

  .float-md-none {
    float: none !important;
  }

  .object-fit-md-contain {
    -o-object-fit: contain !important;
       object-fit: contain !important;
  }

  .object-fit-md-cover {
    -o-object-fit: cover !important;
       object-fit: cover !important;
  }

  .object-fit-md-fill {
    -o-object-fit: fill !important;
       object-fit: fill !important;
  }

  .object-fit-md-scale {
    -o-object-fit: scale-down !important;
       object-fit: scale-down !important;
  }

  .object-fit-md-none {
    -o-object-fit: none !important;
       object-fit: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-grid {
    display: grid !important;
  }

  .d-md-inline-grid {
    display: inline-grid !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }

  .d-md-none {
    display: none !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }

  .order-md-first {
    order: -1 !important;
  }

  .order-md-0 {
    order: 0 !important;
  }

  .order-md-1 {
    order: 1 !important;
  }

  .order-md-2 {
    order: 2 !important;
  }

  .order-md-3 {
    order: 3 !important;
  }

  .order-md-4 {
    order: 4 !important;
  }

  .order-md-5 {
    order: 5 !important;
  }

  .order-md-last {
    order: 6 !important;
  }

  .m-md-0 {
    margin: 0 !important;
  }

  .m-md-1 {
    margin: 0.25rem !important;
  }

  .m-md-2 {
    margin: 0.5rem !important;
  }

  .m-md-3 {
    margin: 1rem !important;
  }

  .m-md-4 {
    margin: 1.5rem !important;
  }

  .m-md-5 {
    margin: 3rem !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-md-0 {
    margin-top: 0 !important;
  }

  .mt-md-1 {
    margin-top: 0.25rem !important;
  }

  .mt-md-2 {
    margin-top: 0.5rem !important;
  }

  .mt-md-3 {
    margin-top: 1rem !important;
  }

  .mt-md-4 {
    margin-top: 1.5rem !important;
  }

  .mt-md-5 {
    margin-top: 3rem !important;
  }

  .mt-md-auto {
    margin-top: auto !important;
  }

  [dir="ltr"] .me-md-0 {
    margin-right: 0 !important;
  }

  [dir="rtl"] .me-md-0 {
    margin-left: 0 !important;
  }

  [dir="ltr"] .me-md-1 {
    margin-right: 0.25rem !important;
  }

  [dir="rtl"] .me-md-1 {
    margin-left: 0.25rem !important;
  }

  [dir="ltr"] .me-md-2 {
    margin-right: 0.5rem !important;
  }

  [dir="rtl"] .me-md-2 {
    margin-left: 0.5rem !important;
  }

  [dir="ltr"] .me-md-3 {
    margin-right: 1rem !important;
  }

  [dir="rtl"] .me-md-3 {
    margin-left: 1rem !important;
  }

  [dir="ltr"] .me-md-4 {
    margin-right: 1.5rem !important;
  }

  [dir="rtl"] .me-md-4 {
    margin-left: 1.5rem !important;
  }

  [dir="ltr"] .me-md-5 {
    margin-right: 3rem !important;
  }

  [dir="rtl"] .me-md-5 {
    margin-left: 3rem !important;
  }

  [dir="ltr"] .me-md-auto {
    margin-right: auto !important;
  }

  [dir="rtl"] .me-md-auto {
    margin-left: auto !important;
  }

  .mb-md-0 {
    margin-bottom: 0 !important;
  }

  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-md-3 {
    margin-bottom: 1rem !important;
  }

  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-md-5 {
    margin-bottom: 3rem !important;
  }

  .mb-md-auto {
    margin-bottom: auto !important;
  }

  [dir="ltr"] .ms-md-0 {
    margin-left: 0 !important;
  }

  [dir="rtl"] .ms-md-0 {
    margin-right: 0 !important;
  }

  [dir="ltr"] .ms-md-1 {
    margin-left: 0.25rem !important;
  }

  [dir="rtl"] .ms-md-1 {
    margin-right: 0.25rem !important;
  }

  [dir="ltr"] .ms-md-2 {
    margin-left: 0.5rem !important;
  }

  [dir="rtl"] .ms-md-2 {
    margin-right: 0.5rem !important;
  }

  [dir="ltr"] .ms-md-3 {
    margin-left: 1rem !important;
  }

  [dir="rtl"] .ms-md-3 {
    margin-right: 1rem !important;
  }

  [dir="ltr"] .ms-md-4 {
    margin-left: 1.5rem !important;
  }

  [dir="rtl"] .ms-md-4 {
    margin-right: 1.5rem !important;
  }

  [dir="ltr"] .ms-md-5 {
    margin-left: 3rem !important;
  }

  [dir="rtl"] .ms-md-5 {
    margin-right: 3rem !important;
  }

  [dir="ltr"] .ms-md-auto {
    margin-left: auto !important;
  }

  [dir="rtl"] .ms-md-auto {
    margin-right: auto !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .p-md-1 {
    padding: 0.25rem !important;
  }

  .p-md-2 {
    padding: 0.5rem !important;
  }

  .p-md-3 {
    padding: 1rem !important;
  }

  .p-md-4 {
    padding: 1.5rem !important;
  }

  .p-md-5 {
    padding: 3rem !important;
  }

  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-md-0 {
    padding-top: 0 !important;
  }

  .pt-md-1 {
    padding-top: 0.25rem !important;
  }

  .pt-md-2 {
    padding-top: 0.5rem !important;
  }

  .pt-md-3 {
    padding-top: 1rem !important;
  }

  .pt-md-4 {
    padding-top: 1.5rem !important;
  }

  .pt-md-5 {
    padding-top: 3rem !important;
  }

  [dir="ltr"] .pe-md-0 {
    padding-right: 0 !important;
  }

  [dir="rtl"] .pe-md-0 {
    padding-left: 0 !important;
  }

  [dir="ltr"] .pe-md-1 {
    padding-right: 0.25rem !important;
  }

  [dir="rtl"] .pe-md-1 {
    padding-left: 0.25rem !important;
  }

  [dir="ltr"] .pe-md-2 {
    padding-right: 0.5rem !important;
  }

  [dir="rtl"] .pe-md-2 {
    padding-left: 0.5rem !important;
  }

  [dir="ltr"] .pe-md-3 {
    padding-right: 1rem !important;
  }

  [dir="rtl"] .pe-md-3 {
    padding-left: 1rem !important;
  }

  [dir="ltr"] .pe-md-4 {
    padding-right: 1.5rem !important;
  }

  [dir="rtl"] .pe-md-4 {
    padding-left: 1.5rem !important;
  }

  [dir="ltr"] .pe-md-5 {
    padding-right: 3rem !important;
  }

  [dir="rtl"] .pe-md-5 {
    padding-left: 3rem !important;
  }

  .pb-md-0 {
    padding-bottom: 0 !important;
  }

  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-md-3 {
    padding-bottom: 1rem !important;
  }

  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-md-5 {
    padding-bottom: 3rem !important;
  }

  [dir="ltr"] .ps-md-0 {
    padding-left: 0 !important;
  }

  [dir="rtl"] .ps-md-0 {
    padding-right: 0 !important;
  }

  [dir="ltr"] .ps-md-1 {
    padding-left: 0.25rem !important;
  }

  [dir="rtl"] .ps-md-1 {
    padding-right: 0.25rem !important;
  }

  [dir="ltr"] .ps-md-2 {
    padding-left: 0.5rem !important;
  }

  [dir="rtl"] .ps-md-2 {
    padding-right: 0.5rem !important;
  }

  [dir="ltr"] .ps-md-3 {
    padding-left: 1rem !important;
  }

  [dir="rtl"] .ps-md-3 {
    padding-right: 1rem !important;
  }

  [dir="ltr"] .ps-md-4 {
    padding-left: 1.5rem !important;
  }

  [dir="rtl"] .ps-md-4 {
    padding-right: 1.5rem !important;
  }

  [dir="ltr"] .ps-md-5 {
    padding-left: 3rem !important;
  }

  [dir="rtl"] .ps-md-5 {
    padding-right: 3rem !important;
  }

  .gap-md-0 {
    gap: 0 !important;
  }

  .gap-md-1 {
    gap: 0.25rem !important;
  }

  .gap-md-2 {
    gap: 0.5rem !important;
  }

  .gap-md-3 {
    gap: 1rem !important;
  }

  .gap-md-4 {
    gap: 1.5rem !important;
  }

  .gap-md-5 {
    gap: 3rem !important;
  }

  .row-gap-md-0 {
    row-gap: 0 !important;
  }

  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-md-3 {
    row-gap: 1rem !important;
  }

  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-md-5 {
    row-gap: 3rem !important;
  }

  .column-gap-md-0 {
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .column-gap-md-1 {
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .column-gap-md-2 {
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .column-gap-md-3 {
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .column-gap-md-4 {
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .column-gap-md-5 {
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  [dir="ltr"] .text-md-start {
    text-align: left !important;
  }

  [dir="rtl"] .text-md-start {
    text-align: right !important;
  }

  [dir="ltr"] .text-md-end {
    text-align: right !important;
  }

  [dir="rtl"] .text-md-end {
    text-align: left !important;
  }

  .text-md-center {
    text-align: center !important;
  }
}

@media (min-width: 992px) {
  [dir="ltr"] .float-lg-start {
    float: left !important;
  }

  [dir="rtl"] .float-lg-start {
    float: right !important;
  }

  [dir="ltr"] .float-lg-end {
    float: right !important;
  }

  [dir="rtl"] .float-lg-end {
    float: left !important;
  }

  .float-lg-none {
    float: none !important;
  }

  .object-fit-lg-contain {
    -o-object-fit: contain !important;
       object-fit: contain !important;
  }

  .object-fit-lg-cover {
    -o-object-fit: cover !important;
       object-fit: cover !important;
  }

  .object-fit-lg-fill {
    -o-object-fit: fill !important;
       object-fit: fill !important;
  }

  .object-fit-lg-scale {
    -o-object-fit: scale-down !important;
       object-fit: scale-down !important;
  }

  .object-fit-lg-none {
    -o-object-fit: none !important;
       object-fit: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-grid {
    display: grid !important;
  }

  .d-lg-inline-grid {
    display: inline-grid !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }

  .d-lg-none {
    display: none !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }

  .order-lg-first {
    order: -1 !important;
  }

  .order-lg-0 {
    order: 0 !important;
  }

  .order-lg-1 {
    order: 1 !important;
  }

  .order-lg-2 {
    order: 2 !important;
  }

  .order-lg-3 {
    order: 3 !important;
  }

  .order-lg-4 {
    order: 4 !important;
  }

  .order-lg-5 {
    order: 5 !important;
  }

  .order-lg-last {
    order: 6 !important;
  }

  .m-lg-0 {
    margin: 0 !important;
  }

  .m-lg-1 {
    margin: 0.25rem !important;
  }

  .m-lg-2 {
    margin: 0.5rem !important;
  }

  .m-lg-3 {
    margin: 1rem !important;
  }

  .m-lg-4 {
    margin: 1.5rem !important;
  }

  .m-lg-5 {
    margin: 3rem !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-lg-0 {
    margin-top: 0 !important;
  }

  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }

  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }

  .mt-lg-3 {
    margin-top: 1rem !important;
  }

  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }

  .mt-lg-5 {
    margin-top: 3rem !important;
  }

  .mt-lg-auto {
    margin-top: auto !important;
  }

  [dir="ltr"] .me-lg-0 {
    margin-right: 0 !important;
  }

  [dir="rtl"] .me-lg-0 {
    margin-left: 0 !important;
  }

  [dir="ltr"] .me-lg-1 {
    margin-right: 0.25rem !important;
  }

  [dir="rtl"] .me-lg-1 {
    margin-left: 0.25rem !important;
  }

  [dir="ltr"] .me-lg-2 {
    margin-right: 0.5rem !important;
  }

  [dir="rtl"] .me-lg-2 {
    margin-left: 0.5rem !important;
  }

  [dir="ltr"] .me-lg-3 {
    margin-right: 1rem !important;
  }

  [dir="rtl"] .me-lg-3 {
    margin-left: 1rem !important;
  }

  [dir="ltr"] .me-lg-4 {
    margin-right: 1.5rem !important;
  }

  [dir="rtl"] .me-lg-4 {
    margin-left: 1.5rem !important;
  }

  [dir="ltr"] .me-lg-5 {
    margin-right: 3rem !important;
  }

  [dir="rtl"] .me-lg-5 {
    margin-left: 3rem !important;
  }

  [dir="ltr"] .me-lg-auto {
    margin-right: auto !important;
  }

  [dir="rtl"] .me-lg-auto {
    margin-left: auto !important;
  }

  .mb-lg-0 {
    margin-bottom: 0 !important;
  }

  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }

  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }

  .mb-lg-auto {
    margin-bottom: auto !important;
  }

  [dir="ltr"] .ms-lg-0 {
    margin-left: 0 !important;
  }

  [dir="rtl"] .ms-lg-0 {
    margin-right: 0 !important;
  }

  [dir="ltr"] .ms-lg-1 {
    margin-left: 0.25rem !important;
  }

  [dir="rtl"] .ms-lg-1 {
    margin-right: 0.25rem !important;
  }

  [dir="ltr"] .ms-lg-2 {
    margin-left: 0.5rem !important;
  }

  [dir="rtl"] .ms-lg-2 {
    margin-right: 0.5rem !important;
  }

  [dir="ltr"] .ms-lg-3 {
    margin-left: 1rem !important;
  }

  [dir="rtl"] .ms-lg-3 {
    margin-right: 1rem !important;
  }

  [dir="ltr"] .ms-lg-4 {
    margin-left: 1.5rem !important;
  }

  [dir="rtl"] .ms-lg-4 {
    margin-right: 1.5rem !important;
  }

  [dir="ltr"] .ms-lg-5 {
    margin-left: 3rem !important;
  }

  [dir="rtl"] .ms-lg-5 {
    margin-right: 3rem !important;
  }

  [dir="ltr"] .ms-lg-auto {
    margin-left: auto !important;
  }

  [dir="rtl"] .ms-lg-auto {
    margin-right: auto !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .p-lg-1 {
    padding: 0.25rem !important;
  }

  .p-lg-2 {
    padding: 0.5rem !important;
  }

  .p-lg-3 {
    padding: 1rem !important;
  }

  .p-lg-4 {
    padding: 1.5rem !important;
  }

  .p-lg-5 {
    padding: 3rem !important;
  }

  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-lg-0 {
    padding-top: 0 !important;
  }

  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }

  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }

  .pt-lg-3 {
    padding-top: 1rem !important;
  }

  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }

  .pt-lg-5 {
    padding-top: 3rem !important;
  }

  [dir="ltr"] .pe-lg-0 {
    padding-right: 0 !important;
  }

  [dir="rtl"] .pe-lg-0 {
    padding-left: 0 !important;
  }

  [dir="ltr"] .pe-lg-1 {
    padding-right: 0.25rem !important;
  }

  [dir="rtl"] .pe-lg-1 {
    padding-left: 0.25rem !important;
  }

  [dir="ltr"] .pe-lg-2 {
    padding-right: 0.5rem !important;
  }

  [dir="rtl"] .pe-lg-2 {
    padding-left: 0.5rem !important;
  }

  [dir="ltr"] .pe-lg-3 {
    padding-right: 1rem !important;
  }

  [dir="rtl"] .pe-lg-3 {
    padding-left: 1rem !important;
  }

  [dir="ltr"] .pe-lg-4 {
    padding-right: 1.5rem !important;
  }

  [dir="rtl"] .pe-lg-4 {
    padding-left: 1.5rem !important;
  }

  [dir="ltr"] .pe-lg-5 {
    padding-right: 3rem !important;
  }

  [dir="rtl"] .pe-lg-5 {
    padding-left: 3rem !important;
  }

  .pb-lg-0 {
    padding-bottom: 0 !important;
  }

  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }

  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }

  [dir="ltr"] .ps-lg-0 {
    padding-left: 0 !important;
  }

  [dir="rtl"] .ps-lg-0 {
    padding-right: 0 !important;
  }

  [dir="ltr"] .ps-lg-1 {
    padding-left: 0.25rem !important;
  }

  [dir="rtl"] .ps-lg-1 {
    padding-right: 0.25rem !important;
  }

  [dir="ltr"] .ps-lg-2 {
    padding-left: 0.5rem !important;
  }

  [dir="rtl"] .ps-lg-2 {
    padding-right: 0.5rem !important;
  }

  [dir="ltr"] .ps-lg-3 {
    padding-left: 1rem !important;
  }

  [dir="rtl"] .ps-lg-3 {
    padding-right: 1rem !important;
  }

  [dir="ltr"] .ps-lg-4 {
    padding-left: 1.5rem !important;
  }

  [dir="rtl"] .ps-lg-4 {
    padding-right: 1.5rem !important;
  }

  [dir="ltr"] .ps-lg-5 {
    padding-left: 3rem !important;
  }

  [dir="rtl"] .ps-lg-5 {
    padding-right: 3rem !important;
  }

  .gap-lg-0 {
    gap: 0 !important;
  }

  .gap-lg-1 {
    gap: 0.25rem !important;
  }

  .gap-lg-2 {
    gap: 0.5rem !important;
  }

  .gap-lg-3 {
    gap: 1rem !important;
  }

  .gap-lg-4 {
    gap: 1.5rem !important;
  }

  .gap-lg-5 {
    gap: 3rem !important;
  }

  .row-gap-lg-0 {
    row-gap: 0 !important;
  }

  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }

  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }

  .column-gap-lg-0 {
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .column-gap-lg-1 {
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .column-gap-lg-2 {
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .column-gap-lg-3 {
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .column-gap-lg-4 {
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .column-gap-lg-5 {
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  [dir="ltr"] .text-lg-start {
    text-align: left !important;
  }

  [dir="rtl"] .text-lg-start {
    text-align: right !important;
  }

  [dir="ltr"] .text-lg-end {
    text-align: right !important;
  }

  [dir="rtl"] .text-lg-end {
    text-align: left !important;
  }

  .text-lg-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  [dir="ltr"] .float-xl-start {
    float: left !important;
  }

  [dir="rtl"] .float-xl-start {
    float: right !important;
  }

  [dir="ltr"] .float-xl-end {
    float: right !important;
  }

  [dir="rtl"] .float-xl-end {
    float: left !important;
  }

  .float-xl-none {
    float: none !important;
  }

  .object-fit-xl-contain {
    -o-object-fit: contain !important;
       object-fit: contain !important;
  }

  .object-fit-xl-cover {
    -o-object-fit: cover !important;
       object-fit: cover !important;
  }

  .object-fit-xl-fill {
    -o-object-fit: fill !important;
       object-fit: fill !important;
  }

  .object-fit-xl-scale {
    -o-object-fit: scale-down !important;
       object-fit: scale-down !important;
  }

  .object-fit-xl-none {
    -o-object-fit: none !important;
       object-fit: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-grid {
    display: grid !important;
  }

  .d-xl-inline-grid {
    display: inline-grid !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }

  .d-xl-none {
    display: none !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }

  .order-xl-first {
    order: -1 !important;
  }

  .order-xl-0 {
    order: 0 !important;
  }

  .order-xl-1 {
    order: 1 !important;
  }

  .order-xl-2 {
    order: 2 !important;
  }

  .order-xl-3 {
    order: 3 !important;
  }

  .order-xl-4 {
    order: 4 !important;
  }

  .order-xl-5 {
    order: 5 !important;
  }

  .order-xl-last {
    order: 6 !important;
  }

  .m-xl-0 {
    margin: 0 !important;
  }

  .m-xl-1 {
    margin: 0.25rem !important;
  }

  .m-xl-2 {
    margin: 0.5rem !important;
  }

  .m-xl-3 {
    margin: 1rem !important;
  }

  .m-xl-4 {
    margin: 1.5rem !important;
  }

  .m-xl-5 {
    margin: 3rem !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xl-0 {
    margin-top: 0 !important;
  }

  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xl-3 {
    margin-top: 1rem !important;
  }

  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }

  .mt-xl-5 {
    margin-top: 3rem !important;
  }

  .mt-xl-auto {
    margin-top: auto !important;
  }

  [dir="ltr"] .me-xl-0 {
    margin-right: 0 !important;
  }

  [dir="rtl"] .me-xl-0 {
    margin-left: 0 !important;
  }

  [dir="ltr"] .me-xl-1 {
    margin-right: 0.25rem !important;
  }

  [dir="rtl"] .me-xl-1 {
    margin-left: 0.25rem !important;
  }

  [dir="ltr"] .me-xl-2 {
    margin-right: 0.5rem !important;
  }

  [dir="rtl"] .me-xl-2 {
    margin-left: 0.5rem !important;
  }

  [dir="ltr"] .me-xl-3 {
    margin-right: 1rem !important;
  }

  [dir="rtl"] .me-xl-3 {
    margin-left: 1rem !important;
  }

  [dir="ltr"] .me-xl-4 {
    margin-right: 1.5rem !important;
  }

  [dir="rtl"] .me-xl-4 {
    margin-left: 1.5rem !important;
  }

  [dir="ltr"] .me-xl-5 {
    margin-right: 3rem !important;
  }

  [dir="rtl"] .me-xl-5 {
    margin-left: 3rem !important;
  }

  [dir="ltr"] .me-xl-auto {
    margin-right: auto !important;
  }

  [dir="rtl"] .me-xl-auto {
    margin-left: auto !important;
  }

  .mb-xl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }

  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }

  .mb-xl-auto {
    margin-bottom: auto !important;
  }

  [dir="ltr"] .ms-xl-0 {
    margin-left: 0 !important;
  }

  [dir="rtl"] .ms-xl-0 {
    margin-right: 0 !important;
  }

  [dir="ltr"] .ms-xl-1 {
    margin-left: 0.25rem !important;
  }

  [dir="rtl"] .ms-xl-1 {
    margin-right: 0.25rem !important;
  }

  [dir="ltr"] .ms-xl-2 {
    margin-left: 0.5rem !important;
  }

  [dir="rtl"] .ms-xl-2 {
    margin-right: 0.5rem !important;
  }

  [dir="ltr"] .ms-xl-3 {
    margin-left: 1rem !important;
  }

  [dir="rtl"] .ms-xl-3 {
    margin-right: 1rem !important;
  }

  [dir="ltr"] .ms-xl-4 {
    margin-left: 1.5rem !important;
  }

  [dir="rtl"] .ms-xl-4 {
    margin-right: 1.5rem !important;
  }

  [dir="ltr"] .ms-xl-5 {
    margin-left: 3rem !important;
  }

  [dir="rtl"] .ms-xl-5 {
    margin-right: 3rem !important;
  }

  [dir="ltr"] .ms-xl-auto {
    margin-left: auto !important;
  }

  [dir="rtl"] .ms-xl-auto {
    margin-right: auto !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .p-xl-1 {
    padding: 0.25rem !important;
  }

  .p-xl-2 {
    padding: 0.5rem !important;
  }

  .p-xl-3 {
    padding: 1rem !important;
  }

  .p-xl-4 {
    padding: 1.5rem !important;
  }

  .p-xl-5 {
    padding: 3rem !important;
  }

  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-xl-0 {
    padding-top: 0 !important;
  }

  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xl-3 {
    padding-top: 1rem !important;
  }

  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }

  .pt-xl-5 {
    padding-top: 3rem !important;
  }

  [dir="ltr"] .pe-xl-0 {
    padding-right: 0 !important;
  }

  [dir="rtl"] .pe-xl-0 {
    padding-left: 0 !important;
  }

  [dir="ltr"] .pe-xl-1 {
    padding-right: 0.25rem !important;
  }

  [dir="rtl"] .pe-xl-1 {
    padding-left: 0.25rem !important;
  }

  [dir="ltr"] .pe-xl-2 {
    padding-right: 0.5rem !important;
  }

  [dir="rtl"] .pe-xl-2 {
    padding-left: 0.5rem !important;
  }

  [dir="ltr"] .pe-xl-3 {
    padding-right: 1rem !important;
  }

  [dir="rtl"] .pe-xl-3 {
    padding-left: 1rem !important;
  }

  [dir="ltr"] .pe-xl-4 {
    padding-right: 1.5rem !important;
  }

  [dir="rtl"] .pe-xl-4 {
    padding-left: 1.5rem !important;
  }

  [dir="ltr"] .pe-xl-5 {
    padding-right: 3rem !important;
  }

  [dir="rtl"] .pe-xl-5 {
    padding-left: 3rem !important;
  }

  .pb-xl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }

  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }

  [dir="ltr"] .ps-xl-0 {
    padding-left: 0 !important;
  }

  [dir="rtl"] .ps-xl-0 {
    padding-right: 0 !important;
  }

  [dir="ltr"] .ps-xl-1 {
    padding-left: 0.25rem !important;
  }

  [dir="rtl"] .ps-xl-1 {
    padding-right: 0.25rem !important;
  }

  [dir="ltr"] .ps-xl-2 {
    padding-left: 0.5rem !important;
  }

  [dir="rtl"] .ps-xl-2 {
    padding-right: 0.5rem !important;
  }

  [dir="ltr"] .ps-xl-3 {
    padding-left: 1rem !important;
  }

  [dir="rtl"] .ps-xl-3 {
    padding-right: 1rem !important;
  }

  [dir="ltr"] .ps-xl-4 {
    padding-left: 1.5rem !important;
  }

  [dir="rtl"] .ps-xl-4 {
    padding-right: 1.5rem !important;
  }

  [dir="ltr"] .ps-xl-5 {
    padding-left: 3rem !important;
  }

  [dir="rtl"] .ps-xl-5 {
    padding-right: 3rem !important;
  }

  .gap-xl-0 {
    gap: 0 !important;
  }

  .gap-xl-1 {
    gap: 0.25rem !important;
  }

  .gap-xl-2 {
    gap: 0.5rem !important;
  }

  .gap-xl-3 {
    gap: 1rem !important;
  }

  .gap-xl-4 {
    gap: 1.5rem !important;
  }

  .gap-xl-5 {
    gap: 3rem !important;
  }

  .row-gap-xl-0 {
    row-gap: 0 !important;
  }

  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }

  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }

  .column-gap-xl-0 {
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .column-gap-xl-1 {
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .column-gap-xl-2 {
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .column-gap-xl-3 {
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .column-gap-xl-4 {
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .column-gap-xl-5 {
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  [dir="ltr"] .text-xl-start {
    text-align: left !important;
  }

  [dir="rtl"] .text-xl-start {
    text-align: right !important;
  }

  [dir="ltr"] .text-xl-end {
    text-align: right !important;
  }

  [dir="rtl"] .text-xl-end {
    text-align: left !important;
  }

  .text-xl-center {
    text-align: center !important;
  }
}

@media (min-width: 1400px) {
  [dir="ltr"] .float-xxl-start {
    float: left !important;
  }

  [dir="rtl"] .float-xxl-start {
    float: right !important;
  }

  [dir="ltr"] .float-xxl-end {
    float: right !important;
  }

  [dir="rtl"] .float-xxl-end {
    float: left !important;
  }

  .float-xxl-none {
    float: none !important;
  }

  .object-fit-xxl-contain {
    -o-object-fit: contain !important;
       object-fit: contain !important;
  }

  .object-fit-xxl-cover {
    -o-object-fit: cover !important;
       object-fit: cover !important;
  }

  .object-fit-xxl-fill {
    -o-object-fit: fill !important;
       object-fit: fill !important;
  }

  .object-fit-xxl-scale {
    -o-object-fit: scale-down !important;
       object-fit: scale-down !important;
  }

  .object-fit-xxl-none {
    -o-object-fit: none !important;
       object-fit: none !important;
  }

  .d-xxl-inline {
    display: inline !important;
  }

  .d-xxl-inline-block {
    display: inline-block !important;
  }

  .d-xxl-block {
    display: block !important;
  }

  .d-xxl-grid {
    display: grid !important;
  }

  .d-xxl-inline-grid {
    display: inline-grid !important;
  }

  .d-xxl-table {
    display: table !important;
  }

  .d-xxl-table-row {
    display: table-row !important;
  }

  .d-xxl-table-cell {
    display: table-cell !important;
  }

  .d-xxl-flex {
    display: flex !important;
  }

  .d-xxl-inline-flex {
    display: inline-flex !important;
  }

  .d-xxl-none {
    display: none !important;
  }

  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xxl-row {
    flex-direction: row !important;
  }

  .flex-xxl-column {
    flex-direction: column !important;
  }

  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xxl-center {
    justify-content: center !important;
  }

  .justify-content-xxl-between {
    justify-content: space-between !important;
  }

  .justify-content-xxl-around {
    justify-content: space-around !important;
  }

  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xxl-start {
    align-items: flex-start !important;
  }

  .align-items-xxl-end {
    align-items: flex-end !important;
  }

  .align-items-xxl-center {
    align-items: center !important;
  }

  .align-items-xxl-baseline {
    align-items: baseline !important;
  }

  .align-items-xxl-stretch {
    align-items: stretch !important;
  }

  .align-content-xxl-start {
    align-content: flex-start !important;
  }

  .align-content-xxl-end {
    align-content: flex-end !important;
  }

  .align-content-xxl-center {
    align-content: center !important;
  }

  .align-content-xxl-between {
    align-content: space-between !important;
  }

  .align-content-xxl-around {
    align-content: space-around !important;
  }

  .align-content-xxl-stretch {
    align-content: stretch !important;
  }

  .align-self-xxl-auto {
    align-self: auto !important;
  }

  .align-self-xxl-start {
    align-self: flex-start !important;
  }

  .align-self-xxl-end {
    align-self: flex-end !important;
  }

  .align-self-xxl-center {
    align-self: center !important;
  }

  .align-self-xxl-baseline {
    align-self: baseline !important;
  }

  .align-self-xxl-stretch {
    align-self: stretch !important;
  }

  .order-xxl-first {
    order: -1 !important;
  }

  .order-xxl-0 {
    order: 0 !important;
  }

  .order-xxl-1 {
    order: 1 !important;
  }

  .order-xxl-2 {
    order: 2 !important;
  }

  .order-xxl-3 {
    order: 3 !important;
  }

  .order-xxl-4 {
    order: 4 !important;
  }

  .order-xxl-5 {
    order: 5 !important;
  }

  .order-xxl-last {
    order: 6 !important;
  }

  .m-xxl-0 {
    margin: 0 !important;
  }

  .m-xxl-1 {
    margin: 0.25rem !important;
  }

  .m-xxl-2 {
    margin: 0.5rem !important;
  }

  .m-xxl-3 {
    margin: 1rem !important;
  }

  .m-xxl-4 {
    margin: 1.5rem !important;
  }

  .m-xxl-5 {
    margin: 3rem !important;
  }

  .m-xxl-auto {
    margin: auto !important;
  }

  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xxl-0 {
    margin-top: 0 !important;
  }

  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xxl-3 {
    margin-top: 1rem !important;
  }

  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }

  .mt-xxl-5 {
    margin-top: 3rem !important;
  }

  .mt-xxl-auto {
    margin-top: auto !important;
  }

  [dir="ltr"] .me-xxl-0 {
    margin-right: 0 !important;
  }

  [dir="rtl"] .me-xxl-0 {
    margin-left: 0 !important;
  }

  [dir="ltr"] .me-xxl-1 {
    margin-right: 0.25rem !important;
  }

  [dir="rtl"] .me-xxl-1 {
    margin-left: 0.25rem !important;
  }

  [dir="ltr"] .me-xxl-2 {
    margin-right: 0.5rem !important;
  }

  [dir="rtl"] .me-xxl-2 {
    margin-left: 0.5rem !important;
  }

  [dir="ltr"] .me-xxl-3 {
    margin-right: 1rem !important;
  }

  [dir="rtl"] .me-xxl-3 {
    margin-left: 1rem !important;
  }

  [dir="ltr"] .me-xxl-4 {
    margin-right: 1.5rem !important;
  }

  [dir="rtl"] .me-xxl-4 {
    margin-left: 1.5rem !important;
  }

  [dir="ltr"] .me-xxl-5 {
    margin-right: 3rem !important;
  }

  [dir="rtl"] .me-xxl-5 {
    margin-left: 3rem !important;
  }

  [dir="ltr"] .me-xxl-auto {
    margin-right: auto !important;
  }

  [dir="rtl"] .me-xxl-auto {
    margin-left: auto !important;
  }

  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }

  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }

  .mb-xxl-auto {
    margin-bottom: auto !important;
  }

  [dir="ltr"] .ms-xxl-0 {
    margin-left: 0 !important;
  }

  [dir="rtl"] .ms-xxl-0 {
    margin-right: 0 !important;
  }

  [dir="ltr"] .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }

  [dir="rtl"] .ms-xxl-1 {
    margin-right: 0.25rem !important;
  }

  [dir="ltr"] .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }

  [dir="rtl"] .ms-xxl-2 {
    margin-right: 0.5rem !important;
  }

  [dir="ltr"] .ms-xxl-3 {
    margin-left: 1rem !important;
  }

  [dir="rtl"] .ms-xxl-3 {
    margin-right: 1rem !important;
  }

  [dir="ltr"] .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }

  [dir="rtl"] .ms-xxl-4 {
    margin-right: 1.5rem !important;
  }

  [dir="ltr"] .ms-xxl-5 {
    margin-left: 3rem !important;
  }

  [dir="rtl"] .ms-xxl-5 {
    margin-right: 3rem !important;
  }

  [dir="ltr"] .ms-xxl-auto {
    margin-left: auto !important;
  }

  [dir="rtl"] .ms-xxl-auto {
    margin-right: auto !important;
  }

  .p-xxl-0 {
    padding: 0 !important;
  }

  .p-xxl-1 {
    padding: 0.25rem !important;
  }

  .p-xxl-2 {
    padding: 0.5rem !important;
  }

  .p-xxl-3 {
    padding: 1rem !important;
  }

  .p-xxl-4 {
    padding: 1.5rem !important;
  }

  .p-xxl-5 {
    padding: 3rem !important;
  }

  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-xxl-0 {
    padding-top: 0 !important;
  }

  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xxl-3 {
    padding-top: 1rem !important;
  }

  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }

  .pt-xxl-5 {
    padding-top: 3rem !important;
  }

  [dir="ltr"] .pe-xxl-0 {
    padding-right: 0 !important;
  }

  [dir="rtl"] .pe-xxl-0 {
    padding-left: 0 !important;
  }

  [dir="ltr"] .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }

  [dir="rtl"] .pe-xxl-1 {
    padding-left: 0.25rem !important;
  }

  [dir="ltr"] .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }

  [dir="rtl"] .pe-xxl-2 {
    padding-left: 0.5rem !important;
  }

  [dir="ltr"] .pe-xxl-3 {
    padding-right: 1rem !important;
  }

  [dir="rtl"] .pe-xxl-3 {
    padding-left: 1rem !important;
  }

  [dir="ltr"] .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }

  [dir="rtl"] .pe-xxl-4 {
    padding-left: 1.5rem !important;
  }

  [dir="ltr"] .pe-xxl-5 {
    padding-right: 3rem !important;
  }

  [dir="rtl"] .pe-xxl-5 {
    padding-left: 3rem !important;
  }

  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }

  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }

  [dir="ltr"] .ps-xxl-0 {
    padding-left: 0 !important;
  }

  [dir="rtl"] .ps-xxl-0 {
    padding-right: 0 !important;
  }

  [dir="ltr"] .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }

  [dir="rtl"] .ps-xxl-1 {
    padding-right: 0.25rem !important;
  }

  [dir="ltr"] .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }

  [dir="rtl"] .ps-xxl-2 {
    padding-right: 0.5rem !important;
  }

  [dir="ltr"] .ps-xxl-3 {
    padding-left: 1rem !important;
  }

  [dir="rtl"] .ps-xxl-3 {
    padding-right: 1rem !important;
  }

  [dir="ltr"] .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }

  [dir="rtl"] .ps-xxl-4 {
    padding-right: 1.5rem !important;
  }

  [dir="ltr"] .ps-xxl-5 {
    padding-left: 3rem !important;
  }

  [dir="rtl"] .ps-xxl-5 {
    padding-right: 3rem !important;
  }

  .gap-xxl-0 {
    gap: 0 !important;
  }

  .gap-xxl-1 {
    gap: 0.25rem !important;
  }

  .gap-xxl-2 {
    gap: 0.5rem !important;
  }

  .gap-xxl-3 {
    gap: 1rem !important;
  }

  .gap-xxl-4 {
    gap: 1.5rem !important;
  }

  .gap-xxl-5 {
    gap: 3rem !important;
  }

  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }

  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }

  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }

  .column-gap-xxl-0 {
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .column-gap-xxl-1 {
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .column-gap-xxl-2 {
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .column-gap-xxl-3 {
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .column-gap-xxl-4 {
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .column-gap-xxl-5 {
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  [dir="ltr"] .text-xxl-start {
    text-align: left !important;
  }

  [dir="rtl"] .text-xxl-start {
    text-align: right !important;
  }

  [dir="ltr"] .text-xxl-end {
    text-align: right !important;
  }

  [dir="rtl"] .text-xxl-end {
    text-align: left !important;
  }

  .text-xxl-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }

  .fs-2 {
    font-size: 2rem !important;
  }

  .fs-3 {
    font-size: 1.75rem !important;
  }

  .fs-4 {
    font-size: 1.5rem !important;
  }
}

@media print {
  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-grid {
    display: grid !important;
  }

  .d-print-inline-grid {
    display: inline-grid !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }

  .d-print-none {
    display: none !important;
  }
}

body {
  background: #fafafa;
  margin: 0;
}

a {
  color: #533f03;
  font-weight: bold;
}

* {
  box-sizing: border-box;
}

*:after, *::before {
  box-sizing: border-box;
}

.app-container {
  box-sizing: border-box;
}

.app-container .view-container {
  width: 100%;
  height: calc(100% - 40px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1rem;
}

.app-container .view-container .card {
  padding: 1rem;
}

.app-container .view-container .view-routes {
  height: 100%;
}

.app-container .view-container .view-routes > div {
  height: 100%;
}

.fullscreen {
  position: fixed;
  top: 100px;
  width: 99% !important;
  height: calc(100vh - 110px) !important;
  margin: 5px;
  z-index: 1000;
  padding: 5px 25px 50px 25px !important;
}

[dir="ltr"] .fullscreen {
  left: 0px;
}

[dir="rtl"] .fullscreen {
  right: 0px;
}

/* ==========================================================================
Browser Upgrade Prompt
========================================================================== */
.browserupgrade {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0;
}

/* ==========================================================================
Custom button styles
========================================================================== */
.icon-button > .btn {
  background-color: transparent;
  border-color: transparent;
  padding: 0.5rem;
  line-height: 1rem;
}

.icon-button > .btn:hover {
  background-color: transparent;
  border-color: transparent;
}

.icon-button > .btn:focus {
  box-shadow: none;
}

/* ==========================================================================
Generic styles
========================================================================== */
/* Temporary workaround for availity-reactstrap-validation */
.invalid-feedback {
  display: inline;
}

/* other generic styles */
.title {
  font-size: 1.25em;
  margin: 1px 10px 1px 10px;
}

.description {
  font-size: 0.9em;
  margin: 1px 10px 1px 10px;
}

.shadow {
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
  border-radius: 2px;
}

.error {
  color: white;
  background-color: red;
}

.break {
  white-space: normal;
  word-break: break-all;
}

.break-word {
  white-space: normal;
  word-break: keep-all;
}

.preserve-space {
  white-space: pre-wrap;
}

/* padding helpers */
.pad {
  padding: 10px !important;
}

.pad-2 {
  padding: 2px !important;
}

.pad-3 {
  padding: 3px !important;
}

.pad-5 {
  padding: 5px !important;
}

.pad-10 {
  padding: 10px !important;
}

.pad-20 {
  padding: 20px !important;
}

.pad-25 {
  padding: 25px !important;
}

.pad-30 {
  padding: 30px !important;
}

.pad-50 {
  padding: 50px !important;
}

.pad-75 {
  padding: 75px !important;
}

.pad-100 {
  padding: 100px !important;
}

.pad-top-4 {
  padding-top: 4px !important;
}

.pad-top-5 {
  padding-top: 5px !important;
}

.pad-top-10 {
  padding-top: 10px !important;
}

.pad-top-20 {
  padding-top: 20px !important;
}

.pad-top-25 {
  padding-top: 25px !important;
}

.pad-top-30 {
  padding-top: 30px !important;
}

.pad-top-50 {
  padding-top: 50px !important;
}

.pad-top-75 {
  padding-top: 75px !important;
}

.pad-top-100 {
  padding-top: 100px !important;
}

.pad-bottom-4 {
  padding-bottom: 4px !important;
}

.pad-bottom-5 {
  padding-bottom: 5px !important;
}

.pad-bottom-10 {
  padding-bottom: 10px !important;
}

.pad-bottom-20 {
  padding-bottom: 20px !important;
}

.pad-bottom-25 {
  padding-bottom: 25px !important;
}

.pad-bottom-30 {
  padding-bottom: 30px !important;
}

.pad-bottom-50 {
  padding-bottom: 50px !important;
}

.pad-bottom-75 {
  padding-bottom: 75px !important;
}

.pad-bottom-100 {
  padding-bottom: 100px !important;
}

[dir="ltr"] .pad-right-5 {
  padding-right: 5px !important;
}

[dir="rtl"] .pad-right-5 {
  padding-left: 5px !important;
}

[dir="ltr"] .pad-right-10 {
  padding-right: 10px !important;
}

[dir="rtl"] .pad-right-10 {
  padding-left: 10px !important;
}

[dir="ltr"] .pad-right-20 {
  padding-right: 20px !important;
}

[dir="rtl"] .pad-right-20 {
  padding-left: 20px !important;
}

[dir="ltr"] .pad-right-25 {
  padding-right: 25px !important;
}

[dir="rtl"] .pad-right-25 {
  padding-left: 25px !important;
}

[dir="ltr"] .pad-right-30 {
  padding-right: 30px !important;
}

[dir="rtl"] .pad-right-30 {
  padding-left: 30px !important;
}

[dir="ltr"] .pad-right-50 {
  padding-right: 50px !important;
}

[dir="rtl"] .pad-right-50 {
  padding-left: 50px !important;
}

[dir="ltr"] .pad-right-75 {
  padding-right: 75px !important;
}

[dir="rtl"] .pad-right-75 {
  padding-left: 75px !important;
}

[dir="ltr"] .pad-right-100 {
  padding-right: 100px !important;
}

[dir="rtl"] .pad-right-100 {
  padding-left: 100px !important;
}

[dir="ltr"] .pad-left-5 {
  padding-left: 5px !important;
}

[dir="rtl"] .pad-left-5 {
  padding-right: 5px !important;
}

[dir="ltr"] .pad-left-10 {
  padding-left: 10px !important;
}

[dir="rtl"] .pad-left-10 {
  padding-right: 10px !important;
}

[dir="ltr"] .pad-left-20 {
  padding-left: 20px !important;
}

[dir="rtl"] .pad-left-20 {
  padding-right: 20px !important;
}

[dir="ltr"] .pad-left-25 {
  padding-left: 25px !important;
}

[dir="rtl"] .pad-left-25 {
  padding-right: 25px !important;
}

[dir="ltr"] .pad-left-30 {
  padding-left: 30px !important;
}

[dir="rtl"] .pad-left-30 {
  padding-right: 30px !important;
}

[dir="ltr"] .pad-left-50 {
  padding-left: 50px !important;
}

[dir="rtl"] .pad-left-50 {
  padding-right: 50px !important;
}

[dir="ltr"] .pad-left-75 {
  padding-left: 75px !important;
}

[dir="rtl"] .pad-left-75 {
  padding-right: 75px !important;
}

[dir="ltr"] .pad-left-100 {
  padding-left: 100px !important;
}

[dir="rtl"] .pad-left-100 {
  padding-right: 100px !important;
}

[dir="ltr"] .no-padding-left {
  padding-left: 0 !important;
}

[dir="rtl"] .no-padding-left {
  padding-right: 0 !important;
}

[dir="ltr"] .no-padding-right {
  padding-right: 0 !important;
}

[dir="rtl"] .no-padding-right {
  padding-left: 0 !important;
}

.no-padding-top {
  padding-top: 0 !important;
}

.no-padding-bottom {
  padding-bottom: 0 !important;
}

.no-padding {
  padding: 0 !important;
}

/* end of padding helpers */
.no-margin {
  margin: 0px;
}

.voffset {
  margin-top: 2px !important;
}

.voffset-5 {
  margin-top: 5px !important;
}

.voffset-10 {
  margin-top: 10px !important;
}

.voffset-15 {
  margin-top: 15px !important;
}

.voffset-30 {
  margin-top: 30px !important;
}

.voffset-40 {
  margin-top: 40px !important;
}

.voffset-60 {
  margin-top: 60px !important;
}

.voffset-80 {
  margin-top: 80px !important;
}

.voffset-100 {
  margin-top: 100px !important;
}

.voffset-150 {
  margin-top: 150px !important;
}

.readonly {
  background-color: #eee;
  opacity: 1;
}

/* ==========================================================================
make sure browsers use the pointer cursor for anchors, even with no href
========================================================================== */
a:hover {
  cursor: pointer;
}

.hand {
  cursor: pointer;
}

button.anchor-btn {
  background: none;
  border: none;
  padding: 0;
  align-items: initial;
  text-align: initial;
  width: 100%;
}

a.anchor-btn:hover {
  text-decoration: none;
}

/* ==========================================================================
Metrics and Health styles
========================================================================== */
#threadDump .popover,
#healthCheck .popover {
  top: inherit;
  display: block;
  font-size: 10px;
  max-width: 1024px;
}

.thread-dump-modal-lock {
  max-width: 450px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

[dir="ltr"] #healthCheck .popover {
  margin-left: -50px;
}

[dir="rtl"] #healthCheck .popover {
  margin-right: -50px;
}

.health-details {
  min-width: 400px;
}

/* bootstrap 3 input-group 100% width
http://stackoverflow.com/questions/23436430/bootstrap-3-input-group-100-width */
.width-min {
  width: 1% !important;
}

/* jhipster-needle-scss-add-main JHipster will add new css style */
.map-container {
  height: 400px;
  width: 100%;
}

body {
  margin: 0;
  background: #fafafa;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/app.scss","webpack://./src/main/webapp/app/_bootstrap-variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;CAAA;ACCE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,8BAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,2BAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AHIF;;AKpHI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,wCAAA;EAEA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AHIJ;;AM5KA;;;EAGE,sBAAA;AN+KF;;AMhKI;EANJ;IAOM,uBAAA;ENoKJ;AACF;;AMvJA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AN0JF;;AMjJA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;APre9B;;AM1IA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;AN2IF;;AMxIA;EFuMQ,iCAAA;AJ3DR;;AIjGI;EE3CJ;IF8MQ,iBAAA;EJ9DN;AACF;;AM5IA;EFkMQ,iCAAA;AJlDR;;AI1GI;EEtCJ;IFyMQ,eAAA;EJrDN;AACF;;AMhJA;EF6LQ,+BAAA;AJzCR;;AInHI;EEjCJ;IFoMQ,kBAAA;EJ5CN;AACF;;AMpJA;EFwLQ,iCAAA;AJhCR;;AI5HI;EE5BJ;IF+LQ,iBAAA;EJnCN;AACF;;AMxJA;EF+KM,kBALI;AJdV;;AMvJA;EF0KM,eALI;AJVV;;AMhJA;EACE,aAAA;EACA,mBCwV0B;APrM5B;;AMzIA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,sCAAA;UAAA,8BAAA;AN4IF;;AMtIA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ANyIF;;AMnIA;;EAEE,kBAAA;ANsIF;;AMxIA;;EAEE,mBAAA;ANsIF;;AMnIA;;;EAGE,aAAA;EACA,mBAAA;ANsIF;;AMnIA;;;;EAIE,gBAAA;ANsIF;;AMnIA;EACE,gBC6b4B;APvT9B;;AMjIA;EACE,qBAAA;ANqIF;;AMtIA;EAEE,cAAA;ANoIF;;AMtIA;EAEE,eAAA;ANoIF;;AM9HA;EACE,gBAAA;ANiIF;;AMzHA;;EAEE,mBCsa4B;AP1S9B;;AMpHA;EF6EM,kBALI;AJgDV;;AMjHA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;ANoHF;;AM3GA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;AN8GF;;AM3GA;EAAM,eAAA;AN+GN;;AM9GA;EAAM,WAAA;ANkHN;;AM7GA;EACE,gEAAA;EACA,0BCgNwC;APhG1C;;AM9GE;EACE,mDAAA;ANgHJ;;AMrGE;EAEE,cAAA;EACA,qBAAA;ANuGJ;;AMhGA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AJ2FV;;AM5FA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AJmGV;;AM3FE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AN6FJ;;AMzFA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;AN4FF;;AMzFE;EACE,cAAA;AN2FJ;;AMvFA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBCy5CkC;EDx5ClC,sCCy5CkC;EC9rDhC,qBAAA;ARgYJ;;AMxFE;EACE,UAAA;EF7BE,cALI;AJ6HV;;AMhFA;EACE,gBAAA;ANmFF;;AM7EA;;EAEE,sBAAA;ANgFF;;AMxEA;EACE,oBAAA;EACA,yBAAA;AN2EF;;AMxEA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;APhV9B;;AM/EA;EAIE,gBAAA;AN2EF;;AM/EA;EAIE,iBAAA;AN2EF;;AMpEA;EAEE,mBAAA;EACA,gCAAA;ANsEF;;AMnEA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ANsEF;;AM9DA;EACE,qBAAA;ANiEF;;AM3DA;EAEE,gBAAA;AN6DF;;AMrDA;EACE,UAAA;ANwDF;;AMnDA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;ANsDF;;AMlDA;;EAEE,oBAAA;ANqDF;;AMhDA;EACE,eAAA;ANmDF;;AMhDA;EAGE,iBAAA;ANiDF;;AM9CE;EACE,UAAA;ANgDJ;;AMzCA;EACE,wBAAA;AN4CF;;AMpCA;;;;EAIE,0BAAA;ANuCF;;AMpCI;;;;EACE,eAAA;ANyCN;;AMlCA;EACE,UAAA;EACA,kBAAA;ANqCF;;AMhCA;EACE,gBAAA;ANmCF;;AMzBA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AN4BF;;AMpBA;EAEE,WAAA;EACA,UAAA;EACA,qBCmN4B;EHpatB,iCAAA;EEoNN,oBAAA;ANsBF;;AM7BA;EACE,WAAA;AN4BF;;AM7BA;EACE,YAAA;AN4BF;;AItYI;EEyWJ;IFtMQ,iBAAA;EJuON;AACF;;AMzBE;EACE,WAAA;AN2BJ;;AM5BE;EACE,YAAA;AN2BJ;;AMpBA;;;;;;;EAOE,UAAA;ANuBF;;AMpBA;EACE,YAAA;ANuBF;;AMdA;EACE,6BAAA;EACA,oBAAA;ANiBF;;ACxiBA;;;;EAAA,cAAA;AAAA;;AK0iBA;EACE,wBAAA;ANSF;;AMJA;EACE,UAAA;ANOF;;AMAA;EACE,aAAA;EACA,0BAAA;ANGF;;AMEA;EACE,qBAAA;ANCF;;AMIA;EACE,SAAA;ANDF;;AMQA;EACE,kBAAA;EACA,eAAA;ANLF;;AMaA;EACE,wBAAA;ANVF;;AMkBA;EACE,wBAAA;ANfF;;AStjBA;ELmQM,kBALI;EK5PR,gBFwoB4B;AP/E9B;;ASpjBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;APnD9B;;AItdI;EKpGF;ILuQM,eAAA;EJuTN;AACF;;AS/jBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;APxC9B;;AIjeI;EKpGF;ILuQM,iBAAA;EJkUN;AACF;;AS1kBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AP7B9B;;AI5eI;EKpGF;ILuQM,eAAA;EJ6UN;AACF;;ASrlBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;APlB9B;;AIvfI;EKpGF;ILuQM,iBAAA;EJwVN;AACF;;AShmBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;APP9B;;AIlgBI;EKpGF;ILuQM,eAAA;EJmWN;AACF;;AS3mBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;API9B;;AI7gBI;EKpGF;ILuQM,iBAAA;EJ8WN;AACF;;AS9lBA;ECtDE,gBAAA;AVypBF;;ASnmBA;ECvDE,eAAA;AV0pBF;;ASnmBA;ECvDE,gBAAA;AV0pBF;;AS9lBA;EC3DE,gBAAA;AV8pBF;;ASnmBA;EC5DE,eAAA;AV+pBF;;ASnmBA;EC5DE,gBAAA;AV+pBF;;AShmBA;EACE,qBAAA;ATmmBF;;ASjmBE;EACE,oBFsoB0B;APnC9B;;ASpmBE;EACE,mBFsoB0B;APnC9B;;ASzlBA;EL8MM,kBALI;EKvMR,yBAAA;AT4lBF;;ASxlBA;EACE,mBFiUO;EH1HH,kBALI;AJ0ZV;;ASzlBE;EACE,gBAAA;AT2lBJ;;ASvlBA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;APgrBX;;ASxlBE;EACE,aAAA;AT0lBJ;;AW1rBA;ECIE,eAAA;EAGA,YAAA;AZwrBF;;AWzrBA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AZisBF;;AWnrBA;EAEE,qBAAA;AXqrBF;;AWlrBA;EACE,qBAAA;EACA,cAAA;AXqrBF;;AWlrBA;EPyPM,kBALI;EOlPR,gCJkjDkC;AP73BpC;;AavtBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AdouBF;;Ae9qBI;EF5CE;IACE,gBNkee;EP4PrB;AACF;;AeprBI;EF5CE;IACE,gBNkee;EPiQrB;AACF;;AezrBI;EF5CE;IACE,gBNkee;EPsQrB;AACF;;Ae9rBI;EF5CE;IACE,iBNkee;EP2QrB;AACF;;AensBI;EF5CE;IACE,iBNkee;EPgRrB;AACF;;AgBnwBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AhBywBJ;;AgBpwBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AjB6wBF;;AgB3wBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AjBuwBF;;AiBxtBM;EACE,YAAA;AjB2tBR;;AiBxtBM;EApCJ,cAAA;EACA,WAAA;AjBgwBF;;AiBlvBE;EACE,cAAA;EACA,WAAA;AjBqvBJ;;AiBvvBE;EACE,cAAA;EACA,UAAA;AjB0vBJ;;AiB5vBE;EACE,cAAA;EACA,mBAAA;AjB+vBJ;;AiBjwBE;EACE,cAAA;EACA,UAAA;AjBowBJ;;AiBtwBE;EACE,cAAA;EACA,UAAA;AjBywBJ;;AiB3wBE;EACE,cAAA;EACA,mBAAA;AjB8wBJ;;AiB/uBM;EAhDJ,cAAA;EACA,WAAA;AjBmyBF;;AiB9uBU;EAhEN,cAAA;EACA,kBAAA;AjBkzBJ;;AiBnvBU;EAhEN,cAAA;EACA,mBAAA;AjBuzBJ;;AiBxvBU;EAhEN,cAAA;EACA,UAAA;AjB4zBJ;;AiB7vBU;EAhEN,cAAA;EACA,mBAAA;AjBi0BJ;;AiBlwBU;EAhEN,cAAA;EACA,mBAAA;AjBs0BJ;;AiBvwBU;EAhEN,cAAA;EACA,UAAA;AjB20BJ;;AiB5wBU;EAhEN,cAAA;EACA,mBAAA;AjBg1BJ;;AiBjxBU;EAhEN,cAAA;EACA,mBAAA;AjBq1BJ;;AiBtxBU;EAhEN,cAAA;EACA,UAAA;AjB01BJ;;AiB3xBU;EAhEN,cAAA;EACA,mBAAA;AjB+1BJ;;AiBhyBU;EAhEN,cAAA;EACA,mBAAA;AjBo2BJ;;AiBryBU;EAhEN,cAAA;EACA,WAAA;AjBy2BJ;;AiBlyBY;EAxDV,wBAAA;AjB81BF;;AiBtyBY;EAxDV,yBAAA;AjB81BF;;AiBtyBY;EAxDV,yBAAA;AjBk2BF;;AiB1yBY;EAxDV,0BAAA;AjBk2BF;;AiB1yBY;EAxDV,gBAAA;AjBs2BF;;AiB9yBY;EAxDV,iBAAA;AjBs2BF;;AiB9yBY;EAxDV,yBAAA;AjB02BF;;AiBlzBY;EAxDV,0BAAA;AjB02BF;;AiBlzBY;EAxDV,yBAAA;AjB82BF;;AiBtzBY;EAxDV,0BAAA;AjB82BF;;AiBtzBY;EAxDV,gBAAA;AjBk3BF;;AiB1zBY;EAxDV,iBAAA;AjBk3BF;;AiB1zBY;EAxDV,yBAAA;AjBs3BF;;AiB9zBY;EAxDV,0BAAA;AjBs3BF;;AiB9zBY;EAxDV,yBAAA;AjB03BF;;AiBl0BY;EAxDV,0BAAA;AjB03BF;;AiBl0BY;EAxDV,gBAAA;AjB83BF;;AiBt0BY;EAxDV,iBAAA;AjB83BF;;AiBt0BY;EAxDV,yBAAA;AjBk4BF;;AiB10BY;EAxDV,0BAAA;AjBk4BF;;AiB10BY;EAxDV,yBAAA;AjBs4BF;;AiB90BY;EAxDV,0BAAA;AjBs4BF;;AiBn0BQ;;EAEE,gBAAA;AjBs0BV;;AiBn0BQ;;EAEE,gBAAA;AjBs0BV;;AiB70BQ;;EAEE,sBAAA;AjBg1BV;;AiB70BQ;;EAEE,sBAAA;AjBg1BV;;AiBv1BQ;;EAEE,qBAAA;AjB01BV;;AiBv1BQ;;EAEE,qBAAA;AjB01BV;;AiBj2BQ;;EAEE,mBAAA;AjBo2BV;;AiBj2BQ;;EAEE,mBAAA;AjBo2BV;;AiB32BQ;;EAEE,qBAAA;AjB82BV;;AiB32BQ;;EAEE,qBAAA;AjB82BV;;AiBr3BQ;;EAEE,mBAAA;AjBw3BV;;AiBr3BQ;;EAEE,mBAAA;AjBw3BV;;Ael7BI;EEUE;IACE,YAAA;EjB46BN;;EiBz6BI;IApCJ,cAAA;IACA,WAAA;EjBg9BA;;EiBl8BA;IACE,cAAA;IACA,WAAA;EjBo8BF;;EiBt8BA;IACE,cAAA;IACA,UAAA;EjBw8BF;;EiB18BA;IACE,cAAA;IACA,mBAAA;EjB48BF;;EiB98BA;IACE,cAAA;IACA,UAAA;EjBg9BF;;EiBl9BA;IACE,cAAA;IACA,UAAA;EjBo9BF;;EiBt9BA;IACE,cAAA;IACA,mBAAA;EjBw9BF;;EiBz7BI;IAhDJ,cAAA;IACA,WAAA;EjB4+BA;;EiBv7BQ;IAhEN,cAAA;IACA,kBAAA;EjB0/BF;;EiB37BQ;IAhEN,cAAA;IACA,mBAAA;EjB8/BF;;EiB/7BQ;IAhEN,cAAA;IACA,UAAA;EjBkgCF;;EiBn8BQ;IAhEN,cAAA;IACA,mBAAA;EjBsgCF;;EiBv8BQ;IAhEN,cAAA;IACA,mBAAA;EjB0gCF;;EiB38BQ;IAhEN,cAAA;IACA,UAAA;EjB8gCF;;EiB/8BQ;IAhEN,cAAA;IACA,mBAAA;EjBkhCF;;EiBn9BQ;IAhEN,cAAA;IACA,mBAAA;EjBshCF;;EiBv9BQ;IAhEN,cAAA;IACA,UAAA;EjB0hCF;;EiB39BQ;IAhEN,cAAA;IACA,mBAAA;EjB8hCF;;EiB/9BQ;IAhEN,cAAA;IACA,mBAAA;EjBkiCF;;EiBn+BQ;IAhEN,cAAA;IACA,WAAA;EjBsiCF;;EiB/9BU;IAxDV,cAAA;EjB0hCA;;EiBl+BU;IAxDV,eAAA;EjB0hCA;;EiBl+BU;IAxDV,wBAAA;EjB6hCA;;EiBr+BU;IAxDV,yBAAA;EjB6hCA;;EiBr+BU;IAxDV,yBAAA;EjBgiCA;;EiBx+BU;IAxDV,0BAAA;EjBgiCA;;EiBx+BU;IAxDV,gBAAA;EjBmiCA;;EiB3+BU;IAxDV,iBAAA;EjBmiCA;;EiB3+BU;IAxDV,yBAAA;EjBsiCA;;EiB9+BU;IAxDV,0BAAA;EjBsiCA;;EiB9+BU;IAxDV,yBAAA;EjByiCA;;EiBj/BU;IAxDV,0BAAA;EjByiCA;;EiBj/BU;IAxDV,gBAAA;EjB4iCA;;EiBp/BU;IAxDV,iBAAA;EjB4iCA;;EiBp/BU;IAxDV,yBAAA;EjB+iCA;;EiBv/BU;IAxDV,0BAAA;EjB+iCA;;EiBv/BU;IAxDV,yBAAA;EjBkjCA;;EiB1/BU;IAxDV,0BAAA;EjBkjCA;;EiB1/BU;IAxDV,gBAAA;EjBqjCA;;EiB7/BU;IAxDV,iBAAA;EjBqjCA;;EiB7/BU;IAxDV,yBAAA;EjBwjCA;;EiBhgCU;IAxDV,0BAAA;EjBwjCA;;EiBhgCU;IAxDV,yBAAA;EjB2jCA;;EiBngCU;IAxDV,0BAAA;EjB2jCA;;EiBx/BM;;IAEE,gBAAA;EjB0/BR;;EiBv/BM;;IAEE,gBAAA;EjBy/BR;;EiBhgCM;;IAEE,sBAAA;EjBkgCR;;EiB//BM;;IAEE,sBAAA;EjBigCR;;EiBxgCM;;IAEE,qBAAA;EjB0gCR;;EiBvgCM;;IAEE,qBAAA;EjBygCR;;EiBhhCM;;IAEE,mBAAA;EjBkhCR;;EiB/gCM;;IAEE,mBAAA;EjBihCR;;EiBxhCM;;IAEE,qBAAA;EjB0hCR;;EiBvhCM;;IAEE,qBAAA;EjByhCR;;EiBhiCM;;IAEE,mBAAA;EjBkiCR;;EiB/hCM;;IAEE,mBAAA;EjBiiCR;AACF;;Ae5lCI;EEUE;IACE,YAAA;EjBqlCN;;EiBllCI;IApCJ,cAAA;IACA,WAAA;EjBynCA;;EiB3mCA;IACE,cAAA;IACA,WAAA;EjB6mCF;;EiB/mCA;IACE,cAAA;IACA,UAAA;EjBinCF;;EiBnnCA;IACE,cAAA;IACA,mBAAA;EjBqnCF;;EiBvnCA;IACE,cAAA;IACA,UAAA;EjBynCF;;EiB3nCA;IACE,cAAA;IACA,UAAA;EjB6nCF;;EiB/nCA;IACE,cAAA;IACA,mBAAA;EjBioCF;;EiBlmCI;IAhDJ,cAAA;IACA,WAAA;EjBqpCA;;EiBhmCQ;IAhEN,cAAA;IACA,kBAAA;EjBmqCF;;EiBpmCQ;IAhEN,cAAA;IACA,mBAAA;EjBuqCF;;EiBxmCQ;IAhEN,cAAA;IACA,UAAA;EjB2qCF;;EiB5mCQ;IAhEN,cAAA;IACA,mBAAA;EjB+qCF;;EiBhnCQ;IAhEN,cAAA;IACA,mBAAA;EjBmrCF;;EiBpnCQ;IAhEN,cAAA;IACA,UAAA;EjBurCF;;EiBxnCQ;IAhEN,cAAA;IACA,mBAAA;EjB2rCF;;EiB5nCQ;IAhEN,cAAA;IACA,mBAAA;EjB+rCF;;EiBhoCQ;IAhEN,cAAA;IACA,UAAA;EjBmsCF;;EiBpoCQ;IAhEN,cAAA;IACA,mBAAA;EjBusCF;;EiBxoCQ;IAhEN,cAAA;IACA,mBAAA;EjB2sCF;;EiB5oCQ;IAhEN,cAAA;IACA,WAAA;EjB+sCF;;EiBxoCU;IAxDV,cAAA;EjBmsCA;;EiB3oCU;IAxDV,eAAA;EjBmsCA;;EiB3oCU;IAxDV,wBAAA;EjBssCA;;EiB9oCU;IAxDV,yBAAA;EjBssCA;;EiB9oCU;IAxDV,yBAAA;EjBysCA;;EiBjpCU;IAxDV,0BAAA;EjBysCA;;EiBjpCU;IAxDV,gBAAA;EjB4sCA;;EiBppCU;IAxDV,iBAAA;EjB4sCA;;EiBppCU;IAxDV,yBAAA;EjB+sCA;;EiBvpCU;IAxDV,0BAAA;EjB+sCA;;EiBvpCU;IAxDV,yBAAA;EjBktCA;;EiB1pCU;IAxDV,0BAAA;EjBktCA;;EiB1pCU;IAxDV,gBAAA;EjBqtCA;;EiB7pCU;IAxDV,iBAAA;EjBqtCA;;EiB7pCU;IAxDV,yBAAA;EjBwtCA;;EiBhqCU;IAxDV,0BAAA;EjBwtCA;;EiBhqCU;IAxDV,yBAAA;EjB2tCA;;EiBnqCU;IAxDV,0BAAA;EjB2tCA;;EiBnqCU;IAxDV,gBAAA;EjB8tCA;;EiBtqCU;IAxDV,iBAAA;EjB8tCA;;EiBtqCU;IAxDV,yBAAA;EjBiuCA;;EiBzqCU;IAxDV,0BAAA;EjBiuCA;;EiBzqCU;IAxDV,yBAAA;EjBouCA;;EiB5qCU;IAxDV,0BAAA;EjBouCA;;EiBjqCM;;IAEE,gBAAA;EjBmqCR;;EiBhqCM;;IAEE,gBAAA;EjBkqCR;;EiBzqCM;;IAEE,sBAAA;EjB2qCR;;EiBxqCM;;IAEE,sBAAA;EjB0qCR;;EiBjrCM;;IAEE,qBAAA;EjBmrCR;;EiBhrCM;;IAEE,qBAAA;EjBkrCR;;EiBzrCM;;IAEE,mBAAA;EjB2rCR;;EiBxrCM;;IAEE,mBAAA;EjB0rCR;;EiBjsCM;;IAEE,qBAAA;EjBmsCR;;EiBhsCM;;IAEE,qBAAA;EjBksCR;;EiBzsCM;;IAEE,mBAAA;EjB2sCR;;EiBxsCM;;IAEE,mBAAA;EjB0sCR;AACF;;AerwCI;EEUE;IACE,YAAA;EjB8vCN;;EiB3vCI;IApCJ,cAAA;IACA,WAAA;EjBkyCA;;EiBpxCA;IACE,cAAA;IACA,WAAA;EjBsxCF;;EiBxxCA;IACE,cAAA;IACA,UAAA;EjB0xCF;;EiB5xCA;IACE,cAAA;IACA,mBAAA;EjB8xCF;;EiBhyCA;IACE,cAAA;IACA,UAAA;EjBkyCF;;EiBpyCA;IACE,cAAA;IACA,UAAA;EjBsyCF;;EiBxyCA;IACE,cAAA;IACA,mBAAA;EjB0yCF;;EiB3wCI;IAhDJ,cAAA;IACA,WAAA;EjB8zCA;;EiBzwCQ;IAhEN,cAAA;IACA,kBAAA;EjB40CF;;EiB7wCQ;IAhEN,cAAA;IACA,mBAAA;EjBg1CF;;EiBjxCQ;IAhEN,cAAA;IACA,UAAA;EjBo1CF;;EiBrxCQ;IAhEN,cAAA;IACA,mBAAA;EjBw1CF;;EiBzxCQ;IAhEN,cAAA;IACA,mBAAA;EjB41CF;;EiB7xCQ;IAhEN,cAAA;IACA,UAAA;EjBg2CF;;EiBjyCQ;IAhEN,cAAA;IACA,mBAAA;EjBo2CF;;EiBryCQ;IAhEN,cAAA;IACA,mBAAA;EjBw2CF;;EiBzyCQ;IAhEN,cAAA;IACA,UAAA;EjB42CF;;EiB7yCQ;IAhEN,cAAA;IACA,mBAAA;EjBg3CF;;EiBjzCQ;IAhEN,cAAA;IACA,mBAAA;EjBo3CF;;EiBrzCQ;IAhEN,cAAA;IACA,WAAA;EjBw3CF;;EiBjzCU;IAxDV,cAAA;EjB42CA;;EiBpzCU;IAxDV,eAAA;EjB42CA;;EiBpzCU;IAxDV,wBAAA;EjB+2CA;;EiBvzCU;IAxDV,yBAAA;EjB+2CA;;EiBvzCU;IAxDV,yBAAA;EjBk3CA;;EiB1zCU;IAxDV,0BAAA;EjBk3CA;;EiB1zCU;IAxDV,gBAAA;EjBq3CA;;EiB7zCU;IAxDV,iBAAA;EjBq3CA;;EiB7zCU;IAxDV,yBAAA;EjBw3CA;;EiBh0CU;IAxDV,0BAAA;EjBw3CA;;EiBh0CU;IAxDV,yBAAA;EjB23CA;;EiBn0CU;IAxDV,0BAAA;EjB23CA;;EiBn0CU;IAxDV,gBAAA;EjB83CA;;EiBt0CU;IAxDV,iBAAA;EjB83CA;;EiBt0CU;IAxDV,yBAAA;EjBi4CA;;EiBz0CU;IAxDV,0BAAA;EjBi4CA;;EiBz0CU;IAxDV,yBAAA;EjBo4CA;;EiB50CU;IAxDV,0BAAA;EjBo4CA;;EiB50CU;IAxDV,gBAAA;EjBu4CA;;EiB/0CU;IAxDV,iBAAA;EjBu4CA;;EiB/0CU;IAxDV,yBAAA;EjB04CA;;EiBl1CU;IAxDV,0BAAA;EjB04CA;;EiBl1CU;IAxDV,yBAAA;EjB64CA;;EiBr1CU;IAxDV,0BAAA;EjB64CA;;EiB10CM;;IAEE,gBAAA;EjB40CR;;EiBz0CM;;IAEE,gBAAA;EjB20CR;;EiBl1CM;;IAEE,sBAAA;EjBo1CR;;EiBj1CM;;IAEE,sBAAA;EjBm1CR;;EiB11CM;;IAEE,qBAAA;EjB41CR;;EiBz1CM;;IAEE,qBAAA;EjB21CR;;EiBl2CM;;IAEE,mBAAA;EjBo2CR;;EiBj2CM;;IAEE,mBAAA;EjBm2CR;;EiB12CM;;IAEE,qBAAA;EjB42CR;;EiBz2CM;;IAEE,qBAAA;EjB22CR;;EiBl3CM;;IAEE,mBAAA;EjBo3CR;;EiBj3CM;;IAEE,mBAAA;EjBm3CR;AACF;;Ae96CI;EEUE;IACE,YAAA;EjBu6CN;;EiBp6CI;IApCJ,cAAA;IACA,WAAA;EjB28CA;;EiB77CA;IACE,cAAA;IACA,WAAA;EjB+7CF;;EiBj8CA;IACE,cAAA;IACA,UAAA;EjBm8CF;;EiBr8CA;IACE,cAAA;IACA,mBAAA;EjBu8CF;;EiBz8CA;IACE,cAAA;IACA,UAAA;EjB28CF;;EiB78CA;IACE,cAAA;IACA,UAAA;EjB+8CF;;EiBj9CA;IACE,cAAA;IACA,mBAAA;EjBm9CF;;EiBp7CI;IAhDJ,cAAA;IACA,WAAA;EjBu+CA;;EiBl7CQ;IAhEN,cAAA;IACA,kBAAA;EjBq/CF;;EiBt7CQ;IAhEN,cAAA;IACA,mBAAA;EjBy/CF;;EiB17CQ;IAhEN,cAAA;IACA,UAAA;EjB6/CF;;EiB97CQ;IAhEN,cAAA;IACA,mBAAA;EjBigDF;;EiBl8CQ;IAhEN,cAAA;IACA,mBAAA;EjBqgDF;;EiBt8CQ;IAhEN,cAAA;IACA,UAAA;EjBygDF;;EiB18CQ;IAhEN,cAAA;IACA,mBAAA;EjB6gDF;;EiB98CQ;IAhEN,cAAA;IACA,mBAAA;EjBihDF;;EiBl9CQ;IAhEN,cAAA;IACA,UAAA;EjBqhDF;;EiBt9CQ;IAhEN,cAAA;IACA,mBAAA;EjByhDF;;EiB19CQ;IAhEN,cAAA;IACA,mBAAA;EjB6hDF;;EiB99CQ;IAhEN,cAAA;IACA,WAAA;EjBiiDF;;EiB19CU;IAxDV,cAAA;EjBqhDA;;EiB79CU;IAxDV,eAAA;EjBqhDA;;EiB79CU;IAxDV,wBAAA;EjBwhDA;;EiBh+CU;IAxDV,yBAAA;EjBwhDA;;EiBh+CU;IAxDV,yBAAA;EjB2hDA;;EiBn+CU;IAxDV,0BAAA;EjB2hDA;;EiBn+CU;IAxDV,gBAAA;EjB8hDA;;EiBt+CU;IAxDV,iBAAA;EjB8hDA;;EiBt+CU;IAxDV,yBAAA;EjBiiDA;;EiBz+CU;IAxDV,0BAAA;EjBiiDA;;EiBz+CU;IAxDV,yBAAA;EjBoiDA;;EiB5+CU;IAxDV,0BAAA;EjBoiDA;;EiB5+CU;IAxDV,gBAAA;EjBuiDA;;EiB/+CU;IAxDV,iBAAA;EjBuiDA;;EiB/+CU;IAxDV,yBAAA;EjB0iDA;;EiBl/CU;IAxDV,0BAAA;EjB0iDA;;EiBl/CU;IAxDV,yBAAA;EjB6iDA;;EiBr/CU;IAxDV,0BAAA;EjB6iDA;;EiBr/CU;IAxDV,gBAAA;EjBgjDA;;EiBx/CU;IAxDV,iBAAA;EjBgjDA;;EiBx/CU;IAxDV,yBAAA;EjBmjDA;;EiB3/CU;IAxDV,0BAAA;EjBmjDA;;EiB3/CU;IAxDV,yBAAA;EjBsjDA;;EiB9/CU;IAxDV,0BAAA;EjBsjDA;;EiBn/CM;;IAEE,gBAAA;EjBq/CR;;EiBl/CM;;IAEE,gBAAA;EjBo/CR;;EiB3/CM;;IAEE,sBAAA;EjB6/CR;;EiB1/CM;;IAEE,sBAAA;EjB4/CR;;EiBngDM;;IAEE,qBAAA;EjBqgDR;;EiBlgDM;;IAEE,qBAAA;EjBogDR;;EiB3gDM;;IAEE,mBAAA;EjB6gDR;;EiB1gDM;;IAEE,mBAAA;EjB4gDR;;EiBnhDM;;IAEE,qBAAA;EjBqhDR;;EiBlhDM;;IAEE,qBAAA;EjBohDR;;EiB3hDM;;IAEE,mBAAA;EjB6hDR;;EiB1hDM;;IAEE,mBAAA;EjB4hDR;AACF;;AevlDI;EEUE;IACE,YAAA;EjBglDN;;EiB7kDI;IApCJ,cAAA;IACA,WAAA;EjBonDA;;EiBtmDA;IACE,cAAA;IACA,WAAA;EjBwmDF;;EiB1mDA;IACE,cAAA;IACA,UAAA;EjB4mDF;;EiB9mDA;IACE,cAAA;IACA,mBAAA;EjBgnDF;;EiBlnDA;IACE,cAAA;IACA,UAAA;EjBonDF;;EiBtnDA;IACE,cAAA;IACA,UAAA;EjBwnDF;;EiB1nDA;IACE,cAAA;IACA,mBAAA;EjB4nDF;;EiB7lDI;IAhDJ,cAAA;IACA,WAAA;EjBgpDA;;EiB3lDQ;IAhEN,cAAA;IACA,kBAAA;EjB8pDF;;EiB/lDQ;IAhEN,cAAA;IACA,mBAAA;EjBkqDF;;EiBnmDQ;IAhEN,cAAA;IACA,UAAA;EjBsqDF;;EiBvmDQ;IAhEN,cAAA;IACA,mBAAA;EjB0qDF;;EiB3mDQ;IAhEN,cAAA;IACA,mBAAA;EjB8qDF;;EiB/mDQ;IAhEN,cAAA;IACA,UAAA;EjBkrDF;;EiBnnDQ;IAhEN,cAAA;IACA,mBAAA;EjBsrDF;;EiBvnDQ;IAhEN,cAAA;IACA,mBAAA;EjB0rDF;;EiB3nDQ;IAhEN,cAAA;IACA,UAAA;EjB8rDF;;EiB/nDQ;IAhEN,cAAA;IACA,mBAAA;EjBksDF;;EiBnoDQ;IAhEN,cAAA;IACA,mBAAA;EjBssDF;;EiBvoDQ;IAhEN,cAAA;IACA,WAAA;EjB0sDF;;EiBnoDU;IAxDV,cAAA;EjB8rDA;;EiBtoDU;IAxDV,eAAA;EjB8rDA;;EiBtoDU;IAxDV,wBAAA;EjBisDA;;EiBzoDU;IAxDV,yBAAA;EjBisDA;;EiBzoDU;IAxDV,yBAAA;EjBosDA;;EiB5oDU;IAxDV,0BAAA;EjBosDA;;EiB5oDU;IAxDV,gBAAA;EjBusDA;;EiB/oDU;IAxDV,iBAAA;EjBusDA;;EiB/oDU;IAxDV,yBAAA;EjB0sDA;;EiBlpDU;IAxDV,0BAAA;EjB0sDA;;EiBlpDU;IAxDV,yBAAA;EjB6sDA;;EiBrpDU;IAxDV,0BAAA;EjB6sDA;;EiBrpDU;IAxDV,gBAAA;EjBgtDA;;EiBxpDU;IAxDV,iBAAA;EjBgtDA;;EiBxpDU;IAxDV,yBAAA;EjBmtDA;;EiB3pDU;IAxDV,0BAAA;EjBmtDA;;EiB3pDU;IAxDV,yBAAA;EjBstDA;;EiB9pDU;IAxDV,0BAAA;EjBstDA;;EiB9pDU;IAxDV,gBAAA;EjBytDA;;EiBjqDU;IAxDV,iBAAA;EjBytDA;;EiBjqDU;IAxDV,yBAAA;EjB4tDA;;EiBpqDU;IAxDV,0BAAA;EjB4tDA;;EiBpqDU;IAxDV,yBAAA;EjB+tDA;;EiBvqDU;IAxDV,0BAAA;EjB+tDA;;EiB5pDM;;IAEE,gBAAA;EjB8pDR;;EiB3pDM;;IAEE,gBAAA;EjB6pDR;;EiBpqDM;;IAEE,sBAAA;EjBsqDR;;EiBnqDM;;IAEE,sBAAA;EjBqqDR;;EiB5qDM;;IAEE,qBAAA;EjB8qDR;;EiB3qDM;;IAEE,qBAAA;EjB6qDR;;EiBprDM;;IAEE,mBAAA;EjBsrDR;;EiBnrDM;;IAEE,mBAAA;EjBqrDR;;EiB5rDM;;IAEE,qBAAA;EjB8rDR;;EiB3rDM;;IAEE,qBAAA;EjB6rDR;;EiBpsDM;;IAEE,mBAAA;EjBssDR;;EiBnsDM;;IAEE,mBAAA;EjBqsDR;AACF;;AkB3zDA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AlB0zDF;;AkBnzDE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;AlBozDJ;;AkBjzDE;EACE,uBAAA;AlBmzDJ;;AkBhzDE;EACE,sBAAA;AlBkzDJ;;AkB9yDA;EACE,+DAAA;AlBizDF;;AkB1yDA;EACE,iBAAA;AlB6yDF;;AkBnyDE;EACE,wBAAA;AlBsyDJ;;AkBvxDE;EACE,sCAAA;AlB0xDJ;;AkBvxDI;EACE,sCAAA;AlByxDN;;AkBlxDE;EACE,sBAAA;AlBqxDJ;;AkBlxDE;EACE,mBAAA;AlBoxDJ;;AkB1wDE;EACE,oDAAA;EACA,8CAAA;AlB6wDJ;;AkBvwDE;EACE,oDAAA;EACA,8CAAA;AlB0wDJ;;AkBlwDA;EACE,oDAAA;EACA,8CAAA;AlBqwDF;;AkB7vDE;EACE,mDAAA;EACA,6CAAA;AlBgwDJ;;AmB54DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBw4DJ;;AmB15DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBs5DJ;;AmBx6DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBo6DJ;;AmBt7DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBk7DJ;;AmBp8DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBg8DJ;;AmBl9DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB88DJ;;AmBh+DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB49DJ;;AmB9+DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB0+DJ;;AkBz1DI;EACE,gBAAA;EACA,iCAAA;AlB41DN;;Aev7DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElBk2DJ;AACF;;Ae97DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElBw2DJ;AACF;;Aep8DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElB82DJ;AACF;;Ae18DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElBo3DJ;AACF;;Aeh9DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElB03DJ;AACF;;AoB9hEA;EACE,qBbu2BsC;APyrCxC;;AoBvhEA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;APy7C9B;;AoBphEA;EACE,kDAAA;EACA,qDAAA;EhBoQI,kBALI;AJyxDV;;AoBphEA;EACE,mDAAA;EACA,sDAAA;EhB8PI,mBALI;AJ+xDV;;AqBrjEA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,gCd+1BsC;APutCxC;;AsB3jEA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,2Bf43BsC;Ee33BtC,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,sCAAA;EeHE,wEDMJ;AtByjEF;;AuB3jEM;EDhBN;ICiBQ,gBAAA;EvB8jEN;AACF;;AsB5jEE;EACE,gBAAA;AtB8jEJ;;AsB5jEI;EACE,eAAA;AtB8jEN;;AsBzjEE;EACE,2Bfs2BoC;Eer2BpC,mCfg2BoC;Ee/1BpC,qBf82BoC;Ee72BpC,UAAA;EAKE,kDfkhBkB;APqiDxB;;AsBnjEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AtBuiEJ;;AsBliEE;EACE,cAAA;EACA,UAAA;AtBoiEJ;;AsBhiEE;EACE,gCf40BoC;Ee10BpC,UAAA;AtBiiEJ;;AsBpiEE;EACE,gCf40BoC;Ee10BpC,UAAA;AtBiiEJ;;AsBzhEE;EAEE,wCf8yBoC;Ee3yBpC,UAAA;AtBwhEJ;;AsBphEE;EACE,yBAAA;EACA,0BAAA;EACA,0BforB0B;EenrB1B,2BfsyBoC;EiBp4BtC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;AtBshEJ;;AuB5mEM;ED0EJ;ICzEM,gBAAA;EvB+mEN;AACF;;AsBxhEE;EACE,wCf47B8B;AP8lClC;;AsBjhEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;AtBohEF;;AsBlhEE;EACE,UAAA;AtBohEJ;;AsBjhEE;EAEE,gBAAA;EACA,eAAA;AtBkhEJ;;AsBvgEA;EACE,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,yCAAA;AR+oEJ;;AsBxgEE;EACE,uBAAA;EACA,wBAAA;EACA,yBfooB0B;APs4C9B;;AsBtgEA;EACE,iEfgwBsC;Ee/vBtC,oBAAA;ElB4HI,kBALI;EIvQN,yCAAA;AR2pEJ;;AsBvgEE;EACE,oBAAA;EACA,qBAAA;EACA,uBf2nB0B;AP84C9B;;AsBjgEE;EACE,oEf6uBoC;APuxCxC;;AsBjgEE;EACE,mEf0uBoC;APyxCxC;;AsBhgEE;EACE,iEfuuBoC;AP2xCxC;;AsB7/DA;EACE,WfquBsC;EepuBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;AP+6C9B;;AsB9/DE;EACE,eAAA;AtBggEJ;;AsB7/DE;EACE,oBAAA;EdvLA,sCAAA;ARurEJ;;AsB5/DE;EACE,oBAAA;Ed5LA,sCAAA;AR2rEJ;;AsB3/DE;EAAoB,+Df8sBkB;APgzCxC;;AsB7/DE;EAAoB,6Df8sBkB;APkzCxC;;AyB/sEA;EACE,wPAAA;EAEA,cAAA;EACA,WAAA;ErBsRI,eALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,2BlBy3BsC;EkBx3BtC,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EAEA,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,sCAAA;EeHE,wEESJ;AzB+sEF;;AyBnuEA;EAKE,0CAAA;EAUA,yClB+9BkC;APqvCpC;;AyBnuEA;EAKE,0CAAA;EAUA,wClB+9BkC;APqvCpC;;AuBptEM;EEfN;IFgBQ,gBAAA;EvButEN;AACF;;AyBltEE;EACE,qBlBs3BoC;EkBr3BpC,UAAA;EAKE,kDlBi+B4B;AP+uClC;;AyB5sEE;EAGE,sBAAA;AzB6sEJ;;AyBhtEE;EAEE,sBlB6uB0B;APi+C9B;;AyBhtEE;EAEE,qBlB6uB0B;APi+C9B;;AyB1sEE;EAEE,wClBu1BoC;APo3CxC;;AyBtsEE;EACE,kBAAA;EACA,uCAAA;AzBwsEJ;;AyBpsEA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EHjgBxB,mBALI;EIvQN,yCAAA;ARkvEJ;;AyB5sEA;EAGE,oBlBquB4B;APo+C9B;;AyB5sEA;EAGE,qBlBquB4B;APo+C9B;;AyBpsEA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EHrgBxB,kBALI;EIvQN,yCAAA;AR0vEJ;;AyB5sEA;EAGE,kBlBiuB4B;APw+C9B;;AyB5sEA;EAGE,mBlBiuB4B;APw+C9B;;AyBlsEI;EACE,wPAAA;AzBqsEN;;A0B7wEA;EACE,cAAA;EACA,kBnBq6BwC;EmBn6BxC,uBnBq6BwC;AP22C1C;;A0BpxEA;EAGE,mBnBq6BwC;AP42C1C;;A0BpxEA;EAGE,oBnBq6BwC;AP42C1C;;A0B9wEE;EACE,WAAA;EACA,mBAAA;A1BgxEJ;;A0BlxEE;EACE,YAAA;EACA,oBAAA;A1BgxEJ;;A0B5wEA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;A1B+wEF;;A0BlxEA;EACE,mBnB25BwC;EmB15BxC,gBAAA;EACA,gBAAA;A1B+wEF;;A0B7wEE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A1B+wEJ;;A0BlxEE;EACE,WAAA;EACA,mBAAA;EACA,eAAA;A1B+wEJ;;A0B3wEA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,iCAAA;UAAA,yBAAA;A1B6wEF;;A0B1wEE;ElB3BE,qBAAA;ARwyEJ;;A0BzwEE;EAEE,kBnBm4BsC;APu4C1C;;A0BvwEE;EACE,uBnB03BsC;AP+4C1C;;A0BtwEE;EACE,qBnBs1BoC;EmBr1BpC,UAAA;EACA,kDnB8foB;AP0wDxB;;A0BrwEE;EACE,yBnB5BM;EmB6BN,qBnB7BM;APoyEV;;A0BrwEI;EAII,uPAAA;A1BowER;;A0BhwEI;EAII,+JAAA;A1B+vER;;A0B1vEE;EACE,yBnBjDM;EmBkDN,qBnBlDM;EmBuDJ,iPAAA;A1BwvEN;;A0BpvEE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;APo5C3C;;A0B/uEI;EACE,eAAA;EACA,YnBy1BqC;APw5C3C;;A0BnuEA;EACE,mBnBo1BgC;APk5ClC;;A0BvuEA;EACE,oBnBo1BgC;APk5ClC;;A0BpuEE;EACE,2KAAA;EAEA,UnB80B8B;EmB50B9B,0CAAA;ElBhHA,kBAAA;EeHE,iDGsHF;A1BquEJ;;A0B7uEE;EAIE,mBAAA;EAEA,gCAAA;A1BuuEJ;;A0B7uEE;EAIE,oBAAA;EAEA,iCAAA;A1BuuEJ;;AuBv1EM;EG0GJ;IHzGM,gBAAA;EvB01EN;AACF;;A0BxuEI;EACE,6JAAA;A1B0uEN;;A0BvuEI;EAMI,0JAAA;A1BquER;;A0B3uEI;EACE,iCnB60B4B;AP65ClC;;A0B3uEI;EACE,gCnB60B4B;AP65ClC;;A0BhuEE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;A1BkuEJ;;A0BpuEE;EACE,mBnBwzB8B;EmBvzB9B,gBAAA;A1BkuEJ;;A0BhuEI;EACE,oBAAA;EACA,cAAA;A1BkuEN;;A0BpuEI;EACE,mBAAA;EACA,eAAA;A1BkuEN;;A0B7tEA;EACE,qBAAA;A1BiuEF;;A0BluEA;EAEE,kBnBsyBgC;AP07ClC;;A0BluEA;EAEE,iBnBsyBgC;AP07ClC;;A0B7tEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A1BguEF;;A0B5tEI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;APwkD9B;;A0BvtEI;EACE,iLAAA;A1B0tEN;;A2B74EA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,6BAAA;A3Bg5EF;;A2B94EE;EACE,UAAA;A3Bg5EJ;;A2B54EI;EAA0B,qEpB8gCa;APi4C3C;;A2B94EI;EAA0B,qEpB6gCa;APo4C3C;;A2B94EE;EACE,SAAA;A3Bg5EJ;;A2B74EE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,wBAAA;UAAA,gBAAA;EH1BF,yBjBkCQ;EoBNN,SpB6/BuC;EC1gCvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A3B84EJ;;AuB75EM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EvBg6EN;AACF;;A2Bj5EI;EHjCF,yBjB8hCyC;APu5C3C;;A2B/4EE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;AR+6EJ;;A2B74EE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,qBAAA;OAAA,gBAAA;EHpDF,yBjBkCQ;EoBoBN,SpBm+BuC;EC1gCvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A3B84EJ;;AuBv7EM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EvB07EN;AACF;;A2Bj5EI;EH3DF,yBjB8hCyC;APi7C3C;;A2B/4EE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;ARy8EJ;;A2B74EE;EACE,oBAAA;A3B+4EJ;;A2B74EI;EACE,2CpBg9BqC;AP+7C3C;;A2B54EI;EACE,2CpB48BqC;APk8C3C;;A4Br+EA;EACE,kBAAA;A5Bw+EF;;A4Bt+EE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;APi8CxC;;A4Br+EE;EACE,kBAAA;EACA,MAAA;EAEA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;ELPE,gEKSF;A5Bu+EJ;;A4Br/EE;EAGE,OAAA;EAUA,qBAAA;A5Bw+EJ;;A4Br/EE;EAGE,QAAA;EAUA,wBAAA;A5Bw+EJ;;AuB5+EM;EKTJ;ILUM,gBAAA;EvB++EN;AACF;;A4Bz+EE;;EAEE,qBAAA;A5B2+EJ;;A4Bz+EI;EACE,kBAAA;A5B4+EN;;A4B7+EI;;EACE,kBAAA;A5B4+EN;;A4Bz+EI;EAEE,qBrB4gCkC;EqB3gClC,wBrB4gCkC;APg+CxC;;A4B/+EI;;;EAEE,qBrB4gCkC;EqB3gClC,wBrB4gCkC;APg+CxC;;A4Bz+EI;;EACE,qBrBugCkC;EqBtgClC,wBrBugCkC;APq+CxC;;A4Bx+EE;EACE,qBrBigCoC;EqBhgCpC,wBrBigCoC;APy+CxC;;A4Bn+EI;EACE,2CAAA;A5By+EN;;A4B1+EI;;;;EACE,2CAAA;A5By+EN;;A4B1+EI;EAEE,8DrB2/BkC;AP6+CxC;;A4B1+EI;;;;EAEE,8DrB2/BkC;AP6+CxC;;A4B1+EI;EAEE,+DrB2/BkC;AP6+CxC;;A4B1+EI;;;;EAEE,+DrB2/BkC;AP6+CxC;;A4Bt+EM;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBm/BgC;EqBl/BhC,WAAA;EACA,mCrBg0BgC;ECh3BpC,sCAAA;AR4hFJ;;A4Bl/EM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBm/BgC;EqBl/BhC,WAAA;EACA,mCrBg0BgC;ECh3BpC,sCAAA;AR4hFJ;;A4Br+EI;EACE,2CAAA;A5Bw+EN;;A4Bz+EI;EAEE,8DrB0+BkC;AP6/CxC;;A4Bz+EI;EAEE,+DrB0+BkC;AP6/CxC;;A4Bl+EI;EACE,sCAAA;A5Bo+EN;;A4Bh+EE;;EAEE,crB1EO;AP4iFX;;A4Bh+EI;;EACE,wCrB0yBkC;APyrDxC;;A6B1jFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A7B6jFF;;A6B3jFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A7B6jFJ;;A6BzjFE;;;EAGE,UAAA;A7B2jFJ;;A6BrjFE;EACE,kBAAA;EACA,UAAA;A7BujFJ;;A6BrjFI;EACE,UAAA;A7BujFN;;A6B5iFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,eALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,sCAAA;ARslFJ;;A6BtiFA;;;;EAIE,oBAAA;EzBwNI,kBALI;EIvQN,yCAAA;AR+lFJ;;A6BtiFA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,yCAAA;ARwmFJ;;A6BtiFA;;EAEE,mBAAA;A7ByiFF;;A6B3iFA;;EAEE,kBAAA;A7ByiFF;;A6B5hFI;;;;ErBjEA,0BAAA;EACA,6BAAA;ARomFJ;;A6BpiFI;;;;ErBjEA,yBAAA;EACA,4BAAA;ARomFJ;;A6B3hFI;;;;ErB1EA,0BAAA;EACA,6BAAA;AR2mFJ;;A6BliFI;;;;ErB1EA,yBAAA;EACA,4BAAA;AR2mFJ;;A6BrhFE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;ARkmFJ;;A6B1hFE;EACE,+CAAA;ErB1EA,0BAAA;EACA,6BAAA;ARkmFJ;;A6BrhFE;;ErB9EE,yBAAA;EACA,4BAAA;ARumFJ;;A6B1hFE;;ErB9EE,0BAAA;EACA,6BAAA;ARumFJ;;A8B/nFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,iCvBkjCqB;AP+kDzB;;A8B9nFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;AR4pFJ;;A8B5nFI;;;;EAEE,cAAA;A9BioFN;;A8BhrFI;EAqDE,+CvBuhCmB;EuBnhCjB,2PAAA;EACA,4BAAA;EAEA,gEAAA;A9B6nFR;;A8BzrFI;EAwDI,oCvB81BgC;EuB31BhC,2DAAA;A9B8nFR;;A8BzrFI;EAwDI,mCvB81BgC;EuB31BhC,0DAAA;A9B8nFR;;A8B1nFM;EACE,+CvB4gCiB;EuBvgCf,2DvBugCe;APinDzB;;A8B7rFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A9BknFR;;A8BlsFI;EA+EI,mCvBu0BgC;EuBt0BhC,iFAAA;A9BknFR;;A8BlsFI;EAuFE,+CvBq/BmB;AP0nDzB;;A8B5mFQ;EAEE,mQAAA;EAGA,2EAAA;A9B6mFV;;A8BlnFQ;EAGE,uBvBq5B8B;EuBp5B9B,+DAAA;A9B8mFV;;A8BlnFQ;EAGE,sBvBq5B8B;EuBp5B9B,6DAAA;A9B8mFV;;A8BzmFM;EACE,+CvBw+BiB;EuBn+Bf,2DvBm+Be;APooDzB;;A8BhtFI;EAkHI,yCAAA;A9BkmFR;;A8BptFI;EAyHE,+CvBm9BmB;AP4oDzB;;A8B7lFM;EACE,4CvBg9BiB;AP+oDzB;;A8B5lFM;EACE,2DvB48BiB;APkpDzB;;A8B3lFM;EACE,iCvBw8BiB;APqpDzB;;A8BxlFI;EACE,kBAAA;A9B2lFN;;A8B5lFI;EACE,mBAAA;A9B2lFN;;A8BruFI;;;;;EAoJM,UAAA;A9BylFV;;A8BztFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,mCvBkjCqB;APyqDzB;;A8BxtFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;ARsvFJ;;A8BttFI;;;;EAEE,cAAA;A9B2tFN;;A8B1wFI;EAqDE,iDvBuhCmB;EuBnhCjB,4UAAA;EACA,4BAAA;EAEA,gEAAA;A9ButFR;;A8BnxFI;EAwDI,oCvB81BgC;EuB31BhC,2DAAA;A9BwtFR;;A8BnxFI;EAwDI,mCvB81BgC;EuB31BhC,0DAAA;A9BwtFR;;A8BptFM;EACE,iDvB4gCiB;EuBvgCf,0DvBugCe;AP2sDzB;;A8BvxFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A9B4sFR;;A8B5xFI;EA+EI,mCvBu0BgC;EuBt0BhC,iFAAA;A9B4sFR;;A8B5xFI;EAuFE,iDvBq/BmB;APotDzB;;A8BtsFQ;EAEE,oVAAA;EAGA,2EAAA;A9BusFV;;A8B5sFQ;EAGE,uBvBq5B8B;EuBp5B9B,+DAAA;A9BwsFV;;A8B5sFQ;EAGE,sBvBq5B8B;EuBp5B9B,6DAAA;A9BwsFV;;A8BnsFM;EACE,iDvBw+BiB;EuBn+Bf,0DvBm+Be;AP8tDzB;;A8B1yFI;EAkHI,yCAAA;A9B4rFR;;A8B9yFI;EAyHE,iDvBm9BmB;APsuDzB;;A8BvrFM;EACE,8CvBg9BiB;APyuDzB;;A8BtrFM;EACE,0DvB48BiB;AP4uDzB;;A8BrrFM;EACE,mCvBw8BiB;AP+uDzB;;A8BlrFI;EACE,kBAAA;A9BqrFN;;A8BtrFI;EACE,mBAAA;A9BqrFN;;A8B/zFI;;;;;EAsJM,UAAA;A9BirFV;;A+Bz0FA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,wBALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A/Bu0FF;;AuB31FM;EQhBN;IRiBQ,gBAAA;EvB81FN;AACF;;A+B10FE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A/B20FJ;;A+Bx0FE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A/By0FJ;;A+Bt0FE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A/Bo0FN;;A+Bh0FE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A/B8zFN;;A+B1zFE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A/BszFJ;;A+BnzFI;EAKI,0CAAA;A/BizFR;;A+B5yFE;EAKI,0CAAA;A/B0yFN;;A+BtyFE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A/BqyFJ;;A+BzxFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC44FF;;A+B1yFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC65FF;;A+B3zFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC86FF;;A+B50FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC+7FF;;A+B71FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCg9FF;;A+B92FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCi+FF;;A+B/3FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCk/FF;;A+Bh5FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCmgGF;;A+Bv4FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC2/FF;;A+Bx5FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC4gGF;;A+Bz6FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC6hGF;;A+B17FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC8iGF;;A+B38FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC+jGF;;A+B59FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCglGF;;A+B7+FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCimGF;;A+B9/FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCknGF;;A+BngGA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxB8QwC;APuvF1C;;A+B3/FE;EACE,0BAAA;A/B6/FJ;;A+B1/FE;EACE,gCAAA;A/B4/FJ;;A+Bj/FA;ECjJE,0BAAA;EACA,wBAAA;E5B8NI,2BALI;E4BvNR,kDAAA;AhCsoGF;;A+Bp/FA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;AhC6oGF;;AiChtGA;EVgBM,gCUfJ;AjCmtGF;;AuBhsGM;EUpBN;IVqBQ,gBAAA;EvBmsGN;AACF;;AiCttGE;EACE,UAAA;AjCwtGJ;;AiCltGE;EACE,aAAA;AjCqtGJ;;AiCjtGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AjCotGF;;AuBltGM;EULN;IVMQ,gBAAA;EvBqtGN;AACF;;AiCvtGE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AjCytGJ;;AuB5tGM;EUAJ;IVCM,gBAAA;EvB+tGN;AACF;;AkCpvGA;;;;;;EAME,kBAAA;AlCuvGF;;AkCpvGA;EACE,mBAAA;AlCuvGF;;AmC/tGI;EACE,qBAAA;EAEA,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AnCuwGF;;AmCzuGI;EAEE,oB5B6hBwB;AP0sF9B;;AmCzuGI;EAEE,qB5B6hBwB;AP0sF9B;;AmC7sGI;EACE,cAAA;AnC+sGN;;AmChtGI;EACE,eAAA;AnC+sGN;;AkC7vGA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,6BALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EAEA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;ARuyGJ;;AkCxyGA;EAsCE,gBAAA;AlCkwGF;;AkCxyGA;EAsCE,iBAAA;AlCkwGF;;AkC1vGE;EACE,SAAA;EAEA,qCAAA;AlC4vGJ;;AkC/vGE;EAEE,OAAA;AlC6vGJ;;AkC/vGE;EAEE,QAAA;AlC6vGJ;;AkCpuGI;EACE,oBAAA;AlCuuGN;;AkCruGM;EACE,WAAA;EACA,OAAA;AlCuuGR;;AkCzuGM;EACE,UAAA;EACA,QAAA;AlCuuGR;;AkCnuGI;EACE,kBAAA;AlCsuGN;;AkCpuGM;EACE,QAAA;EACA,UAAA;AlCsuGR;;AkCxuGM;EACE,OAAA;EACA,WAAA;AlCsuGR;;AehxGI;EmB4BA;IACE,oBAAA;ElCwvGJ;;EkCtvGI;IACE,WAAA;IACA,OAAA;ElCwvGN;;EkC1vGI;IACE,UAAA;IACA,QAAA;ElCwvGN;;EkCpvGE;IACE,kBAAA;ElCsvGJ;;EkCpvGI;IACE,QAAA;IACA,UAAA;ElCsvGN;;EkCxvGI;IACE,OAAA;IACA,WAAA;ElCsvGN;AACF;;AejyGI;EmB4BA;IACE,oBAAA;ElCwwGJ;;EkCtwGI;IACE,WAAA;IACA,OAAA;ElCwwGN;;EkC1wGI;IACE,UAAA;IACA,QAAA;ElCwwGN;;EkCpwGE;IACE,kBAAA;ElCswGJ;;EkCpwGI;IACE,QAAA;IACA,UAAA;ElCswGN;;EkCxwGI;IACE,OAAA;IACA,WAAA;ElCswGN;AACF;;AejzGI;EmB4BA;IACE,oBAAA;ElCwxGJ;;EkCtxGI;IACE,WAAA;IACA,OAAA;ElCwxGN;;EkC1xGI;IACE,UAAA;IACA,QAAA;ElCwxGN;;EkCpxGE;IACE,kBAAA;ElCsxGJ;;EkCpxGI;IACE,QAAA;IACA,UAAA;ElCsxGN;;EkCxxGI;IACE,OAAA;IACA,WAAA;ElCsxGN;AACF;;Aej0GI;EmB4BA;IACE,oBAAA;ElCwyGJ;;EkCtyGI;IACE,WAAA;IACA,OAAA;ElCwyGN;;EkC1yGI;IACE,UAAA;IACA,QAAA;ElCwyGN;;EkCpyGE;IACE,kBAAA;ElCsyGJ;;EkCpyGI;IACE,QAAA;IACA,UAAA;ElCsyGN;;EkCxyGI;IACE,OAAA;IACA,WAAA;ElCsyGN;AACF;;Aej1GI;EmB4BA;IACE,oBAAA;ElCwzGJ;;EkCtzGI;IACE,WAAA;IACA,OAAA;ElCwzGN;;EkC1zGI;IACE,UAAA;IACA,QAAA;ElCwzGN;;EkCpzGE;IACE,kBAAA;ElCszGJ;;EkCpzGI;IACE,QAAA;IACA,UAAA;ElCszGN;;EkCxzGI;IACE,OAAA;IACA,WAAA;ElCszGN;AACF;;AkC7yGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AlC+yGJ;;AmCn4GI;EACE,qBAAA;EAEA,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AnCo6GF;;AmC74GI;EAEE,oB5B6hBwB;AP82F9B;;AmC74GI;EAEE,qB5B6hBwB;AP82F9B;;AmCj3GI;EACE,cAAA;AnCm3GN;;AmCp3GI;EACE,eAAA;AnCm3GN;;AkCnzGE;EACE,MAAA;EAGA,aAAA;AlCuzGJ;;AkC3zGE;EAEE,WAAA;EACA,UAAA;EAEA,sCAAA;AlCszGJ;;AkC3zGE;EAEE,UAAA;EACA,WAAA;EAEA,uCAAA;AlCszGJ;;AmCx5GI;EACE,qBAAA;EAEA,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EAEA,sCAAA;AnCm7GF;;AmCl6GI;EAEE,oB5B6hBwB;E4BjjB5B,eAAA;EAEA,wBAAA;AnCk7GF;;AmCl6GI;EAEE,qB5B6hBwB;E4BjjB5B,cAAA;EAEA,yBAAA;AnCk7GF;;AmCt4GI;EACE,cAAA;AnCw4GN;;AmCz4GI;EACE,eAAA;AnCw4GN;;AkC9zGI;EACE,iBAAA;AlCg0GN;;AkC1zGE;EACE,MAAA;EAGA,aAAA;AlC8zGJ;;AkCl0GE;EAEE,WAAA;EACA,UAAA;EAEA,uCAAA;AlC6zGJ;;AkCl0GE;EAEE,UAAA;EACA,WAAA;EAEA,sCAAA;AlC6zGJ;;AmCh7GI;EACE,qBAAA;EAEA,uB5B2hBwB;E4B1hBxB,WAAA;AnCk7GN;;AmCt7GI;EAEE,oB5B6hBwB;APu5F9B;;AmCt7GI;EAEE,qB5B6hBwB;APu5F9B;;AmCv6GM;EACE,aAAA;AnCy6GR;;AmCt6GM;EACE,qBAAA;EAEA,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EAEA,sCAAA;AnC48GF;;AmC/6GM;EAEE,qB5B0gBsB;E4B1iB5B,yBAAA;AnC68GF;;AmC/6GM;EAEE,oB5B0gBsB;E4B1iB5B,wBAAA;AnC68GF;;AmCt6GI;EACE,cAAA;AnCw6GN;;AmCz6GI;EACE,eAAA;AnCw6GN;;AkC70GI;EACE,iBAAA;AlC+0GN;;AkCx0GA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AlC20GF;;AkCr0GA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;AR++GJ;;AkCt0GE;EAEE,0CAAA;EV1LF,kDU4LuB;AlCs0GzB;;AkCn0GE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AlCo0GzB;;AkCj0GE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AlCk0GJ;;AkC5zGA;EACE,cAAA;AlC+zGF;;AkC3zGA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;AlC8zGF;;AkC1zGA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AlC6zGF;;AkCzzGA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AlC2zGF;;AoCjjHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ApCojHF;;AoCljHE;;EACE,kBAAA;EACA,cAAA;ApCqjHJ;;AoChjHE;;;;;;;;;;;;EAME,UAAA;ApCwjHJ;;AoCnjHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ApCsjHF;;AoCpjHE;EACE,WAAA;ApCsjHJ;;AoCljHA;E5BhBI,sCAAA;ARskHJ;;AoCljHE;;EAEE,8CAAA;ApCojHJ;;AoCtjHE;;EAEE,+CAAA;ApCojHJ;;AoChjHE;;;E5BVE,0BAAA;EACA,6BAAA;AR+jHJ;;AoCtjHE;;;E5BVE,yBAAA;EACA,4BAAA;AR+jHJ;;AoC5iHE;;;E5BNE,yBAAA;EACA,4BAAA;ARujHJ;;AoCljHE;;;E5BNE,0BAAA;EACA,6BAAA;ARujHJ;;AoC/hHA;EACE,wBAAA;EACA,uBAAA;ApCkiHF;;AoChiHE;EAGE,cAAA;ApCgiHJ;;AoCniHE;EAGE,eAAA;ApCgiHJ;;AoC7hHE;EACE,eAAA;ApC+hHJ;;AoChiHE;EACE,cAAA;ApC+hHJ;;AoC3hHA;EACE,uBAAA;EACA,sBAAA;ApC8hHF;;AoC3hHA;EACE,sBAAA;EACA,qBAAA;ApC8hHF;;AoC1gHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ApC6gHF;;AoC3gHE;;EAEE,WAAA;ApC6gHJ;;AoC1gHE;;EAEE,6CAAA;ApC4gHJ;;AoCxgHE;;E5B1FE,6BAAA;EACA,4BAAA;ARsmHJ;;AoCxgHE;;E5B7GE,yBAAA;EACA,0BAAA;ARynHJ;;AqCjpHA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EAEA,gBAAA;EACA,gBAAA;ArCgpHF;;AqC/pHA;EAaE,eAAA;ArCkpHF;;AqC/pHA;EAaE,gBAAA;ArCkpHF;;AqC7oHA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ArCgpHF;;AuB5pHM;EcGN;IdFQ,gBAAA;EvB+pHN;AACF;;AqCnpHE;EAEE,qCAAA;ArCopHJ;;AqChpHE;EACE,UAAA;EACA,kD9BkhBoB;APgoGxB;;AqC9oHE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ArC+oHJ;;AqCvoHA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ArCuoHF;;AqCroHE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;ARqrHJ;;AqCtoHI;EAGE,kBAAA;EACA,wDAAA;ArCsoHN;;AqCloHE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ArCooHJ;;AqCjoHE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;ARosHJ;;AqCznHA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ArC2nHF;;AqCxnHE;E7B5FE,gDAAA;ARutHJ;;AqCvnHE;;EAEE,4CAAA;EbjHF,oDakHuB;ArCynHzB;;AqChnHA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ArCgnHF;;AqC9mHE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ArCgnHJ;;AqC9mHI;EAEE,iCAAA;ArC+mHN;;AqC3mHE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;ArC6mHJ;;AqCnmHE;;EAEE,cAAA;EACA,kBAAA;ArCsmHJ;;AqCjmHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;ArComHJ;;AqC9lHE;;EACE,WAAA;ArCkmHJ;;AqCxlHE;EACE,aAAA;ArC2lHJ;;AqCzlHE;EACE,cAAA;ArC2lHJ;;AsCxxHA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,2QAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AtCwxHF;;AsClxHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AtC0xHJ;;AsCtwHA;EACE,6CAAA;EACA,gDAAA;ElC6NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;AtCwwHF;;AsC/wHA;EAGE,+CAAA;AtC4wHF;;AsC/wHA;EAGE,8CAAA;AtC4wHF;;AsCtwHE;EAEE,yCAAA;AtCuwHJ;;AsC7vHA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EAEA,gBAAA;EACA,gBAAA;AtC4vHF;;AsC3wHA;EAaE,eAAA;AtC8vHF;;AsC3wHA;EAaE,gBAAA;AtC8vHF;;AsCzvHI;EAEE,oCAAA;AtC0vHN;;AsCtvHE;EACE,gBAAA;AtCwvHJ;;AsC/uHA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;AtCkvHF;;AsChvHE;;;EAGE,oCAAA;AtCkvHJ;;AsCruHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AtCsuHF;;AsCluHA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;AtCquHF;;AuB92HM;EeiIN;IfhIQ,gBAAA;EvBi3HN;AACF;;AsCxuHE;EACE,qBAAA;AtC0uHJ;;AsCvuHE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AtCyuHJ;;AsCnuHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AtCsuHF;;AsCnuHA;EACE,yCAAA;EACA,gBAAA;AtCsuHF;;Aeh2HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtC6tHN;;EsC3tHM;IACE,mBAAA;EtC6tHR;;EsC3tHQ;IACE,kBAAA;EtC6tHV;;EsC1tHQ;IACE,kDAAA;IACA,iDAAA;EtC4tHV;;EsCxtHM;IACE,iBAAA;EtC0tHR;;EsCvtHM;IACE,wBAAA;IACA,gBAAA;EtCytHR;;EsCttHM;IACE,aAAA;EtCwtHR;;EsCrtHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCqtHR;;EsCltHQ;IACE,aAAA;EtCotHV;;EsCjtHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCmtHV;AACF;;Aeh5HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtC4wHN;;EsC1wHM;IACE,mBAAA;EtC4wHR;;EsC1wHQ;IACE,kBAAA;EtC4wHV;;EsCzwHQ;IACE,kDAAA;IACA,iDAAA;EtC2wHV;;EsCvwHM;IACE,iBAAA;EtCywHR;;EsCtwHM;IACE,wBAAA;IACA,gBAAA;EtCwwHR;;EsCrwHM;IACE,aAAA;EtCuwHR;;EsCpwHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCowHR;;EsCjwHQ;IACE,aAAA;EtCmwHV;;EsChwHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCkwHV;AACF;;Ae/7HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtC2zHN;;EsCzzHM;IACE,mBAAA;EtC2zHR;;EsCzzHQ;IACE,kBAAA;EtC2zHV;;EsCxzHQ;IACE,kDAAA;IACA,iDAAA;EtC0zHV;;EsCtzHM;IACE,iBAAA;EtCwzHR;;EsCrzHM;IACE,wBAAA;IACA,gBAAA;EtCuzHR;;EsCpzHM;IACE,aAAA;EtCszHR;;EsCnzHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCmzHR;;EsChzHQ;IACE,aAAA;EtCkzHV;;EsC/yHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCizHV;AACF;;Ae9+HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtC02HN;;EsCx2HM;IACE,mBAAA;EtC02HR;;EsCx2HQ;IACE,kBAAA;EtC02HV;;EsCv2HQ;IACE,kDAAA;IACA,iDAAA;EtCy2HV;;EsCr2HM;IACE,iBAAA;EtCu2HR;;EsCp2HM;IACE,wBAAA;IACA,gBAAA;EtCs2HR;;EsCn2HM;IACE,aAAA;EtCq2HR;;EsCl2HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCk2HR;;EsC/1HQ;IACE,aAAA;EtCi2HV;;EsC91HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCg2HV;AACF;;Ae7hII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtCy5HN;;EsCv5HM;IACE,mBAAA;EtCy5HR;;EsCv5HQ;IACE,kBAAA;EtCy5HV;;EsCt5HQ;IACE,kDAAA;IACA,iDAAA;EtCw5HV;;EsCp5HM;IACE,iBAAA;EtCs5HR;;EsCn5HM;IACE,wBAAA;IACA,gBAAA;EtCq5HR;;EsCl5HM;IACE,aAAA;EtCo5HR;;EsCj5HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCi5HR;;EsC94HQ;IACE,aAAA;EtCg5HV;;EsC74HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC+4HV;AACF;;AsCt8HI;EAEI,iBAAA;EACA,2BAAA;AtCu8HR;;AsCr8HQ;EACE,mBAAA;AtCu8HV;;AsCr8HU;EACE,kBAAA;AtCu8HZ;;AsCp8HU;EACE,kDAAA;EACA,iDAAA;AtCs8HZ;;AsCl8HQ;EACE,iBAAA;AtCo8HV;;AsCj8HQ;EACE,wBAAA;EACA,gBAAA;AtCm8HV;;AsCh8HQ;EACE,aAAA;AtCk8HV;;AsC/7HQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;AtC+7HV;;AsC57HU;EACE,aAAA;AtC87HZ;;AsC37HU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AtC67HZ;;AsC56HA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,8QAAA;AtC86HF;;AsCx6HI;EACE,8QAAA;AtC26HN;;AuCpsIA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;ARstIJ;;AuCjsIE;EACE,eAAA;EACA,cAAA;AvCmsIJ;;AuChsIE;EACE,mBAAA;EACA,sBAAA;AvCksIJ;;AuChsII;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;ARytIJ;;AuChsII;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;ARgtIJ;;AuC7rIE;;EAEE,aAAA;AvC+rIJ;;AuC3rIA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AvC4rIF;;AuCzrIA;EACE,4CAAA;EACA,iCAAA;AvC4rIF;;AuCzrIA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AvC4rIF;;AuCzrIA;EACE,gBAAA;AvC4rIF;;AuCprIE;EACE,oCAAA;AvCurIJ;;AuCxrIE;EACE,qCAAA;AvCurIJ;;AuC/qIA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AvCkrIF;;AuChrIE;E/B7FE,wFAAA;ARgxIJ;;AuC9qIA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AvCirIF;;AuC/qIE;E/BxGE,wFAAA;AR0xIJ;;AuCxqIA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AvC2qIF;;AuCzqIE;EACE,mCAAA;EACA,sCAAA;AvC2qIJ;;AuCvqIA;EACE,uDAAA;EACA,sDAAA;AvC0qIF;;AuCtqIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;ARozIJ;;AuCtqIA;;;EAGE,WAAA;AvCyqIF;;AuCtqIA;;E/B3II,0DAAA;EACA,2DAAA;ARszIJ;;AuCvqIA;;E/BlII,8DAAA;EACA,6DAAA;AR8yIJ;;AuChqIE;EACE,0CAAA;AvCmqIJ;;Ae9xII;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EvCmqIF;;EuChqIE;IAEE,YAAA;IACA,gBAAA;EvCiqIJ;;EuC/pII;IACE,cAAA;IACA,cAAA;EvCiqIN;;EuCnqII;IACE,eAAA;IACA,eAAA;EvCiqIN;;EuC5pIM;I/B3KJ,0BAAA;IACA,6BAAA;ER00IF;;EuChqIM;I/B3KJ,yBAAA;IACA,4BAAA;ER00IF;;EuC7pIQ;;IAGE,0BAAA;EvC8pIV;;EuCjqIQ;;IAGE,yBAAA;EvC8pIV;;EuC5pIQ;;IAGE,6BAAA;EvC6pIV;;EuChqIQ;;IAGE,4BAAA;EvC6pIV;;EuCzpIM;I/B5KJ,yBAAA;IACA,4BAAA;ERw0IF;;EuC7pIM;I/B5KJ,0BAAA;IACA,6BAAA;ERw0IF;;EuC1pIQ;;IAGE,yBAAA;EvC2pIV;;EuC9pIQ;;IAGE,0BAAA;EvC2pIV;;EuCzpIQ;;IAGE,4BAAA;EvC0pIV;;EuC7pIQ;;IAGE,6BAAA;EvC0pIV;AACF;;AwC/3IA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,yOAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,gPAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AxCi4IF;;AwC73IA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,eALI;EoCrPR,oCAAA;EAEA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AxCg4IF;;AwC74IA;EAQE,gBAAA;AxCq4IF;;AwC74IA;EAQE,iBAAA;AxCq4IF;;AuBv5IM;EiBUN;IjBTQ,gBAAA;EvB05IN;AACF;;AwCn4IE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AxCq4IJ;;AwCn4II;EACE,qDAAA;EACA,iDAAA;AxCq4IN;;AwCh4IE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EAEA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AxCk4IJ;;AwC34IE;EAIE,iBAAA;AxCu4IJ;;AwC34IE;EAIE,kBAAA;AxCu4IJ;;AuBh7IM;EiBqCJ;IjBpCM,gBAAA;EvBm7IN;AACF;;AwCp4IE;EACE,UAAA;AxCs4IJ;;AwCn4IE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AxCq4IJ;;AwCj4IA;EACE,gBAAA;AxCo4IF;;AwCj4IA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AxCo4IF;;AwCl4IE;EhC7DE,yDAAA;EACA,0DAAA;ARk8IJ;;AwCn4II;EhChEA,+DAAA;EACA,gEAAA;ARs8IJ;;AwCl4IE;EACE,aAAA;AxCo4IJ;;AwCh4IE;EhC5DE,6DAAA;EACA,4DAAA;AR+7IJ;;AwCh4IM;EhChEF,mEAAA;EACA,kEAAA;ARm8IJ;;AwC/3II;EhCrEA,6DAAA;EACA,4DAAA;ARu8IJ;;AwC73IA;EACE,8EAAA;AxCg4IF;;AwCv3IE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;ARy+IJ;;AwCx3II;EAAgB,aAAA;AxC23IpB;;AwC13II;EAAe,gBAAA;AxC63InB;;AwCz3IM;EhCtHF,gBAAA;ARk/IJ;;AwCr3II;EhC7HA,gBAAA;ARq/IJ;;AwCh3II;EACE,wSAAA;EACA,+SAAA;AxCm3IN;;AyC7gJA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;AR6gJJ;;AyCvgJE;EACE,iDAAA;AzC0gJJ;;AyC3gJE;EACE,kDAAA;AzC0gJJ;;AyCxgJI;EAGE,yCAAA;EACA,0CAAA;AzC0gJN;;AyC9gJI;EACE,WAAA;EACA,kDAAA;AzC4gJN;;AyC9gJI;EACE,YAAA;EACA,iDAAA;AzC4gJN;;AyCtgJE;EACE,6CAAA;AzCwgJJ;;A0C7iJA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCnBA,gBAAA;AVkkJF;;A0CvkJA;EhCIE,eAAA;AVmkJF;;A0CvkJA;EhCIE,gBAAA;AVmkJF;;A0C3iJA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A1C8iJF;;AuB/jJM;EmBQN;InBPQ,gBAAA;EvBkkJN;AACF;;A0CjjJE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A1CkjJJ;;A0C/iJE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;A1CijJJ;;A0C9iJE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A1C+iJJ;;A0C5iJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A1C6iJJ;;A0CxiJE;EACE,8CnC8sCgC;AP61GpC;;A0C5iJE;EACE,+CnC8sCgC;AP61GpC;;A0CtiJM;ElC9BF,0DAAA;EACA,6DAAA;ARukJJ;;A0C1iJM;ElC9BF,2DAAA;EACA,8DAAA;ARukJJ;;A0CpiJM;ElClDF,2DAAA;EACA,8DAAA;ARylJJ;;A0CxiJM;ElClDF,0DAAA;EACA,6DAAA;ARylJJ;;A0CvhJA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,kCALI;EuCnRR,yDAAA;A3C6nJF;;A0C1hJA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;A3CooJF;;A4CtoJA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;AR2oJJ;;A4CloJE;EACE,aAAA;A5CooJJ;;A4C/nJA;EACE,kBAAA;EACA,SAAA;A5CkoJF;;A6ClqJA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;ARsqJJ;;A6C9pJA;EAEE,cAAA;A7CgqJF;;A6C5pJA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;A7C+pJF;;A6CvpJA;EACE,mBtCs+C8B;APorGhC;;A6C3pJA;EACE,kBtCs+C8B;APorGhC;;A6CvpJE;EACE,kBAAA;EACA,MAAA;EAEA,UAAA;EACA,qBAAA;A7CypJJ;;A6C9pJE;EAGE,QAAA;A7C2pJJ;;A6C9pJE;EAGE,OAAA;A7C2pJJ;;A6CjpJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7CopJJ;;A6CxpJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A7C2pJJ;;A6C/pJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7CkqJJ;;A6CtqJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A7CyqJJ;;A6C7qJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7CgrJJ;;A6CprJE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A7CurJJ;;A6C3rJE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A7C8rJJ;;A6ClsJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A7CqsJJ;;A8CjwJE;EACE;IAAK,2BvCyhD2B;EP4uGlC;AACF;;A8CjwJA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;ARywJJ;;A8C5vJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A9C+vJF;;AuBpxJM;EuBYN;IvBXQ,gBAAA;EvBuxJN;AACF;;A8CjwJA;EAEE,oEAAA;A9CowJF;;A8CtwJA;EtBAE,qMAAA;AxBswJF;;A8CtwJA;EtBAE,sMAAA;AxBswJF;;A8CjwJA;EACE,iBAAA;A9CowJF;;A8CjwJA;EACE,WAAA;A9CowJF;;A8ChwJE;EACE,kDAAA;A9CmwJJ;;A8ChwJM;EAJJ;IAKM,eAAA;E9CmwJN;AACF;;A+C/zJA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAIA,gBAAA;EvCXE,iDAAA;ARy0JJ;;A+Cx1JA;EAyBE,eAAA;A/C+zJF;;A+Cx1JA;EAyBE,gBAAA;A/C+zJF;;A+C1zJA;EACE,qBAAA;EACA,sBAAA;A/C6zJF;;A+C3zJE;EAEE,oCAAA;EACA,0BAAA;A/C4zJJ;;A+CnzJA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A/CszJF;;A+CnzJE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A/CozJJ;;A+CjzJE;EACE,+CAAA;EACA,uDAAA;A/CmzJJ;;A+C3yJA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A/C8yJF;;A+C5yJE;EvCvDE,+BAAA;EACA,gCAAA;ARs2JJ;;A+C5yJE;EvC7CE,mCAAA;EACA,kCAAA;AR41JJ;;A+C5yJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A/C6yJJ;;A+CzyJE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A/C2yJJ;;A+CvyJE;EACE,mBAAA;A/CyyJJ;;A+CvyJI;EACE,wDAAA;EACA,mDAAA;A/CyyJN;;A+C5xJI;EACE,mBAAA;A/C+xJN;;A+C5xJQ;EvCvDJ,6DAAA;EAZA,0BAAA;ARm2JJ;;A+ChyJQ;EvCvDJ,8DAAA;EAZA,yBAAA;ARm2JJ;;A+C3xJQ;EvCxEJ,2DAAA;EAYA,4BAAA;AR21JJ;;A+C/xJQ;EvCxEJ,0DAAA;EAYA,6BAAA;AR21JJ;;A+C1xJQ;EACE,aAAA;A/C4xJV;;A+CzxJQ;EACE,mDAAA;A/C4xJV;;A+C7xJQ;EAEE,oBAAA;A/C2xJV;;A+C7xJQ;EAEE,qBAAA;A/C2xJV;;A+CzxJU;EACE,yDAAA;EACA,oDAAA;A/C2xJZ;;A+C7xJU;EACE,0DAAA;EACA,qDAAA;A/C2xJZ;;Aej3JI;EgC8DA;IACE,mBAAA;E/CuzJJ;;E+CpzJM;IvCvDJ,6DAAA;IAZA,0BAAA;ER23JF;;E+CxzJM;IvCvDJ,8DAAA;IAZA,yBAAA;ER23JF;;E+CnzJM;IvCxEJ,2DAAA;IAYA,4BAAA;ERm3JF;;E+CvzJM;IvCxEJ,0DAAA;IAYA,6BAAA;ERm3JF;;E+ClzJM;IACE,aAAA;E/CozJR;;E+CjzJM;IACE,mDAAA;E/CozJR;;E+CrzJM;IAEE,oBAAA;E/CmzJR;;E+CrzJM;IAEE,qBAAA;E/CmzJR;;E+CjzJQ;IACE,yDAAA;IACA,oDAAA;E/CmzJV;;E+CrzJQ;IACE,0DAAA;IACA,qDAAA;E/CmzJV;AACF;;Ae14JI;EgC8DA;IACE,mBAAA;E/C+0JJ;;E+C50JM;IvCvDJ,6DAAA;IAZA,0BAAA;ERm5JF;;E+Ch1JM;IvCvDJ,8DAAA;IAZA,yBAAA;ERm5JF;;E+C30JM;IvCxEJ,2DAAA;IAYA,4BAAA;ER24JF;;E+C/0JM;IvCxEJ,0DAAA;IAYA,6BAAA;ER24JF;;E+C10JM;IACE,aAAA;E/C40JR;;E+Cz0JM;IACE,mDAAA;E/C40JR;;E+C70JM;IAEE,oBAAA;E/C20JR;;E+C70JM;IAEE,qBAAA;E/C20JR;;E+Cz0JQ;IACE,yDAAA;IACA,oDAAA;E/C20JV;;E+C70JQ;IACE,0DAAA;IACA,qDAAA;E/C20JV;AACF;;Ael6JI;EgC8DA;IACE,mBAAA;E/Cu2JJ;;E+Cp2JM;IvCvDJ,6DAAA;IAZA,0BAAA;ER26JF;;E+Cx2JM;IvCvDJ,8DAAA;IAZA,yBAAA;ER26JF;;E+Cn2JM;IvCxEJ,2DAAA;IAYA,4BAAA;ERm6JF;;E+Cv2JM;IvCxEJ,0DAAA;IAYA,6BAAA;ERm6JF;;E+Cl2JM;IACE,aAAA;E/Co2JR;;E+Cj2JM;IACE,mDAAA;E/Co2JR;;E+Cr2JM;IAEE,oBAAA;E/Cm2JR;;E+Cr2JM;IAEE,qBAAA;E/Cm2JR;;E+Cj2JQ;IACE,yDAAA;IACA,oDAAA;E/Cm2JV;;E+Cr2JQ;IACE,0DAAA;IACA,qDAAA;E/Cm2JV;AACF;;Ae17JI;EgC8DA;IACE,mBAAA;E/C+3JJ;;E+C53JM;IvCvDJ,6DAAA;IAZA,0BAAA;ERm8JF;;E+Ch4JM;IvCvDJ,8DAAA;IAZA,yBAAA;ERm8JF;;E+C33JM;IvCxEJ,2DAAA;IAYA,4BAAA;ER27JF;;E+C/3JM;IvCxEJ,0DAAA;IAYA,6BAAA;ER27JF;;E+C13JM;IACE,aAAA;E/C43JR;;E+Cz3JM;IACE,mDAAA;E/C43JR;;E+C73JM;IAEE,oBAAA;E/C23JR;;E+C73JM;IAEE,qBAAA;E/C23JR;;E+Cz3JQ;IACE,yDAAA;IACA,oDAAA;E/C23JV;;E+C73JQ;IACE,0DAAA;IACA,qDAAA;E/C23JV;AACF;;Ael9JI;EgC8DA;IACE,mBAAA;E/Cu5JJ;;E+Cp5JM;IvCvDJ,6DAAA;IAZA,0BAAA;ER29JF;;E+Cx5JM;IvCvDJ,8DAAA;IAZA,yBAAA;ER29JF;;E+Cn5JM;IvCxEJ,2DAAA;IAYA,4BAAA;ERm9JF;;E+Cv5JM;IvCxEJ,0DAAA;IAYA,6BAAA;ERm9JF;;E+Cl5JM;IACE,aAAA;E/Co5JR;;E+Cj5JM;IACE,mDAAA;E/Co5JR;;E+Cr5JM;IAEE,oBAAA;E/Cm5JR;;E+Cr5JM;IAEE,qBAAA;E/Cm5JR;;E+Cj5JQ;IACE,yDAAA;IACA,oDAAA;E/Cm5JV;;E+Cr5JQ;IACE,0DAAA;IACA,qDAAA;E/Cm5JV;AACF;;A+Ct4JA;EvChJI,gBAAA;ARyhKJ;;A+Ct4JE;EACE,mDAAA;A/Cw4JJ;;A+Ct4JI;EACE,sBAAA;A/Cw4JN;;A+C33JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/C83JJ;;A+Cx4JE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A/C24JJ;;A+Cr5JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/Cw5JJ;;A+Cl6JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A/Cq6JJ;;A+C/6JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/Ck7JJ;;A+C57JE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A/C+7JJ;;A+Cz8JE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A/C48JJ;;A+Ct9JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A/Cy9JJ;;AgDrpKA;EAEE,0BAAA;EACA,oVAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,UzCqpD2B;EyCppD3B,WzCopD2B;EyCnpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;ExCJE,sBAAA;EwCMF,oCAAA;AhDqpKF;;AgDlpKE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AhDopKJ;;AgDjpKE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AhDmpKJ;;AgDhpKE;EAEE,oBAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,6CAAA;AhDipKJ;;AgDzoKA;EAHE,wCAAA;AhDgpKF;;AgDvoKI;EATF,wCAAA;AhDopKF;;AiDrsKA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;AR8sKJ;;AiDnsKE;EACE,UAAA;AjDqsKJ;;AiDlsKE;EACE,aAAA;AjDosKJ;;AiDhsKA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,oBAAA;AjDksKF;;AiDhsKE;EACE,sCAAA;AjDksKJ;;AiD9rKA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;ARkuKJ;;AiDhsKE;EACE,oDAAA;EACA,sCAAA;AjDksKJ;;AiDpsKE;EACE,mDAAA;EACA,uCAAA;AjDksKJ;;AiD9rKA;EACE,kCAAA;EACA,qBAAA;AjDisKF;;AkD/vKA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EAEA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AlD6vKF;;AkDjyKA;EA2BE,OAAA;AlDswKF;;AkDjyKA;EA2BE,QAAA;AlDswKF;;AkDtvKA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AlDwvKF;;AkDrvKE;E3B5CI,mC2B6CF;EACA,8B3Ck8CgC;APqzHpC;;AuBjyKM;E2BwCJ;I3BvCM,gBAAA;EvBoyKN;AACF;;AkD1vKE;EACE,e3Cg8CgC;AP4zHpC;;AkDxvKE;EACE,sB3C67CgC;AP6zHpC;;AkDtvKA;EACE,+CAAA;AlDyvKF;;AkDvvKE;EACE,gBAAA;EACA,gBAAA;AlDyvKJ;;AkDtvKE;EACE,gBAAA;AlDwvKJ;;AkDpvKA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AlDuvKF;;AkDnvKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AlDmvKF;;AkD/uKA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EAEA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AlDqvK9D;;AkD5vKA;EC5GE,OAAA;AnDw2KF;;AkD5vKA;EC5GE,QAAA;AnDw2KF;;AmDj2KE;EAAS,UAAA;AnDo2KX;;AmDn2KE;EAAS,mCD2GiF;AlD2vK5F;;AkDtvKA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;AR+1KJ;;AkDxvKE;EACE,kGAAA;AlD2vKJ;;AkD5vKE;EAEE,sJAAA;AlD0vKJ;;AkD5vKE;EAEE,sJAAA;AlD0vKJ;;AkDrvKA;EACE,gBAAA;EACA,8CAAA;AlDwvKF;;AkDnvKA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AlDovKF;;AkDhvKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1CzHE,+DAAA;EACA,8DAAA;AR62KJ;;AkD/uKE;EACE,8CAAA;AlDivKJ;;Ae51KI;EmCiHF;IACE,0BAAA;IACA,2CAAA;ElD+uKF;;EkD3uKA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;ElD6uKF;;EkD1uKA;IACE,uBAAA;ElD4uKF;AACF;;Ae32KI;EmCmIF;;IAEE,uBAAA;ElD2uKF;AACF;;Aej3KI;EmC0IF;IACE,wBAAA;ElD0uKF;AACF;;AkDjuKI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AlDmuKN;;AkDjuKM;EACE,YAAA;EACA,SAAA;E1CzMJ,gBAAA;AR66KJ;;AkDhuKM;;E1C7MF,gBAAA;ARi7KJ;;AkD/tKM;EACE,gBAAA;AlDiuKR;;Ae33KI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDuvKJ;;EkDrvKI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;ERi8KF;;EkDpvKI;;I1C7MF,gBAAA;ERq8KF;;EkDnvKI;IACE,gBAAA;ElDqvKN;AACF;;Aeh5KI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD2wKJ;;EkDzwKI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;ERq9KF;;EkDxwKI;;I1C7MF,gBAAA;ERy9KF;;EkDvwKI;IACE,gBAAA;ElDywKN;AACF;;Aep6KI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD+xKJ;;EkD7xKI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;ERy+KF;;EkD5xKI;;I1C7MF,gBAAA;ER6+KF;;EkD3xKI;IACE,gBAAA;ElD6xKN;AACF;;Aex7KI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDmzKJ;;EkDjzKI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;ER6/KF;;EkDhzKI;;I1C7MF,gBAAA;ERigLF;;EkD/yKI;IACE,gBAAA;ElDizKN;AACF;;Ae58KI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDu0KJ;;EkDr0KI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;ERihLF;;EkDp0KI;;I1C7MF,gBAAA;ERqhLF;;EkDn0KI;IACE,gBAAA;ElDq0KN;AACF;;AoD3iLA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;ApDmjLF;;AoDjjLE;EAAS,kCAAA;ApDojLX;;AoDljLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ApDojLJ;;AoDljLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDojLN;;AoD/iLA;EACE,iDAAA;ApDkjLF;;AoDhjLE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;ApDkjLJ;;AoD7iLA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;ApDijLF;;AoD/iLE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;ApDijLJ;;AoD3iLA;EACE,8CAAA;ApD+iLF;;AoD7iLE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;ApD+iLJ;;AoD1iLA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;ApD8iLF;;AoD5iLE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;ApD8iLJ;;AoDxhLA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;AR8nLJ;;AsDjpLA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;AR4qLJ;;AsDxpLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AtD0pLJ;;AsDxpLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AtDypLN;;AsDnpLE;EACE,oFAAA;AtDspLJ;;AsDppLI;EAEE,wFAAA;AtDqpLN;;AsDlpLI;EACE,SAAA;EACA,gDAAA;AtDopLN;;AsDjpLI;EACE,sCAAA;EACA,sCAAA;AtDmpLN;;AsD5oLE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AtDgpLJ;;AsD9oLI;EAEE,kIAAA;AtD+oLN;;AsD5oLI;EACE,OAAA;EACA,kDAAA;AtD8oLN;;AsD3oLI;EACE,oCAAA;EACA,wCAAA;AtD6oLN;;AsDroLE;EACE,iFAAA;AtDyoLJ;;AsDvoLI;EAEE,wFAAA;AtDwoLN;;AsDroLI;EACE,MAAA;EACA,mDAAA;AtDuoLN;;AsDpoLI;EACE,mCAAA;EACA,yCAAA;AtDsoLN;;AsDjoLE;EACE,kBAAA;EACA,MAAA;EAEA,cAAA;EACA,oCAAA;EAEA,WAAA;EACA,+EAAA;AtDmoLJ;;AsD3oLE;EAGE,SAAA;EAGA,uDAAA;AtDqoLJ;;AsD3oLE;EAGE,UAAA;EAGA,wDAAA;AtDqoLJ;;AsD7nLE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AtDioLJ;;AsD/nLI;EAEE,kIAAA;AtDgoLN;;AsD7nLI;EACE,QAAA;EACA,iDAAA;AtD+nLN;;AsD5nLI;EACE,qCAAA;EACA,uCAAA;AtD8nLN;;AsDvmLA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;ARwwLJ;;AsD1mLE;EACE,aAAA;AtD4mLJ;;AsDxmLA;EACE,0EAAA;EACA,mCAAA;AtD2mLF;;AuDhyLA;EACE,kBAAA;AvDmyLF;;AuDhyLA;EACE,mBAAA;AvDmyLF;;AuDhyLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AvDmyLF;;AwDzzLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxD2zLJ;;AuDpyLA;EACE,kBAAA;EACA,aAAA;EAEA,WAAA;EAEA,2BAAA;EhClBI,sCgCmBJ;AvDuyLF;;AuD9yLA;EAGE,WAAA;EAEA,mBAAA;AvDyyLF;;AuD9yLA;EAGE,YAAA;EAEA,kBAAA;AvDyyLF;;AuBtzLM;EgCQN;IhCPQ,gBAAA;EvByzLN;AACF;;AuDzyLA;;;EAGE,cAAA;AvD4yLF;;AuDzyLA;;EAEE,2BAAA;AvD4yLF;;AuD9yLA;;EAEE,4BAAA;AvD4yLF;;AuDzyLA;;EAEE,4BAAA;AvD4yLF;;AuD9yLA;;EAEE,2BAAA;AvD4yLF;;AuDnyLE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AvDsyLJ;;AuDnyLE;;;EAGE,UAAA;EACA,UAAA;AvDqyLJ;;AuDlyLE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AvDoyLJ;;AuB71LM;EgCqDJ;;IhCpDM,gBAAA;EvBi2LN;AACF;;AuDjyLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WhD1FS;EgD2FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhD6gDmC;EgBnmD/B,8BgCuFJ;AvDmyLF;;AuBt3LM;EgCkEN;;IhCjEQ,gBAAA;EvB03LN;AACF;;AuDtyLE;;;EAEE,WhDpGO;EgDqGP,qBAAA;EACA,UAAA;EACA,YhDqgDiC;APoyIrC;;AuDtyLA;EACE,OAAA;AvDyyLF;;AuD1yLA;EACE,QAAA;AvDyyLF;;AuDtyLA;EACE,QAAA;AvDyyLF;;AuD1yLA;EACE,OAAA;AvDyyLF;;AuDpyLA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AvDuyLF;;AuDpyLA;EACE,yQAAA;AvDuyLF;;AuDxyLA;EACE,0QAAA;AvDuyLF;;AuDryLA;EACE,0QAAA;AvDwyLF;;AuDzyLA;EACE,yQAAA;AvDwyLF;;AuDhyLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDs9CmC;EgDr9CnC,mBAAA;EACA,gBhDo9CmC;AP80IrC;;AuDhyLE;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,sBhDlKO;EgDmKP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB3mD/B,6BgCiKF;AvDiyLJ;;AuB97LM;EgC4IJ;IhC3IM,gBAAA;EvBi8LN;AACF;;AuDnyLE;EACE,UhDw8CiC;AP61IrC;;AuD5xLA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,WhD7LS;EgD8LT,kBAAA;AvD+xLF;;AuDzxLE;;EAEE,gChDm8CiC;APy1IrC;;AuDzxLE;EACE,sBhDhMO;AP29LX;;AuDxxLE;EACE,WhDpMO;AP89LX;;AuDpyLE;;;EAEE,gChDm8CiC;APq2IrC;;AuDryLE;EACE,sBhDhMO;APu+LX;;AuDpyLE;EACE,WhDpMO;AP0+LX;;AyDx/LA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AzD0/LF;;AyDt/LA;EACE;IAAK,0CAAA;EzD0/LL;AACF;;AyDv/LA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;AzDu/LF;;AyDjgMA;EAWE,+BAAA;AzDs/LF;;AyDjgMA;EAWE,8BAAA;AzDs/LF;;AyDn/LA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AzDq/LF;;AyD5+LA;EACE;IACE,mBAAA;EzD++LF;;EyD7+LA;IACE,UAAA;IACA,eAAA;EzD++LF;AACF;;AyD3+LA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AzD0+LF;;AyDv+LA;EACE,wBAAA;EACA,yBAAA;AzD0+LF;;AyDt+LE;EACE;;IAEE,kCAAA;EzDy+LJ;AACF;;A0DzjMA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;A1D0jMF;;Ae7/LI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1D2iMJ;AACF;;AuBtkMM;EmCYJ;InCXM,gBAAA;EvBykMN;AACF;;AenhMI;E2C5BE;IACE,MAAA;IAEA,gCAAA;E1DojMN;;E0DvjMI;IAEE,OAAA;IAEA,qFAAA;IACA,4BAAA;E1DkjMN;;E0DvjMI;IAEE,QAAA;IAEA,oFAAA;IACA,2BAAA;E1DkjMN;;E0D/iMI;IACE,MAAA;IAEA,gCAAA;E1DmjMN;;E0DtjMI;IAEE,QAAA;IAEA,oFAAA;IACA,2BAAA;E1DijMN;;E0DtjMI;IAEE,OAAA;IAEA,qFAAA;IACA,4BAAA;E1DijMN;;E0D9iMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1DgjMN;;E0D7iMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1D+iMN;;E0D5iMI;IAEE,eAAA;E1D6iMN;;E0D1iMI;IAGE,mBAAA;E1D0iMN;AACF;;AevkMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DyiMN;;E0DviMM;IACE,aAAA;E1DyiMR;;E0DtiMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DuiMR;AACF;;Ae3kMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1DynMJ;AACF;;AuBppMM;EmCYJ;InCXM,gBAAA;EvBupMN;AACF;;AejmMI;E2C5BE;IACE,MAAA;IAEA,gCAAA;E1DkoMN;;E0DroMI;IAEE,OAAA;IAEA,qFAAA;IACA,4BAAA;E1DgoMN;;E0DroMI;IAEE,QAAA;IAEA,oFAAA;IACA,2BAAA;E1DgoMN;;E0D7nMI;IACE,MAAA;IAEA,gCAAA;E1DioMN;;E0DpoMI;IAEE,QAAA;IAEA,oFAAA;IACA,2BAAA;E1D+nMN;;E0DpoMI;IAEE,OAAA;IAEA,qFAAA;IACA,4BAAA;E1D+nMN;;E0D5nMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1D8nMN;;E0D3nMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1D6nMN;;E0D1nMI;IAEE,eAAA;E1D2nMN;;E0DxnMI;IAGE,mBAAA;E1DwnMN;AACF;;AerpMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DunMN;;E0DrnMM;IACE,aAAA;E1DunMR;;E0DpnMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DqnMR;AACF;;AezpMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1DusMJ;AACF;;AuBluMM;EmCYJ;InCXM,gBAAA;EvBquMN;AACF;;Ae/qMI;E2C5BE;IACE,MAAA;IAEA,gCAAA;E1DgtMN;;E0DntMI;IAEE,OAAA;IAEA,qFAAA;IACA,4BAAA;E1D8sMN;;E0DntMI;IAEE,QAAA;IAEA,oFAAA;IACA,2BAAA;E1D8sMN;;E0D3sMI;IACE,MAAA;IAEA,gCAAA;E1D+sMN;;E0DltMI;IAEE,QAAA;IAEA,oFAAA;IACA,2BAAA;E1D6sMN;;E0DltMI;IAEE,OAAA;IAEA,qFAAA;IACA,4BAAA;E1D6sMN;;E0D1sMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1D4sMN;;E0DzsMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1D2sMN;;E0DxsMI;IAEE,eAAA;E1DysMN;;E0DtsMI;IAGE,mBAAA;E1DssMN;AACF;;AenuMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DqsMN;;E0DnsMM;IACE,aAAA;E1DqsMR;;E0DlsMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DmsMR;AACF;;AevuMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1DqxMJ;AACF;;AuBhzMM;EmCYJ;InCXM,gBAAA;EvBmzMN;AACF;;Ae7vMI;E2C5BE;IACE,MAAA;IAEA,gCAAA;E1D8xMN;;E0DjyMI;IAEE,OAAA;IAEA,qFAAA;IACA,4BAAA;E1D4xMN;;E0DjyMI;IAEE,QAAA;IAEA,oFAAA;IACA,2BAAA;E1D4xMN;;E0DzxMI;IACE,MAAA;IAEA,gCAAA;E1D6xMN;;E0DhyMI;IAEE,QAAA;IAEA,oFAAA;IACA,2BAAA;E1D2xMN;;E0DhyMI;IAEE,OAAA;IAEA,qFAAA;IACA,4BAAA;E1D2xMN;;E0DxxMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1D0xMN;;E0DvxMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1DyxMN;;E0DtxMI;IAEE,eAAA;E1DuxMN;;E0DpxMI;IAGE,mBAAA;E1DoxMN;AACF;;AejzMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DmxMN;;E0DjxMM;IACE,aAAA;E1DmxMR;;E0DhxMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DixMR;AACF;;AerzMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1Dm2MJ;AACF;;AuB93MM;EmCYJ;InCXM,gBAAA;EvBi4MN;AACF;;Ae30MI;E2C5BE;IACE,MAAA;IAEA,gCAAA;E1D42MN;;E0D/2MI;IAEE,OAAA;IAEA,qFAAA;IACA,4BAAA;E1D02MN;;E0D/2MI;IAEE,QAAA;IAEA,oFAAA;IACA,2BAAA;E1D02MN;;E0Dv2MI;IACE,MAAA;IAEA,gCAAA;E1D22MN;;E0D92MI;IAEE,QAAA;IAEA,oFAAA;IACA,2BAAA;E1Dy2MN;;E0D92MI;IAEE,OAAA;IAEA,qFAAA;IACA,4BAAA;E1Dy2MN;;E0Dt2MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1Dw2MN;;E0Dr2MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1Du2MN;;E0Dp2MI;IAEE,eAAA;E1Dq2MN;;E0Dl2MI;IAGE,mBAAA;E1Dk2MN;AACF;;Ae/3MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1Di2MN;;E0D/1MM;IACE,aAAA;E1Di2MR;;E0D91MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1D+1MR;AACF;;A0D/6ME;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;A1Dg7MN;;AuB18MM;EmCYJ;InCXM,gBAAA;EvB68MN;AACF;;A0Dn7MM;EACE,MAAA;EAEA,gCAAA;A1Du7MR;;A0D17MM;EAEE,OAAA;EAEA,qFAAA;EACA,4BAAA;A1Dq7MR;;A0D17MM;EAEE,QAAA;EAEA,oFAAA;EACA,2BAAA;A1Dq7MR;;A0Dl7MM;EACE,MAAA;EAEA,gCAAA;A1Ds7MR;;A0Dz7MM;EAEE,QAAA;EAEA,oFAAA;EACA,2BAAA;A1Do7MR;;A0Dz7MM;EAEE,OAAA;EAEA,qFAAA;EACA,4BAAA;A1Do7MR;;A0Dj7MM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A1Dm7MR;;A0Dh7MM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A1Dk7MR;;A0D/6MM;EAEE,eAAA;A1Dg7MR;;A0D76MM;EAGE,mBAAA;A1D66MR;;A0Dl5MA;EPpHE,eAAA;EACA,MAAA;EAEA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sB5CUS;APggNX;;A0D55MA;EPlHE,OAAA;AnD8gNF;;A0D55MA;EPlHE,QAAA;AnD8gNF;;AmDvgNE;EAAS,UAAA;AnD0gNX;;AmDzgNE;EAAS,Y5Cm+CyB;APyiKpC;;A0D95MA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;A1Di6MF;;A0D/5ME;EACE,4FAAA;A1Dk6MJ;;A0Dn6ME;EAEE,6IAAA;A1Di6MJ;;A0Dn6ME;EAEE,6IAAA;A1Di6MJ;;A0D75MA;EACE,gBAAA;EACA,kDAAA;A1Dg6MF;;A0D75MA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A1Dg6MF;;A2D7iNA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDgzCkC;APgwKpC;;A2D9iNE;EACE,qBAAA;EACA,WAAA;A3DgjNJ;;A2D3iNA;EACE,iBAAA;A3D8iNF;;A2D3iNA;EACE,iBAAA;A3D8iNF;;A2D3iNA;EACE,iBAAA;A3D8iNF;;A2DziNE;EACE,mDAAA;A3D4iNJ;;A2DxiNA;EACE;IACE,YpDmxCgC;EPwxKlC;AACF;;A2DxiNA;EACE,uFAAA;UAAA,+EAAA;EACA,4BAAA;UAAA,oBAAA;EACA,8CAAA;A3D0iNF;;A2DviNA;EACE;IACE,+BAAA;YAAA,uBAAA;E3D0iNF;AACF;;AwDzlNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxD2lNJ;;A4D9lNE;EACE,sBAAA;EACA,iFAAA;A5DimNJ;;A4DnmNE;EACE,sBAAA;EACA,mFAAA;A5DsmNJ;;A4DxmNE;EACE,sBAAA;EACA,iFAAA;A5D2mNJ;;A4D7mNE;EACE,sBAAA;EACA,8EAAA;A5DgnNJ;;A4DlnNE;EACE,sBAAA;EACA,iFAAA;A5DqnNJ;;A4DvnNE;EACE,sBAAA;EACA,gFAAA;A5D0nNJ;;A4D5nNE;EACE,sBAAA;EACA,+EAAA;A5D+nNJ;;A4DjoNE;EACE,sBAAA;EACA,8EAAA;A5DooNJ;;A6DtoNE;EACE,wEAAA;EACA,kGAAA;A7DyoNJ;;A6DtoNM;EAGE,8DAAA;EACA,wFAAA;A7DsoNR;;A6D/oNE;EACE,0EAAA;EACA,oGAAA;A7DkpNJ;;A6D/oNM;EAGE,8DAAA;EACA,wFAAA;A7D+oNR;;A6DxpNE;EACE,wEAAA;EACA,kGAAA;A7D2pNJ;;A6DxpNM;EAGE,8DAAA;EACA,wFAAA;A7DwpNR;;A6DjqNE;EACE,qEAAA;EACA,+FAAA;A7DoqNJ;;A6DjqNM;EAGE,+DAAA;EACA,yFAAA;A7DiqNR;;A6D1qNE;EACE,wEAAA;EACA,kGAAA;A7D6qNJ;;A6D1qNM;EAGE,+DAAA;EACA,yFAAA;A7D0qNR;;A6DnrNE;EACE,uEAAA;EACA,iGAAA;A7DsrNJ;;A6DnrNM;EAGE,8DAAA;EACA,wFAAA;A7DmrNR;;A6D5rNE;EACE,sEAAA;EACA,gGAAA;A7D+rNJ;;A6D5rNM;EAGE,gEAAA;EACA,0FAAA;A7D4rNR;;A6DrsNE;EACE,qEAAA;EACA,+FAAA;A7DwsNJ;;A6DrsNM;EAGE,6DAAA;EACA,uFAAA;A7DqsNR;;A6D9rNA;EACE,+EAAA;EACA,yGAAA;A7DisNF;;A6D9rNI;EAEE,kFAAA;EACA,4GAAA;A7D+rNN;;A8DztNA;EACE,UAAA;EAEA,kJAAA;A9D2tNF;;A+D9tNA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,kFAAA;EACA,6BxD2c4B;EwD1c5B,2BAAA;A/DiuNF;;A+D/tNE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A/DiuNJ;;AuB1tNM;EwCZJ;IxCaM,gBAAA;EvB6tNN;AACF;;A+D/tNI;EACE,mEAAA;A/DkuNN;;A+DnuNI;EACE,oEAAA;A/DkuNN;;AgErvNA;EACE,kBAAA;EACA,WAAA;AhEwvNF;;AgEtvNE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AhEwvNJ;;AgErvNE;EACE,kBAAA;EACA,MAAA;EAEA,WAAA;EACA,YAAA;AhEuvNJ;;AgE5vNE;EAGE,OAAA;AhEyvNJ;;AgE5vNE;EAGE,QAAA;AhEyvNJ;;AgElvNE;EACE,uBAAA;AhEqvNJ;;AgEtvNE;EACE,sBAAA;AhEyvNJ;;AgE1vNE;EACE,yBAAA;AhE6vNJ;;AgE9vNE;EACE,iCAAA;AhEiwNJ;;AiEtxNA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;APkrLpC;;AiEtxNA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;AP0rLpC;;AiEjxNI;EACE,gBAAA;EACA,MAAA;EACA,a1DmlC8B;APisLpC;;AiEjxNI;EACE,gBAAA;EACA,SAAA;EACA,a1D6kC8B;APusLpC;;AervNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EP8sLlC;;EiE9xNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EPmtLlC;AACF;;AelwNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EP0tLlC;;EiE1yNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EP+tLlC;AACF;;Ae9wNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EPsuLlC;;EiEtzNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EP2uLlC;AACF;;Ae1xNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EPkvLlC;;EiEl0NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EPuvLlC;AACF;;AetyNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EP8vLlC;;EiE90NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EPmwLlC;AACF;;AkEh3NA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AlEk3NF;;AkE/2NA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AlEk3NF;;AmE13NA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;ApE23NF;;AoEx3NE;;EACE,6BAAA;ApE23NJ;;AqEz4NE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;ArE44NJ;;AsEp5NA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AvEw5NF;;AwE95NA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;APsuM9B;;AyEr2NQ;EAOI,mCAAA;AzEk2NZ;;AyEz2NQ;EAOI,8BAAA;AzEs2NZ;;AyE72NQ;EAOI,iCAAA;AzE02NZ;;AyEj3NQ;EAOI,iCAAA;AzE82NZ;;AyEr3NQ;EAOI,sCAAA;AzEk3NZ;;AyEz3NQ;EAOI,mCAAA;AzEs3NZ;;AyE73NQ;EAOI,sBAAA;AzE03NZ;;AyEj4NQ;EAOI,uBAAA;AzE03NZ;;AyEj4NQ;EAOI,uBAAA;AzE83NZ;;AyEr4NQ;EAOI,sBAAA;AzE83NZ;;AyEr4NQ;EAOI,sBAAA;AzEk4NZ;;AyEz4NQ;EAOI,iCAAA;KAAA,8BAAA;AzEs4NZ;;AyE74NQ;EAOI,+BAAA;KAAA,4BAAA;AzE04NZ;;AyEj5NQ;EAOI,8BAAA;KAAA,2BAAA;AzE84NZ;;AyEr5NQ;EAOI,oCAAA;KAAA,iCAAA;AzEk5NZ;;AyEz5NQ;EAOI,8BAAA;KAAA,2BAAA;AzEs5NZ;;AyE75NQ;EAOI,qBAAA;AzE05NZ;;AyEj6NQ;EAOI,wBAAA;AzE85NZ;;AyEr6NQ;EAOI,uBAAA;AzEk6NZ;;AyEz6NQ;EAOI,wBAAA;AzEs6NZ;;AyE76NQ;EAOI,qBAAA;AzE06NZ;;AyEj7NQ;EAOI,yBAAA;AzE86NZ;;AyEr7NQ;EAOI,2BAAA;AzEk7NZ;;AyEz7NQ;EAOI,4BAAA;AzEs7NZ;;AyE77NQ;EAOI,2BAAA;AzE07NZ;;AyEj8NQ;EAOI,2BAAA;AzE87NZ;;AyEr8NQ;EAOI,6BAAA;AzEk8NZ;;AyEz8NQ;EAOI,8BAAA;AzEs8NZ;;AyE78NQ;EAOI,6BAAA;AzE08NZ;;AyEj9NQ;EAOI,2BAAA;AzE88NZ;;AyEr9NQ;EAOI,6BAAA;AzEk9NZ;;AyEz9NQ;EAOI,8BAAA;AzEs9NZ;;AyE79NQ;EAOI,6BAAA;AzE09NZ;;AyEj+NQ;EAOI,0BAAA;AzE89NZ;;AyEr+NQ;EAOI,gCAAA;AzEk+NZ;;AyEz+NQ;EAOI,yBAAA;AzEs+NZ;;AyE7+NQ;EAOI,wBAAA;AzE0+NZ;;AyEj/NQ;EAOI,+BAAA;AzE8+NZ;;AyEr/NQ;EAOI,yBAAA;AzEk/NZ;;AyEz/NQ;EAOI,6BAAA;AzEs/NZ;;AyE7/NQ;EAOI,8BAAA;AzE0/NZ;;AyEjgOQ;EAOI,wBAAA;AzE8/NZ;;AyErgOQ;EAOI,+BAAA;AzEkgOZ;;AyEzgOQ;EAOI,wBAAA;AzEsgOZ;;AyE7gOQ;EAOI,2CAAA;AzE0gOZ;;AyEjhOQ;EAOI,8CAAA;AzE8gOZ;;AyErhOQ;EAOI,8CAAA;AzEkhOZ;;AyEzhOQ;EAOI,2BAAA;AzEshOZ;;AyEviOQ;EACE,gFAAA;AzE0iOV;;AyE3iOQ;EACE,kFAAA;AzE8iOV;;AyE/iOQ;EACE,gFAAA;AzEkjOV;;AyEnjOQ;EACE,6EAAA;AzEsjOV;;AyEvjOQ;EACE,gFAAA;AzE0jOV;;AyE3jOQ;EACE,+EAAA;AzE8jOV;;AyE/jOQ;EACE,8EAAA;AzEkkOV;;AyEnkOQ;EACE,6EAAA;AzEskOV;;AyE7jOQ;EAOI,2BAAA;AzE0jOZ;;AyEjkOQ;EAOI,6BAAA;AzE8jOZ;;AyErkOQ;EAOI,6BAAA;AzEkkOZ;;AyEzkOQ;EAOI,0BAAA;AzEskOZ;;AyE7kOQ;EAOI,2BAAA;AzE0kOZ;;AyEjlOQ;EAOI,iBAAA;AzE8kOZ;;AyErlOQ;EAOI,mBAAA;AzEklOZ;;AyEzlOQ;EAOI,oBAAA;AzEslOZ;;AyE7lOQ;EAOI,oBAAA;AzE0lOZ;;AyEjmOQ;EAOI,sBAAA;AzE8lOZ;;AyErmOQ;EAOI,uBAAA;AzEkmOZ;;AyEzmOQ;EAOI,kBAAA;AzEsmOZ;;AyE7mOQ;EAOI,mBAAA;AzEsmOZ;;AyE7mOQ;EAOI,oBAAA;AzE0mOZ;;AyEjnOQ;EAOI,qBAAA;AzE0mOZ;;AyEjnOQ;EAOI,qBAAA;AzE8mOZ;;AyErnOQ;EAOI,sBAAA;AzE8mOZ;;AyErnOQ;EAOI,mBAAA;AzEknOZ;;AyEznOQ;EAOI,kBAAA;AzEknOZ;;AyEznOQ;EAOI,qBAAA;AzEsnOZ;;AyE7nOQ;EAOI,oBAAA;AzEsnOZ;;AyE7nOQ;EAOI,sBAAA;AzE0nOZ;;AyEjoOQ;EAOI,qBAAA;AzE0nOZ;;AyEjoOQ;EAOI,2CAAA;AzE8nOZ;;AyEroOQ;EAOI,0CAAA;AzE8nOZ;;AyEroOQ;EAOI,sCAAA;AzEkoOZ;;AyEzoOQ;EAOI,qCAAA;AzEkoOZ;;AyEzoOQ;EAOI,sCAAA;AzEsoOZ;;AyE7oOQ;EAOI,uFAAA;AzE0oOZ;;AyEjpOQ;EAOI,oBAAA;AzE8oOZ;;AyErpOQ;EAOI,2FAAA;AzEkpOZ;;AyEzpOQ;EAOI,wBAAA;AzEspOZ;;AyE7pOQ;EAOI,6FAAA;AzE0pOZ;;AyEjqOQ;EAOI,4FAAA;AzE0pOZ;;AyEjqOQ;EAOI,0BAAA;AzE8pOZ;;AyErqOQ;EAOI,yBAAA;AzE8pOZ;;AyErqOQ;EAOI,8FAAA;AzEkqOZ;;AyEzqOQ;EAOI,2BAAA;AzEsqOZ;;AyE7qOQ;EAOI,4FAAA;AzE0qOZ;;AyEjrOQ;EAOI,6FAAA;AzE0qOZ;;AyEjrOQ;EAOI,yBAAA;AzE8qOZ;;AyErrOQ;EAOI,0BAAA;AzE8qOZ;;AyErrOQ;EAIQ,sBAAA;EAGJ,8EAAA;AzEmrOZ;;AyE1rOQ;EAIQ,sBAAA;EAGJ,gFAAA;AzEwrOZ;;AyE/rOQ;EAIQ,sBAAA;EAGJ,8EAAA;AzE6rOZ;;AyEpsOQ;EAIQ,sBAAA;EAGJ,2EAAA;AzEksOZ;;AyEzsOQ;EAIQ,sBAAA;EAGJ,8EAAA;AzEusOZ;;AyE9sOQ;EAIQ,sBAAA;EAGJ,6EAAA;AzE4sOZ;;AyEntOQ;EAIQ,sBAAA;EAGJ,4EAAA;AzEitOZ;;AyExtOQ;EAIQ,sBAAA;EAGJ,2EAAA;AzEstOZ;;AyE7tOQ;EAIQ,sBAAA;EAGJ,4EAAA;AzE2tOZ;;AyEluOQ;EAIQ,sBAAA;EAGJ,4EAAA;AzEguOZ;;AyEvuOQ;EAOI,wDAAA;AzEouOZ;;AyE3uOQ;EAOI,0DAAA;AzEwuOZ;;AyE/uOQ;EAOI,wDAAA;AzE4uOZ;;AyEnvOQ;EAOI,qDAAA;AzEgvOZ;;AyEvvOQ;EAOI,wDAAA;AzEovOZ;;AyE3vOQ;EAOI,uDAAA;AzEwvOZ;;AyE/vOQ;EAOI,sDAAA;AzE4vOZ;;AyEnwOQ;EAOI,qDAAA;AzEgwOZ;;AyEvwOQ;EAOI,4BAAA;AzEowOZ;;AyE3wOQ;EAOI,4BAAA;AzEwwOZ;;AyE/wOQ;EAOI,4BAAA;AzE4wOZ;;AyEnxOQ;EAOI,4BAAA;AzEgxOZ;;AyEvxOQ;EAOI,4BAAA;AzEoxOZ;;AyEryOQ;EACE,wBAAA;AzEwyOV;;AyEzyOQ;EACE,yBAAA;AzE4yOV;;AyE7yOQ;EACE,wBAAA;AzEgzOV;;AyEjzOQ;EACE,yBAAA;AzEozOV;;AyErzOQ;EACE,sBAAA;AzEwzOV;;AyE/yOQ;EAOI,qBAAA;AzE4yOZ;;AyEnzOQ;EAOI,qBAAA;AzEgzOZ;;AyEvzOQ;EAOI,qBAAA;AzEozOZ;;AyE3zOQ;EAOI,sBAAA;AzEwzOZ;;AyE/zOQ;EAOI,sBAAA;AzE4zOZ;;AyEn0OQ;EAOI,0BAAA;AzEg0OZ;;AyEv0OQ;EAOI,uBAAA;AzEo0OZ;;AyE30OQ;EAOI,2BAAA;AzEw0OZ;;AyE/0OQ;EAOI,sBAAA;AzE40OZ;;AyEn1OQ;EAOI,sBAAA;AzEg1OZ;;AyEv1OQ;EAOI,sBAAA;AzEo1OZ;;AyE31OQ;EAOI,uBAAA;AzEw1OZ;;AyE/1OQ;EAOI,uBAAA;AzE41OZ;;AyEn2OQ;EAOI,2BAAA;AzEg2OZ;;AyEv2OQ;EAOI,wBAAA;AzEo2OZ;;AyE32OQ;EAOI,4BAAA;AzEw2OZ;;AyE/2OQ;EAOI,yBAAA;AzE42OZ;;AyEn3OQ;EAOI,8BAAA;AzEg3OZ;;AyEv3OQ;EAOI,iCAAA;AzEo3OZ;;AyE33OQ;EAOI,sCAAA;AzEw3OZ;;AyE/3OQ;EAOI,yCAAA;AzE43OZ;;AyEn4OQ;EAOI,uBAAA;AzEg4OZ;;AyEv4OQ;EAOI,uBAAA;AzEo4OZ;;AyE34OQ;EAOI,yBAAA;AzEw4OZ;;AyE/4OQ;EAOI,yBAAA;AzE44OZ;;AyEn5OQ;EAOI,0BAAA;AzEg5OZ;;AyEv5OQ;EAOI,4BAAA;AzEo5OZ;;AyE35OQ;EAOI,kCAAA;AzEw5OZ;;AyE/5OQ;EAOI,sCAAA;AzE45OZ;;AyEn6OQ;EAOI,oCAAA;AzEg6OZ;;AyEv6OQ;EAOI,kCAAA;AzEo6OZ;;AyE36OQ;EAOI,yCAAA;AzEw6OZ;;AyE/6OQ;EAOI,wCAAA;AzE46OZ;;AyEn7OQ;EAOI,wCAAA;AzEg7OZ;;AyEv7OQ;EAOI,kCAAA;AzEo7OZ;;AyE37OQ;EAOI,gCAAA;AzEw7OZ;;AyE/7OQ;EAOI,8BAAA;AzE47OZ;;AyEn8OQ;EAOI,gCAAA;AzEg8OZ;;AyEv8OQ;EAOI,+BAAA;AzEo8OZ;;AyE38OQ;EAOI,oCAAA;AzEw8OZ;;AyE/8OQ;EAOI,kCAAA;AzE48OZ;;AyEn9OQ;EAOI,gCAAA;AzEg9OZ;;AyEv9OQ;EAOI,uCAAA;AzEo9OZ;;AyE39OQ;EAOI,sCAAA;AzEw9OZ;;AyE/9OQ;EAOI,iCAAA;AzE49OZ;;AyEn+OQ;EAOI,2BAAA;AzEg+OZ;;AyEv+OQ;EAOI,iCAAA;AzEo+OZ;;AyE3+OQ;EAOI,+BAAA;AzEw+OZ;;AyE/+OQ;EAOI,6BAAA;AzE4+OZ;;AyEn/OQ;EAOI,+BAAA;AzEg/OZ;;AyEv/OQ;EAOI,8BAAA;AzEo/OZ;;AyE3/OQ;EAOI,oBAAA;AzEw/OZ;;AyE//OQ;EAOI,mBAAA;AzE4/OZ;;AyEngPQ;EAOI,mBAAA;AzEggPZ;;AyEvgPQ;EAOI,mBAAA;AzEogPZ;;AyE3gPQ;EAOI,mBAAA;AzEwgPZ;;AyE/gPQ;EAOI,mBAAA;AzE4gPZ;;AyEnhPQ;EAOI,mBAAA;AzEghPZ;;AyEvhPQ;EAOI,mBAAA;AzEohPZ;;AyE3hPQ;EAOI,oBAAA;AzEwhPZ;;AyE/hPQ;EAOI,0BAAA;AzE4hPZ;;AyEniPQ;EAOI,yBAAA;AzEgiPZ;;AyEviPQ;EAOI,uBAAA;AzEoiPZ;;AyE3iPQ;EAOI,yBAAA;AzEwiPZ;;AyE/iPQ;EAOI,uBAAA;AzE4iPZ;;AyEnjPQ;EAOI,uBAAA;AzEgjPZ;;AyEvjPQ;EAOI,0BAAA;EAAA,yBAAA;AzEqjPZ;;AyE5jPQ;EAOI,gCAAA;EAAA,+BAAA;AzE0jPZ;;AyEjkPQ;EAOI,+BAAA;EAAA,8BAAA;AzE+jPZ;;AyEtkPQ;EAOI,6BAAA;EAAA,4BAAA;AzEokPZ;;AyE3kPQ;EAOI,+BAAA;EAAA,8BAAA;AzEykPZ;;AyEhlPQ;EAOI,6BAAA;EAAA,4BAAA;AzE8kPZ;;AyErlPQ;EAOI,6BAAA;EAAA,4BAAA;AzEmlPZ;;AyE1lPQ;EAOI,wBAAA;EAAA,2BAAA;AzEwlPZ;;AyE/lPQ;EAOI,8BAAA;EAAA,iCAAA;AzE6lPZ;;AyEpmPQ;EAOI,6BAAA;EAAA,gCAAA;AzEkmPZ;;AyEzmPQ;EAOI,2BAAA;EAAA,8BAAA;AzEumPZ;;AyE9mPQ;EAOI,6BAAA;EAAA,gCAAA;AzE4mPZ;;AyEnnPQ;EAOI,2BAAA;EAAA,8BAAA;AzEinPZ;;AyExnPQ;EAOI,2BAAA;EAAA,8BAAA;AzEsnPZ;;AyE7nPQ;EAOI,wBAAA;AzE0nPZ;;AyEjoPQ;EAOI,8BAAA;AzE8nPZ;;AyEroPQ;EAOI,6BAAA;AzEkoPZ;;AyEzoPQ;EAOI,2BAAA;AzEsoPZ;;AyE7oPQ;EAOI,6BAAA;AzE0oPZ;;AyEjpPQ;EAOI,2BAAA;AzE8oPZ;;AyErpPQ;EAOI,2BAAA;AzEkpPZ;;AyEzpPQ;EAOI,0BAAA;AzEspPZ;;AyE7pPQ;EAOI,yBAAA;AzEspPZ;;AyE7pPQ;EAOI,gCAAA;AzE0pPZ;;AyEjqPQ;EAOI,+BAAA;AzE0pPZ;;AyEjqPQ;EAOI,+BAAA;AzE8pPZ;;AyErqPQ;EAOI,8BAAA;AzE8pPZ;;AyErqPQ;EAOI,6BAAA;AzEkqPZ;;AyEzqPQ;EAOI,4BAAA;AzEkqPZ;;AyEzqPQ;EAOI,+BAAA;AzEsqPZ;;AyE7qPQ;EAOI,8BAAA;AzEsqPZ;;AyE7qPQ;EAOI,6BAAA;AzE0qPZ;;AyEjrPQ;EAOI,4BAAA;AzE0qPZ;;AyEjrPQ;EAOI,6BAAA;AzE8qPZ;;AyErrPQ;EAOI,4BAAA;AzE8qPZ;;AyErrPQ;EAOI,2BAAA;AzEkrPZ;;AyEzrPQ;EAOI,iCAAA;AzEsrPZ;;AyE7rPQ;EAOI,gCAAA;AzE0rPZ;;AyEjsPQ;EAOI,8BAAA;AzE8rPZ;;AyErsPQ;EAOI,gCAAA;AzEksPZ;;AyEzsPQ;EAOI,8BAAA;AzEssPZ;;AyE7sPQ;EAOI,8BAAA;AzE0sPZ;;AyEjtPQ;EAOI,yBAAA;AzE8sPZ;;AyErtPQ;EAOI,0BAAA;AzE8sPZ;;AyErtPQ;EAOI,+BAAA;AzEktPZ;;AyEztPQ;EAOI,gCAAA;AzEktPZ;;AyEztPQ;EAOI,8BAAA;AzEstPZ;;AyE7tPQ;EAOI,+BAAA;AzEstPZ;;AyE7tPQ;EAOI,4BAAA;AzE0tPZ;;AyEjuPQ;EAOI,6BAAA;AzE0tPZ;;AyEjuPQ;EAOI,8BAAA;AzE8tPZ;;AyEruPQ;EAOI,+BAAA;AzE8tPZ;;AyEruPQ;EAOI,4BAAA;AzEkuPZ;;AyEzuPQ;EAOI,6BAAA;AzEkuPZ;;AyEzuPQ;EAOI,4BAAA;AzEsuPZ;;AyE7uPQ;EAOI,6BAAA;AzEsuPZ;;AyE7uPQ;EAOI,qBAAA;AzE0uPZ;;AyEjvPQ;EAOI,2BAAA;AzE8uPZ;;AyErvPQ;EAOI,0BAAA;AzEkvPZ;;AyEzvPQ;EAOI,wBAAA;AzEsvPZ;;AyE7vPQ;EAOI,0BAAA;AzE0vPZ;;AyEjwPQ;EAOI,wBAAA;AzE8vPZ;;AyErwPQ;EAOI,2BAAA;EAAA,0BAAA;AzEmwPZ;;AyE1wPQ;EAOI,iCAAA;EAAA,gCAAA;AzEwwPZ;;AyE/wPQ;EAOI,gCAAA;EAAA,+BAAA;AzE6wPZ;;AyEpxPQ;EAOI,8BAAA;EAAA,6BAAA;AzEkxPZ;;AyEzxPQ;EAOI,gCAAA;EAAA,+BAAA;AzEuxPZ;;AyE9xPQ;EAOI,8BAAA;EAAA,6BAAA;AzE4xPZ;;AyEnyPQ;EAOI,yBAAA;EAAA,4BAAA;AzEiyPZ;;AyExyPQ;EAOI,+BAAA;EAAA,kCAAA;AzEsyPZ;;AyE7yPQ;EAOI,8BAAA;EAAA,iCAAA;AzE2yPZ;;AyElzPQ;EAOI,4BAAA;EAAA,+BAAA;AzEgzPZ;;AyEvzPQ;EAOI,8BAAA;EAAA,iCAAA;AzEqzPZ;;AyE5zPQ;EAOI,4BAAA;EAAA,+BAAA;AzE0zPZ;;AyEj0PQ;EAOI,yBAAA;AzE8zPZ;;AyEr0PQ;EAOI,+BAAA;AzEk0PZ;;AyEz0PQ;EAOI,8BAAA;AzEs0PZ;;AyE70PQ;EAOI,4BAAA;AzE00PZ;;AyEj1PQ;EAOI,8BAAA;AzE80PZ;;AyEr1PQ;EAOI,4BAAA;AzEk1PZ;;AyEz1PQ;EAOI,2BAAA;AzEs1PZ;;AyE71PQ;EAOI,0BAAA;AzEs1PZ;;AyE71PQ;EAOI,iCAAA;AzE01PZ;;AyEj2PQ;EAOI,gCAAA;AzE01PZ;;AyEj2PQ;EAOI,gCAAA;AzE81PZ;;AyEr2PQ;EAOI,+BAAA;AzE81PZ;;AyEr2PQ;EAOI,8BAAA;AzEk2PZ;;AyEz2PQ;EAOI,6BAAA;AzEk2PZ;;AyEz2PQ;EAOI,gCAAA;AzEs2PZ;;AyE72PQ;EAOI,+BAAA;AzEs2PZ;;AyE72PQ;EAOI,8BAAA;AzE02PZ;;AyEj3PQ;EAOI,6BAAA;AzE02PZ;;AyEj3PQ;EAOI,4BAAA;AzE82PZ;;AyEr3PQ;EAOI,kCAAA;AzEk3PZ;;AyEz3PQ;EAOI,iCAAA;AzEs3PZ;;AyE73PQ;EAOI,+BAAA;AzE03PZ;;AyEj4PQ;EAOI,iCAAA;AzE83PZ;;AyEr4PQ;EAOI,+BAAA;AzEk4PZ;;AyEz4PQ;EAOI,0BAAA;AzEs4PZ;;AyE74PQ;EAOI,2BAAA;AzEs4PZ;;AyE74PQ;EAOI,gCAAA;AzE04PZ;;AyEj5PQ;EAOI,iCAAA;AzE04PZ;;AyEj5PQ;EAOI,+BAAA;AzE84PZ;;AyEr5PQ;EAOI,gCAAA;AzE84PZ;;AyEr5PQ;EAOI,6BAAA;AzEk5PZ;;AyEz5PQ;EAOI,8BAAA;AzEk5PZ;;AyEz5PQ;EAOI,+BAAA;AzEs5PZ;;AyE75PQ;EAOI,gCAAA;AzEs5PZ;;AyE75PQ;EAOI,6BAAA;AzE05PZ;;AyEj6PQ;EAOI,8BAAA;AzE05PZ;;AyEj6PQ;EAOI,iBAAA;AzE85PZ;;AyEr6PQ;EAOI,uBAAA;AzEk6PZ;;AyEz6PQ;EAOI,sBAAA;AzEs6PZ;;AyE76PQ;EAOI,oBAAA;AzE06PZ;;AyEj7PQ;EAOI,sBAAA;AzE86PZ;;AyEr7PQ;EAOI,oBAAA;AzEk7PZ;;AyEz7PQ;EAOI,qBAAA;AzEs7PZ;;AyE77PQ;EAOI,2BAAA;AzE07PZ;;AyEj8PQ;EAOI,0BAAA;AzE87PZ;;AyEr8PQ;EAOI,wBAAA;AzEk8PZ;;AyEz8PQ;EAOI,0BAAA;AzEs8PZ;;AyE78PQ;EAOI,wBAAA;AzE08PZ;;AyEj9PQ;EAOI,6BAAA;OAAA,wBAAA;AzE88PZ;;AyEr9PQ;EAOI,mCAAA;OAAA,8BAAA;AzEk9PZ;;AyEz9PQ;EAOI,kCAAA;OAAA,6BAAA;AzEs9PZ;;AyE79PQ;EAOI,gCAAA;OAAA,2BAAA;AzE09PZ;;AyEj+PQ;EAOI,kCAAA;OAAA,6BAAA;AzE89PZ;;AyEr+PQ;EAOI,gCAAA;OAAA,2BAAA;AzEk+PZ;;AyEz+PQ;EAOI,gDAAA;AzEs+PZ;;AyE7+PQ;EAOI,4CAAA;AzE0+PZ;;AyEj/PQ;EAOI,4CAAA;AzE8+PZ;;AyEr/PQ;EAOI,0CAAA;AzEk/PZ;;AyEz/PQ;EAOI,4CAAA;AzEs/PZ;;AyE7/PQ;EAOI,6BAAA;AzE0/PZ;;AyEjgQQ;EAOI,0BAAA;AzE8/PZ;;AyErgQQ;EAOI,6BAAA;AzEkgQZ;;AyEzgQQ;EAOI,6BAAA;AzEsgQZ;;AyE7gQQ;EAOI,+BAAA;AzE0gQZ;;AyEjhQQ;EAOI,2BAAA;AzE8gQZ;;AyErhQQ;EAOI,2BAAA;AzEkhQZ;;AyEzhQQ;EAOI,2BAAA;AzEshQZ;;AyE7hQQ;EAOI,2BAAA;AzE0hQZ;;AyEjiQQ;EAOI,2BAAA;AzE8hQZ;;AyEriQQ;EAOI,8BAAA;AzEkiQZ;;AyEziQQ;EAOI,yBAAA;AzEsiQZ;;AyE7iQQ;EAOI,4BAAA;AzE0iQZ;;AyEjjQQ;EAOI,2BAAA;AzE8iQZ;;AyErjQQ;EAOI,yBAAA;AzEkjQZ;;AyEzjQQ;EAOI,2BAAA;AzEsjQZ;;AyE7jQQ;EAOI,4BAAA;AzEsjQZ;;AyE7jQQ;EAOI,4BAAA;AzE0jQZ;;AyEjkQQ;EAOI,2BAAA;AzE0jQZ;;AyEjkQQ;EAOI,6BAAA;AzE8jQZ;;AyErkQQ;EAOI,gCAAA;AzEkkQZ;;AyEzkQQ;EAOI,qCAAA;AzEskQZ;;AyE7kQQ;EAOI,wCAAA;AzE0kQZ;;AyEjlQQ;EAOI,oCAAA;AzE8kQZ;;AyErlQQ;EAOI,oCAAA;AzEklQZ;;AyEzlQQ;EAOI,qCAAA;AzEslQZ;;AyE7lQQ;EAOI,8BAAA;AzE0lQZ;;AyEjmQQ;EAOI,8BAAA;AzE8lQZ;;AyEnnQQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AzEomQZ;;AyEjlQQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AzE0mQZ;;AyEjnQQ;EAIQ,oBAAA;EAGJ,uEAAA;AzE+mQZ;;AyEtnQQ;EAIQ,oBAAA;EAGJ,qEAAA;AzEonQZ;;AyE3nQQ;EAIQ,oBAAA;EAGJ,kEAAA;AzEynQZ;;AyEhoQQ;EAIQ,oBAAA;EAGJ,qEAAA;AzE8nQZ;;AyEroQQ;EAIQ,oBAAA;EAGJ,oEAAA;AzEmoQZ;;AyE1oQQ;EAIQ,oBAAA;EAGJ,mEAAA;AzEwoQZ;;AyE/oQQ;EAIQ,oBAAA;EAGJ,kEAAA;AzE6oQZ;;AyEppQQ;EAIQ,oBAAA;EAGJ,mEAAA;AzEkpQZ;;AyEzpQQ;EAIQ,oBAAA;EAGJ,mEAAA;AzEupQZ;;AyE9pQQ;EAIQ,oBAAA;EAGJ,wEAAA;AzE4pQZ;;AyEnqQQ;EAIQ,oBAAA;EAGJ,2CAAA;AzEiqQZ;;AyExqQQ;EAIQ,oBAAA;EAGJ,oCAAA;AzEsqQZ;;AyE7qQQ;EAIQ,oBAAA;EAGJ,0CAAA;AzE2qQZ;;AyElrQQ;EAIQ,oBAAA;EAGJ,2CAAA;AzEgrQZ;;AyEvrQQ;EAIQ,oBAAA;EAGJ,0CAAA;AzEqrQZ;;AyE5rQQ;EAIQ,oBAAA;EAGJ,0CAAA;AzE0rQZ;;AyEjsQQ;EAIQ,oBAAA;EAGJ,yBAAA;AzE+rQZ;;AyEhtQQ;EACE,uBAAA;AzEmtQV;;AyEptQQ;EACE,sBAAA;AzEutQV;;AyExtQQ;EACE,uBAAA;AzE2tQV;;AyE5tQQ;EACE,oBAAA;AzE+tQV;;AyEttQQ;EAOI,iDAAA;AzEmtQZ;;AyE1tQQ;EAOI,mDAAA;AzEutQZ;;AyE9tQQ;EAOI,iDAAA;AzE2tQZ;;AyEluQQ;EAOI,8CAAA;AzE+tQZ;;AyEtuQQ;EAOI,iDAAA;AzEmuQZ;;AyE1uQQ;EAOI,gDAAA;AzEuuQZ;;AyE9uQQ;EAOI,+CAAA;AzE2uQZ;;AyElvQQ;EAOI,8CAAA;AzE+uQZ;;AyEhwQQ;EACE,sBAAA;AzEmwQV;;AyE/vQU;EACE,sBAAA;AzEkwQZ;;AyExwQQ;EACE,uBAAA;AzE2wQV;;AyEvwQU;EACE,uBAAA;AzE0wQZ;;AyEhxQQ;EACE,sBAAA;AzEmxQV;;AyE/wQU;EACE,sBAAA;AzEkxQZ;;AyExxQQ;EACE,uBAAA;AzE2xQV;;AyEvxQU;EACE,uBAAA;AzE0xQZ;;AyEhyQQ;EACE,oBAAA;AzEmyQV;;AyE/xQU;EACE,oBAAA;AzEkyQZ;;AyE9xQQ;EAOI,yCAAA;AzE2xQZ;;AyEtxQU;EAOI,yCAAA;AzEmxQd;;AyEtyQQ;EAOI,wCAAA;AzEmyQZ;;AyE9xQU;EAOI,wCAAA;AzE2xQd;;AyE9yQQ;EAOI,yCAAA;AzE2yQZ;;AyEtyQU;EAOI,yCAAA;AzEmyQd;;AyEtzQQ;EAIQ,8BAAA;EAGJ,+FAAA;AzEozQZ;;AyE3zQQ;EAIQ,8BAAA;EAGJ,iGAAA;AzEyzQZ;;AyEh0QQ;EAIQ,8BAAA;EAGJ,+FAAA;AzE8zQZ;;AyEr0QQ;EAIQ,8BAAA;EAGJ,4FAAA;AzEm0QZ;;AyE10QQ;EAIQ,8BAAA;EAGJ,+FAAA;AzEw0QZ;;AyE/0QQ;EAIQ,8BAAA;EAGJ,8FAAA;AzE60QZ;;AyEp1QQ;EAIQ,8BAAA;EAGJ,6FAAA;AzEk1QZ;;AyEz1QQ;EAIQ,8BAAA;EAGJ,4FAAA;AzEu1QZ;;AyE91QQ;EAIQ,8BAAA;EAGJ,qGAAA;AzE41QZ;;AyE72QQ;EACE,8BAAA;AzEg3QV;;AyE52QU;EACE,8BAAA;AzE+2QZ;;AyEr3QQ;EACE,gCAAA;AzEw3QV;;AyEp3QU;EACE,gCAAA;AzEu3QZ;;AyE73QQ;EACE,iCAAA;AzEg4QV;;AyE53QU;EACE,iCAAA;AzE+3QZ;;AyEr4QQ;EACE,gCAAA;AzEw4QV;;AyEp4QU;EACE,gCAAA;AzEu4QZ;;AyE74QQ;EACE,iCAAA;AzEg5QV;;AyE54QU;EACE,iCAAA;AzE+4QZ;;AyEr5QQ;EACE,8BAAA;AzEw5QV;;AyEp5QU;EACE,8BAAA;AzEu5QZ;;AyEn5QQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEi5QZ;;AyEx5QQ;EAIQ,kBAAA;EAGJ,gFAAA;AzEs5QZ;;AyE75QQ;EAIQ,kBAAA;EAGJ,8EAAA;AzE25QZ;;AyEl6QQ;EAIQ,kBAAA;EAGJ,2EAAA;AzEg6QZ;;AyEv6QQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEq6QZ;;AyE56QQ;EAIQ,kBAAA;EAGJ,6EAAA;AzE06QZ;;AyEj7QQ;EAIQ,kBAAA;EAGJ,4EAAA;AzE+6QZ;;AyEt7QQ;EAIQ,kBAAA;EAGJ,2EAAA;AzEo7QZ;;AyE37QQ;EAIQ,kBAAA;EAGJ,4EAAA;AzEy7QZ;;AyEh8QQ;EAIQ,kBAAA;EAGJ,4EAAA;AzE87QZ;;AyEr8QQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEm8QZ;;AyE18QQ;EAIQ,kBAAA;EAGJ,wCAAA;AzEw8QZ;;AyE/8QQ;EAIQ,kBAAA;EAGJ,mFAAA;AzE68QZ;;AyEp9QQ;EAIQ,kBAAA;EAGJ,kFAAA;AzEk9QZ;;AyEn+QQ;EACE,oBAAA;AzEs+QV;;AyEv+QQ;EACE,qBAAA;AzE0+QV;;AyE3+QQ;EACE,oBAAA;AzE8+QV;;AyE/+QQ;EACE,qBAAA;AzEk/QV;;AyEn/QQ;EACE,kBAAA;AzEs/QV;;AyE7+QQ;EAOI,wDAAA;AzE0+QZ;;AyEj/QQ;EAOI,0DAAA;AzE8+QZ;;AyEr/QQ;EAOI,wDAAA;AzEk/QZ;;AyEz/QQ;EAOI,qDAAA;AzEs/QZ;;AyE7/QQ;EAOI,wDAAA;AzE0/QZ;;AyEjgRQ;EAOI,uDAAA;AzE8/QZ;;AyErgRQ;EAOI,sDAAA;AzEkgRZ;;AyEzgRQ;EAOI,qDAAA;AzEsgRZ;;AyE7gRQ;EAOI,+CAAA;AzE0gRZ;;AyEjhRQ;EAOI,mCAAA;KAAA,gCAAA;UAAA,2BAAA;AzE8gRZ;;AyErhRQ;EAOI,oCAAA;KAAA,iCAAA;UAAA,4BAAA;AzEkhRZ;;AyEzhRQ;EAOI,oCAAA;KAAA,iCAAA;UAAA,4BAAA;AzEshRZ;;AyE7hRQ;EAOI,+BAAA;AzE0hRZ;;AyEjiRQ;EAOI,+BAAA;AzE8hRZ;;AyEriRQ;EAOI,iDAAA;AzEkiRZ;;AyEziRQ;EAOI,2BAAA;AzEsiRZ;;AyE7iRQ;EAOI,oDAAA;AzE0iRZ;;AyEjjRQ;EAOI,iDAAA;AzE8iRZ;;AyErjRQ;EAOI,oDAAA;AzEkjRZ;;AyEzjRQ;EAOI,oDAAA;AzEsjRZ;;AyE7jRQ;EAOI,qDAAA;AzE0jRZ;;AyEjkRQ;EAOI,6BAAA;AzE8jRZ;;AyErkRQ;EAOI,sDAAA;AzEkkRZ;;AyEzkRQ;EAOI,0DAAA;EAAA,2DAAA;AzEukRZ;;AyE9kRQ;EAOI,oCAAA;EAAA,qCAAA;AzE4kRZ;;AyEnlRQ;EAOI,6DAAA;EAAA,8DAAA;AzEilRZ;;AyExlRQ;EAOI,0DAAA;EAAA,2DAAA;AzEslRZ;;AyE7lRQ;EAOI,6DAAA;EAAA,8DAAA;AzE2lRZ;;AyElmRQ;EAOI,6DAAA;EAAA,8DAAA;AzEgmRZ;;AyEvmRQ;EAOI,8DAAA;EAAA,+DAAA;AzEqmRZ;;AyE5mRQ;EAOI,sCAAA;EAAA,uCAAA;AzE0mRZ;;AyEjnRQ;EAOI,+DAAA;EAAA,gEAAA;AzE+mRZ;;AyEtnRQ;EAOI,2DAAA;EAAA,8DAAA;AzEonRZ;;AyE3nRQ;EAOI,0DAAA;EAAA,6DAAA;AzEonRZ;;AyE3nRQ;EAOI,qCAAA;EAAA,wCAAA;AzEynRZ;;AyEhoRQ;EAOI,oCAAA;EAAA,uCAAA;AzEynRZ;;AyEhoRQ;EAOI,8DAAA;EAAA,iEAAA;AzE8nRZ;;AyEroRQ;EAOI,6DAAA;EAAA,gEAAA;AzE8nRZ;;AyEroRQ;EAOI,2DAAA;EAAA,8DAAA;AzEmoRZ;;AyE1oRQ;EAOI,0DAAA;EAAA,6DAAA;AzEmoRZ;;AyE1oRQ;EAOI,8DAAA;EAAA,iEAAA;AzEwoRZ;;AyE/oRQ;EAOI,6DAAA;EAAA,gEAAA;AzEwoRZ;;AyE/oRQ;EAOI,8DAAA;EAAA,iEAAA;AzE6oRZ;;AyEppRQ;EAOI,6DAAA;EAAA,gEAAA;AzE6oRZ;;AyEppRQ;EAOI,+DAAA;EAAA,kEAAA;AzEkpRZ;;AyEzpRQ;EAOI,8DAAA;EAAA,iEAAA;AzEkpRZ;;AyEzpRQ;EAOI,uCAAA;EAAA,0CAAA;AzEupRZ;;AyE9pRQ;EAOI,sCAAA;EAAA,yCAAA;AzEupRZ;;AyE9pRQ;EAOI,gEAAA;EAAA,mEAAA;AzE4pRZ;;AyEnqRQ;EAOI,+DAAA;EAAA,kEAAA;AzE4pRZ;;AyEnqRQ;EAOI,8DAAA;EAAA,6DAAA;AzEiqRZ;;AyExqRQ;EAOI,wCAAA;EAAA,uCAAA;AzEsqRZ;;AyE7qRQ;EAOI,iEAAA;EAAA,gEAAA;AzE2qRZ;;AyElrRQ;EAOI,8DAAA;EAAA,6DAAA;AzEgrRZ;;AyEvrRQ;EAOI,iEAAA;EAAA,gEAAA;AzEqrRZ;;AyE5rRQ;EAOI,iEAAA;EAAA,gEAAA;AzE0rRZ;;AyEjsRQ;EAOI,kEAAA;EAAA,iEAAA;AzE+rRZ;;AyEtsRQ;EAOI,0CAAA;EAAA,yCAAA;AzEosRZ;;AyE3sRQ;EAOI,mEAAA;EAAA,kEAAA;AzEysRZ;;AyEhtRQ;EAOI,6DAAA;EAAA,0DAAA;AzE8sRZ;;AyErtRQ;EAOI,8DAAA;EAAA,2DAAA;AzE8sRZ;;AyErtRQ;EAOI,uCAAA;EAAA,oCAAA;AzEmtRZ;;AyE1tRQ;EAOI,wCAAA;EAAA,qCAAA;AzEmtRZ;;AyE1tRQ;EAOI,gEAAA;EAAA,6DAAA;AzEwtRZ;;AyE/tRQ;EAOI,iEAAA;EAAA,8DAAA;AzEwtRZ;;AyE/tRQ;EAOI,6DAAA;EAAA,0DAAA;AzE6tRZ;;AyEpuRQ;EAOI,8DAAA;EAAA,2DAAA;AzE6tRZ;;AyEpuRQ;EAOI,gEAAA;EAAA,6DAAA;AzEkuRZ;;AyEzuRQ;EAOI,iEAAA;EAAA,8DAAA;AzEkuRZ;;AyEzuRQ;EAOI,gEAAA;EAAA,6DAAA;AzEuuRZ;;AyE9uRQ;EAOI,iEAAA;EAAA,8DAAA;AzEuuRZ;;AyE9uRQ;EAOI,iEAAA;EAAA,8DAAA;AzE4uRZ;;AyEnvRQ;EAOI,kEAAA;EAAA,+DAAA;AzE4uRZ;;AyEnvRQ;EAOI,yCAAA;EAAA,sCAAA;AzEivRZ;;AyExvRQ;EAOI,0CAAA;EAAA,uCAAA;AzEivRZ;;AyExvRQ;EAOI,kEAAA;EAAA,+DAAA;AzEsvRZ;;AyE7vRQ;EAOI,mEAAA;EAAA,gEAAA;AzEsvRZ;;AyE7vRQ;EAOI,8BAAA;AzE0vRZ;;AyEjwRQ;EAOI,6BAAA;AzE8vRZ;;AyErwRQ;EAOI,sBAAA;AzEkwRZ;;AyEzwRQ;EAOI,qBAAA;AzEswRZ;;AyE7wRQ;EAOI,qBAAA;AzE0wRZ;;AyEjxRQ;EAOI,qBAAA;AzE8wRZ;;AyErxRQ;EAOI,qBAAA;AzEkxRZ;;Ae5xRI;E0DGI;IAOI,sBAAA;EzEuxRV;;EyE9xRM;IAOI,uBAAA;EzEuxRV;;EyE9xRM;IAOI,uBAAA;EzE0xRV;;EyEjyRM;IAOI,sBAAA;EzE0xRV;;EyEjyRM;IAOI,sBAAA;EzE6xRV;;EyEpyRM;IAOI,iCAAA;OAAA,8BAAA;EzEgyRV;;EyEvyRM;IAOI,+BAAA;OAAA,4BAAA;EzEmyRV;;EyE1yRM;IAOI,8BAAA;OAAA,2BAAA;EzEsyRV;;EyE7yRM;IAOI,oCAAA;OAAA,iCAAA;EzEyyRV;;EyEhzRM;IAOI,8BAAA;OAAA,2BAAA;EzE4yRV;;EyEnzRM;IAOI,0BAAA;EzE+yRV;;EyEtzRM;IAOI,gCAAA;EzEkzRV;;EyEzzRM;IAOI,yBAAA;EzEqzRV;;EyE5zRM;IAOI,wBAAA;EzEwzRV;;EyE/zRM;IAOI,+BAAA;EzE2zRV;;EyEl0RM;IAOI,yBAAA;EzE8zRV;;EyEr0RM;IAOI,6BAAA;EzEi0RV;;EyEx0RM;IAOI,8BAAA;EzEo0RV;;EyE30RM;IAOI,wBAAA;EzEu0RV;;EyE90RM;IAOI,+BAAA;EzE00RV;;EyEj1RM;IAOI,wBAAA;EzE60RV;;EyEp1RM;IAOI,yBAAA;EzEg1RV;;EyEv1RM;IAOI,8BAAA;EzEm1RV;;EyE11RM;IAOI,iCAAA;EzEs1RV;;EyE71RM;IAOI,sCAAA;EzEy1RV;;EyEh2RM;IAOI,yCAAA;EzE41RV;;EyEn2RM;IAOI,uBAAA;EzE+1RV;;EyEt2RM;IAOI,uBAAA;EzEk2RV;;EyEz2RM;IAOI,yBAAA;EzEq2RV;;EyE52RM;IAOI,yBAAA;EzEw2RV;;EyE/2RM;IAOI,0BAAA;EzE22RV;;EyEl3RM;IAOI,4BAAA;EzE82RV;;EyEr3RM;IAOI,kCAAA;EzEi3RV;;EyEx3RM;IAOI,sCAAA;EzEo3RV;;EyE33RM;IAOI,oCAAA;EzEu3RV;;EyE93RM;IAOI,kCAAA;EzE03RV;;EyEj4RM;IAOI,yCAAA;EzE63RV;;EyEp4RM;IAOI,wCAAA;EzEg4RV;;EyEv4RM;IAOI,wCAAA;EzEm4RV;;EyE14RM;IAOI,kCAAA;EzEs4RV;;EyE74RM;IAOI,gCAAA;EzEy4RV;;EyEh5RM;IAOI,8BAAA;EzE44RV;;EyEn5RM;IAOI,gCAAA;EzE+4RV;;EyEt5RM;IAOI,+BAAA;EzEk5RV;;EyEz5RM;IAOI,oCAAA;EzEq5RV;;EyE55RM;IAOI,kCAAA;EzEw5RV;;EyE/5RM;IAOI,gCAAA;EzE25RV;;EyEl6RM;IAOI,uCAAA;EzE85RV;;EyEr6RM;IAOI,sCAAA;EzEi6RV;;EyEx6RM;IAOI,iCAAA;EzEo6RV;;EyE36RM;IAOI,2BAAA;EzEu6RV;;EyE96RM;IAOI,iCAAA;EzE06RV;;EyEj7RM;IAOI,+BAAA;EzE66RV;;EyEp7RM;IAOI,6BAAA;EzEg7RV;;EyEv7RM;IAOI,+BAAA;EzEm7RV;;EyE17RM;IAOI,8BAAA;EzEs7RV;;EyE77RM;IAOI,oBAAA;EzEy7RV;;EyEh8RM;IAOI,mBAAA;EzE47RV;;EyEn8RM;IAOI,mBAAA;EzE+7RV;;EyEt8RM;IAOI,mBAAA;EzEk8RV;;EyEz8RM;IAOI,mBAAA;EzEq8RV;;EyE58RM;IAOI,mBAAA;EzEw8RV;;EyE/8RM;IAOI,mBAAA;EzE28RV;;EyEl9RM;IAOI,mBAAA;EzE88RV;;EyEr9RM;IAOI,oBAAA;EzEi9RV;;EyEx9RM;IAOI,0BAAA;EzEo9RV;;EyE39RM;IAOI,yBAAA;EzEu9RV;;EyE99RM;IAOI,uBAAA;EzE09RV;;EyEj+RM;IAOI,yBAAA;EzE69RV;;EyEp+RM;IAOI,uBAAA;EzEg+RV;;EyEv+RM;IAOI,uBAAA;EzEm+RV;;EyE1+RM;IAOI,0BAAA;IAAA,yBAAA;EzEu+RV;;EyE9+RM;IAOI,gCAAA;IAAA,+BAAA;EzE2+RV;;EyEl/RM;IAOI,+BAAA;IAAA,8BAAA;EzE++RV;;EyEt/RM;IAOI,6BAAA;IAAA,4BAAA;EzEm/RV;;EyE1/RM;IAOI,+BAAA;IAAA,8BAAA;EzEu/RV;;EyE9/RM;IAOI,6BAAA;IAAA,4BAAA;EzE2/RV;;EyElgSM;IAOI,6BAAA;IAAA,4BAAA;EzE+/RV;;EyEtgSM;IAOI,wBAAA;IAAA,2BAAA;EzEmgSV;;EyE1gSM;IAOI,8BAAA;IAAA,iCAAA;EzEugSV;;EyE9gSM;IAOI,6BAAA;IAAA,gCAAA;EzE2gSV;;EyElhSM;IAOI,2BAAA;IAAA,8BAAA;EzE+gSV;;EyEthSM;IAOI,6BAAA;IAAA,gCAAA;EzEmhSV;;EyE1hSM;IAOI,2BAAA;IAAA,8BAAA;EzEuhSV;;EyE9hSM;IAOI,2BAAA;IAAA,8BAAA;EzE2hSV;;EyEliSM;IAOI,wBAAA;EzE8hSV;;EyEriSM;IAOI,8BAAA;EzEiiSV;;EyExiSM;IAOI,6BAAA;EzEoiSV;;EyE3iSM;IAOI,2BAAA;EzEuiSV;;EyE9iSM;IAOI,6BAAA;EzE0iSV;;EyEjjSM;IAOI,2BAAA;EzE6iSV;;EyEpjSM;IAOI,2BAAA;EzEgjSV;;EyEvjSM;IAOI,0BAAA;EzEmjSV;;EyE1jSM;IAOI,yBAAA;EzEmjSV;;EyE1jSM;IAOI,gCAAA;EzEsjSV;;EyE7jSM;IAOI,+BAAA;EzEsjSV;;EyE7jSM;IAOI,+BAAA;EzEyjSV;;EyEhkSM;IAOI,8BAAA;EzEyjSV;;EyEhkSM;IAOI,6BAAA;EzE4jSV;;EyEnkSM;IAOI,4BAAA;EzE4jSV;;EyEnkSM;IAOI,+BAAA;EzE+jSV;;EyEtkSM;IAOI,8BAAA;EzE+jSV;;EyEtkSM;IAOI,6BAAA;EzEkkSV;;EyEzkSM;IAOI,4BAAA;EzEkkSV;;EyEzkSM;IAOI,6BAAA;EzEqkSV;;EyE5kSM;IAOI,4BAAA;EzEqkSV;;EyE5kSM;IAOI,2BAAA;EzEwkSV;;EyE/kSM;IAOI,iCAAA;EzE2kSV;;EyEllSM;IAOI,gCAAA;EzE8kSV;;EyErlSM;IAOI,8BAAA;EzEilSV;;EyExlSM;IAOI,gCAAA;EzEolSV;;EyE3lSM;IAOI,8BAAA;EzEulSV;;EyE9lSM;IAOI,8BAAA;EzE0lSV;;EyEjmSM;IAOI,yBAAA;EzE6lSV;;EyEpmSM;IAOI,0BAAA;EzE6lSV;;EyEpmSM;IAOI,+BAAA;EzEgmSV;;EyEvmSM;IAOI,gCAAA;EzEgmSV;;EyEvmSM;IAOI,8BAAA;EzEmmSV;;EyE1mSM;IAOI,+BAAA;EzEmmSV;;EyE1mSM;IAOI,4BAAA;EzEsmSV;;EyE7mSM;IAOI,6BAAA;EzEsmSV;;EyE7mSM;IAOI,8BAAA;EzEymSV;;EyEhnSM;IAOI,+BAAA;EzEymSV;;EyEhnSM;IAOI,4BAAA;EzE4mSV;;EyEnnSM;IAOI,6BAAA;EzE4mSV;;EyEnnSM;IAOI,4BAAA;EzE+mSV;;EyEtnSM;IAOI,6BAAA;EzE+mSV;;EyEtnSM;IAOI,qBAAA;EzEknSV;;EyEznSM;IAOI,2BAAA;EzEqnSV;;EyE5nSM;IAOI,0BAAA;EzEwnSV;;EyE/nSM;IAOI,wBAAA;EzE2nSV;;EyEloSM;IAOI,0BAAA;EzE8nSV;;EyEroSM;IAOI,wBAAA;EzEioSV;;EyExoSM;IAOI,2BAAA;IAAA,0BAAA;EzEqoSV;;EyE5oSM;IAOI,iCAAA;IAAA,gCAAA;EzEyoSV;;EyEhpSM;IAOI,gCAAA;IAAA,+BAAA;EzE6oSV;;EyEppSM;IAOI,8BAAA;IAAA,6BAAA;EzEipSV;;EyExpSM;IAOI,gCAAA;IAAA,+BAAA;EzEqpSV;;EyE5pSM;IAOI,8BAAA;IAAA,6BAAA;EzEypSV;;EyEhqSM;IAOI,yBAAA;IAAA,4BAAA;EzE6pSV;;EyEpqSM;IAOI,+BAAA;IAAA,kCAAA;EzEiqSV;;EyExqSM;IAOI,8BAAA;IAAA,iCAAA;EzEqqSV;;EyE5qSM;IAOI,4BAAA;IAAA,+BAAA;EzEyqSV;;EyEhrSM;IAOI,8BAAA;IAAA,iCAAA;EzE6qSV;;EyEprSM;IAOI,4BAAA;IAAA,+BAAA;EzEirSV;;EyExrSM;IAOI,yBAAA;EzEorSV;;EyE3rSM;IAOI,+BAAA;EzEurSV;;EyE9rSM;IAOI,8BAAA;EzE0rSV;;EyEjsSM;IAOI,4BAAA;EzE6rSV;;EyEpsSM;IAOI,8BAAA;EzEgsSV;;EyEvsSM;IAOI,4BAAA;EzEmsSV;;EyE1sSM;IAOI,2BAAA;EzEssSV;;EyE7sSM;IAOI,0BAAA;EzEssSV;;EyE7sSM;IAOI,iCAAA;EzEysSV;;EyEhtSM;IAOI,gCAAA;EzEysSV;;EyEhtSM;IAOI,gCAAA;EzE4sSV;;EyEntSM;IAOI,+BAAA;EzE4sSV;;EyEntSM;IAOI,8BAAA;EzE+sSV;;EyEttSM;IAOI,6BAAA;EzE+sSV;;EyEttSM;IAOI,gCAAA;EzEktSV;;EyEztSM;IAOI,+BAAA;EzEktSV;;EyEztSM;IAOI,8BAAA;EzEqtSV;;EyE5tSM;IAOI,6BAAA;EzEqtSV;;EyE5tSM;IAOI,4BAAA;EzEwtSV;;EyE/tSM;IAOI,kCAAA;EzE2tSV;;EyEluSM;IAOI,iCAAA;EzE8tSV;;EyEruSM;IAOI,+BAAA;EzEiuSV;;EyExuSM;IAOI,iCAAA;EzEouSV;;EyE3uSM;IAOI,+BAAA;EzEuuSV;;EyE9uSM;IAOI,0BAAA;EzE0uSV;;EyEjvSM;IAOI,2BAAA;EzE0uSV;;EyEjvSM;IAOI,gCAAA;EzE6uSV;;EyEpvSM;IAOI,iCAAA;EzE6uSV;;EyEpvSM;IAOI,+BAAA;EzEgvSV;;EyEvvSM;IAOI,gCAAA;EzEgvSV;;EyEvvSM;IAOI,6BAAA;EzEmvSV;;EyE1vSM;IAOI,8BAAA;EzEmvSV;;EyE1vSM;IAOI,+BAAA;EzEsvSV;;EyE7vSM;IAOI,gCAAA;EzEsvSV;;EyE7vSM;IAOI,6BAAA;EzEyvSV;;EyEhwSM;IAOI,8BAAA;EzEyvSV;;EyEhwSM;IAOI,iBAAA;EzE4vSV;;EyEnwSM;IAOI,uBAAA;EzE+vSV;;EyEtwSM;IAOI,sBAAA;EzEkwSV;;EyEzwSM;IAOI,oBAAA;EzEqwSV;;EyE5wSM;IAOI,sBAAA;EzEwwSV;;EyE/wSM;IAOI,oBAAA;EzE2wSV;;EyElxSM;IAOI,qBAAA;EzE8wSV;;EyErxSM;IAOI,2BAAA;EzEixSV;;EyExxSM;IAOI,0BAAA;EzEoxSV;;EyE3xSM;IAOI,wBAAA;EzEuxSV;;EyE9xSM;IAOI,0BAAA;EzE0xSV;;EyEjySM;IAOI,wBAAA;EzE6xSV;;EyEpySM;IAOI,6BAAA;SAAA,wBAAA;EzEgySV;;EyEvySM;IAOI,mCAAA;SAAA,8BAAA;EzEmySV;;EyE1ySM;IAOI,kCAAA;SAAA,6BAAA;EzEsySV;;EyE7ySM;IAOI,gCAAA;SAAA,2BAAA;EzEyySV;;EyEhzSM;IAOI,kCAAA;SAAA,6BAAA;EzE4ySV;;EyEnzSM;IAOI,gCAAA;SAAA,2BAAA;EzE+ySV;;EyEtzSM;IAOI,2BAAA;EzEkzSV;;EyEzzSM;IAOI,4BAAA;EzEkzSV;;EyEzzSM;IAOI,4BAAA;EzEqzSV;;EyE5zSM;IAOI,2BAAA;EzEqzSV;;EyE5zSM;IAOI,6BAAA;EzEwzSV;AACF;;Aen0SI;E0DGI;IAOI,sBAAA;EzE6zSV;;EyEp0SM;IAOI,uBAAA;EzE6zSV;;EyEp0SM;IAOI,uBAAA;EzEg0SV;;EyEv0SM;IAOI,sBAAA;EzEg0SV;;EyEv0SM;IAOI,sBAAA;EzEm0SV;;EyE10SM;IAOI,iCAAA;OAAA,8BAAA;EzEs0SV;;EyE70SM;IAOI,+BAAA;OAAA,4BAAA;EzEy0SV;;EyEh1SM;IAOI,8BAAA;OAAA,2BAAA;EzE40SV;;EyEn1SM;IAOI,oCAAA;OAAA,iCAAA;EzE+0SV;;EyEt1SM;IAOI,8BAAA;OAAA,2BAAA;EzEk1SV;;EyEz1SM;IAOI,0BAAA;EzEq1SV;;EyE51SM;IAOI,gCAAA;EzEw1SV;;EyE/1SM;IAOI,yBAAA;EzE21SV;;EyEl2SM;IAOI,wBAAA;EzE81SV;;EyEr2SM;IAOI,+BAAA;EzEi2SV;;EyEx2SM;IAOI,yBAAA;EzEo2SV;;EyE32SM;IAOI,6BAAA;EzEu2SV;;EyE92SM;IAOI,8BAAA;EzE02SV;;EyEj3SM;IAOI,wBAAA;EzE62SV;;EyEp3SM;IAOI,+BAAA;EzEg3SV;;EyEv3SM;IAOI,wBAAA;EzEm3SV;;EyE13SM;IAOI,yBAAA;EzEs3SV;;EyE73SM;IAOI,8BAAA;EzEy3SV;;EyEh4SM;IAOI,iCAAA;EzE43SV;;EyEn4SM;IAOI,sCAAA;EzE+3SV;;EyEt4SM;IAOI,yCAAA;EzEk4SV;;EyEz4SM;IAOI,uBAAA;EzEq4SV;;EyE54SM;IAOI,uBAAA;EzEw4SV;;EyE/4SM;IAOI,yBAAA;EzE24SV;;EyEl5SM;IAOI,yBAAA;EzE84SV;;EyEr5SM;IAOI,0BAAA;EzEi5SV;;EyEx5SM;IAOI,4BAAA;EzEo5SV;;EyE35SM;IAOI,kCAAA;EzEu5SV;;EyE95SM;IAOI,sCAAA;EzE05SV;;EyEj6SM;IAOI,oCAAA;EzE65SV;;EyEp6SM;IAOI,kCAAA;EzEg6SV;;EyEv6SM;IAOI,yCAAA;EzEm6SV;;EyE16SM;IAOI,wCAAA;EzEs6SV;;EyE76SM;IAOI,wCAAA;EzEy6SV;;EyEh7SM;IAOI,kCAAA;EzE46SV;;EyEn7SM;IAOI,gCAAA;EzE+6SV;;EyEt7SM;IAOI,8BAAA;EzEk7SV;;EyEz7SM;IAOI,gCAAA;EzEq7SV;;EyE57SM;IAOI,+BAAA;EzEw7SV;;EyE/7SM;IAOI,oCAAA;EzE27SV;;EyEl8SM;IAOI,kCAAA;EzE87SV;;EyEr8SM;IAOI,gCAAA;EzEi8SV;;EyEx8SM;IAOI,uCAAA;EzEo8SV;;EyE38SM;IAOI,sCAAA;EzEu8SV;;EyE98SM;IAOI,iCAAA;EzE08SV;;EyEj9SM;IAOI,2BAAA;EzE68SV;;EyEp9SM;IAOI,iCAAA;EzEg9SV;;EyEv9SM;IAOI,+BAAA;EzEm9SV;;EyE19SM;IAOI,6BAAA;EzEs9SV;;EyE79SM;IAOI,+BAAA;EzEy9SV;;EyEh+SM;IAOI,8BAAA;EzE49SV;;EyEn+SM;IAOI,oBAAA;EzE+9SV;;EyEt+SM;IAOI,mBAAA;EzEk+SV;;EyEz+SM;IAOI,mBAAA;EzEq+SV;;EyE5+SM;IAOI,mBAAA;EzEw+SV;;EyE/+SM;IAOI,mBAAA;EzE2+SV;;EyEl/SM;IAOI,mBAAA;EzE8+SV;;EyEr/SM;IAOI,mBAAA;EzEi/SV;;EyEx/SM;IAOI,mBAAA;EzEo/SV;;EyE3/SM;IAOI,oBAAA;EzEu/SV;;EyE9/SM;IAOI,0BAAA;EzE0/SV;;EyEjgTM;IAOI,yBAAA;EzE6/SV;;EyEpgTM;IAOI,uBAAA;EzEggTV;;EyEvgTM;IAOI,yBAAA;EzEmgTV;;EyE1gTM;IAOI,uBAAA;EzEsgTV;;EyE7gTM;IAOI,uBAAA;EzEygTV;;EyEhhTM;IAOI,0BAAA;IAAA,yBAAA;EzE6gTV;;EyEphTM;IAOI,gCAAA;IAAA,+BAAA;EzEihTV;;EyExhTM;IAOI,+BAAA;IAAA,8BAAA;EzEqhTV;;EyE5hTM;IAOI,6BAAA;IAAA,4BAAA;EzEyhTV;;EyEhiTM;IAOI,+BAAA;IAAA,8BAAA;EzE6hTV;;EyEpiTM;IAOI,6BAAA;IAAA,4BAAA;EzEiiTV;;EyExiTM;IAOI,6BAAA;IAAA,4BAAA;EzEqiTV;;EyE5iTM;IAOI,wBAAA;IAAA,2BAAA;EzEyiTV;;EyEhjTM;IAOI,8BAAA;IAAA,iCAAA;EzE6iTV;;EyEpjTM;IAOI,6BAAA;IAAA,gCAAA;EzEijTV;;EyExjTM;IAOI,2BAAA;IAAA,8BAAA;EzEqjTV;;EyE5jTM;IAOI,6BAAA;IAAA,gCAAA;EzEyjTV;;EyEhkTM;IAOI,2BAAA;IAAA,8BAAA;EzE6jTV;;EyEpkTM;IAOI,2BAAA;IAAA,8BAAA;EzEikTV;;EyExkTM;IAOI,wBAAA;EzEokTV;;EyE3kTM;IAOI,8BAAA;EzEukTV;;EyE9kTM;IAOI,6BAAA;EzE0kTV;;EyEjlTM;IAOI,2BAAA;EzE6kTV;;EyEplTM;IAOI,6BAAA;EzEglTV;;EyEvlTM;IAOI,2BAAA;EzEmlTV;;EyE1lTM;IAOI,2BAAA;EzEslTV;;EyE7lTM;IAOI,0BAAA;EzEylTV;;EyEhmTM;IAOI,yBAAA;EzEylTV;;EyEhmTM;IAOI,gCAAA;EzE4lTV;;EyEnmTM;IAOI,+BAAA;EzE4lTV;;EyEnmTM;IAOI,+BAAA;EzE+lTV;;EyEtmTM;IAOI,8BAAA;EzE+lTV;;EyEtmTM;IAOI,6BAAA;EzEkmTV;;EyEzmTM;IAOI,4BAAA;EzEkmTV;;EyEzmTM;IAOI,+BAAA;EzEqmTV;;EyE5mTM;IAOI,8BAAA;EzEqmTV;;EyE5mTM;IAOI,6BAAA;EzEwmTV;;EyE/mTM;IAOI,4BAAA;EzEwmTV;;EyE/mTM;IAOI,6BAAA;EzE2mTV;;EyElnTM;IAOI,4BAAA;EzE2mTV;;EyElnTM;IAOI,2BAAA;EzE8mTV;;EyErnTM;IAOI,iCAAA;EzEinTV;;EyExnTM;IAOI,gCAAA;EzEonTV;;EyE3nTM;IAOI,8BAAA;EzEunTV;;EyE9nTM;IAOI,gCAAA;EzE0nTV;;EyEjoTM;IAOI,8BAAA;EzE6nTV;;EyEpoTM;IAOI,8BAAA;EzEgoTV;;EyEvoTM;IAOI,yBAAA;EzEmoTV;;EyE1oTM;IAOI,0BAAA;EzEmoTV;;EyE1oTM;IAOI,+BAAA;EzEsoTV;;EyE7oTM;IAOI,gCAAA;EzEsoTV;;EyE7oTM;IAOI,8BAAA;EzEyoTV;;EyEhpTM;IAOI,+BAAA;EzEyoTV;;EyEhpTM;IAOI,4BAAA;EzE4oTV;;EyEnpTM;IAOI,6BAAA;EzE4oTV;;EyEnpTM;IAOI,8BAAA;EzE+oTV;;EyEtpTM;IAOI,+BAAA;EzE+oTV;;EyEtpTM;IAOI,4BAAA;EzEkpTV;;EyEzpTM;IAOI,6BAAA;EzEkpTV;;EyEzpTM;IAOI,4BAAA;EzEqpTV;;EyE5pTM;IAOI,6BAAA;EzEqpTV;;EyE5pTM;IAOI,qBAAA;EzEwpTV;;EyE/pTM;IAOI,2BAAA;EzE2pTV;;EyElqTM;IAOI,0BAAA;EzE8pTV;;EyErqTM;IAOI,wBAAA;EzEiqTV;;EyExqTM;IAOI,0BAAA;EzEoqTV;;EyE3qTM;IAOI,wBAAA;EzEuqTV;;EyE9qTM;IAOI,2BAAA;IAAA,0BAAA;EzE2qTV;;EyElrTM;IAOI,iCAAA;IAAA,gCAAA;EzE+qTV;;EyEtrTM;IAOI,gCAAA;IAAA,+BAAA;EzEmrTV;;EyE1rTM;IAOI,8BAAA;IAAA,6BAAA;EzEurTV;;EyE9rTM;IAOI,gCAAA;IAAA,+BAAA;EzE2rTV;;EyElsTM;IAOI,8BAAA;IAAA,6BAAA;EzE+rTV;;EyEtsTM;IAOI,yBAAA;IAAA,4BAAA;EzEmsTV;;EyE1sTM;IAOI,+BAAA;IAAA,kCAAA;EzEusTV;;EyE9sTM;IAOI,8BAAA;IAAA,iCAAA;EzE2sTV;;EyEltTM;IAOI,4BAAA;IAAA,+BAAA;EzE+sTV;;EyEttTM;IAOI,8BAAA;IAAA,iCAAA;EzEmtTV;;EyE1tTM;IAOI,4BAAA;IAAA,+BAAA;EzEutTV;;EyE9tTM;IAOI,yBAAA;EzE0tTV;;EyEjuTM;IAOI,+BAAA;EzE6tTV;;EyEpuTM;IAOI,8BAAA;EzEguTV;;EyEvuTM;IAOI,4BAAA;EzEmuTV;;EyE1uTM;IAOI,8BAAA;EzEsuTV;;EyE7uTM;IAOI,4BAAA;EzEyuTV;;EyEhvTM;IAOI,2BAAA;EzE4uTV;;EyEnvTM;IAOI,0BAAA;EzE4uTV;;EyEnvTM;IAOI,iCAAA;EzE+uTV;;EyEtvTM;IAOI,gCAAA;EzE+uTV;;EyEtvTM;IAOI,gCAAA;EzEkvTV;;EyEzvTM;IAOI,+BAAA;EzEkvTV;;EyEzvTM;IAOI,8BAAA;EzEqvTV;;EyE5vTM;IAOI,6BAAA;EzEqvTV;;EyE5vTM;IAOI,gCAAA;EzEwvTV;;EyE/vTM;IAOI,+BAAA;EzEwvTV;;EyE/vTM;IAOI,8BAAA;EzE2vTV;;EyElwTM;IAOI,6BAAA;EzE2vTV;;EyElwTM;IAOI,4BAAA;EzE8vTV;;EyErwTM;IAOI,kCAAA;EzEiwTV;;EyExwTM;IAOI,iCAAA;EzEowTV;;EyE3wTM;IAOI,+BAAA;EzEuwTV;;EyE9wTM;IAOI,iCAAA;EzE0wTV;;EyEjxTM;IAOI,+BAAA;EzE6wTV;;EyEpxTM;IAOI,0BAAA;EzEgxTV;;EyEvxTM;IAOI,2BAAA;EzEgxTV;;EyEvxTM;IAOI,gCAAA;EzEmxTV;;EyE1xTM;IAOI,iCAAA;EzEmxTV;;EyE1xTM;IAOI,+BAAA;EzEsxTV;;EyE7xTM;IAOI,gCAAA;EzEsxTV;;EyE7xTM;IAOI,6BAAA;EzEyxTV;;EyEhyTM;IAOI,8BAAA;EzEyxTV;;EyEhyTM;IAOI,+BAAA;EzE4xTV;;EyEnyTM;IAOI,gCAAA;EzE4xTV;;EyEnyTM;IAOI,6BAAA;EzE+xTV;;EyEtyTM;IAOI,8BAAA;EzE+xTV;;EyEtyTM;IAOI,iBAAA;EzEkyTV;;EyEzyTM;IAOI,uBAAA;EzEqyTV;;EyE5yTM;IAOI,sBAAA;EzEwyTV;;EyE/yTM;IAOI,oBAAA;EzE2yTV;;EyElzTM;IAOI,sBAAA;EzE8yTV;;EyErzTM;IAOI,oBAAA;EzEizTV;;EyExzTM;IAOI,qBAAA;EzEozTV;;EyE3zTM;IAOI,2BAAA;EzEuzTV;;EyE9zTM;IAOI,0BAAA;EzE0zTV;;EyEj0TM;IAOI,wBAAA;EzE6zTV;;EyEp0TM;IAOI,0BAAA;EzEg0TV;;EyEv0TM;IAOI,wBAAA;EzEm0TV;;EyE10TM;IAOI,6BAAA;SAAA,wBAAA;EzEs0TV;;EyE70TM;IAOI,mCAAA;SAAA,8BAAA;EzEy0TV;;EyEh1TM;IAOI,kCAAA;SAAA,6BAAA;EzE40TV;;EyEn1TM;IAOI,gCAAA;SAAA,2BAAA;EzE+0TV;;EyEt1TM;IAOI,kCAAA;SAAA,6BAAA;EzEk1TV;;EyEz1TM;IAOI,gCAAA;SAAA,2BAAA;EzEq1TV;;EyE51TM;IAOI,2BAAA;EzEw1TV;;EyE/1TM;IAOI,4BAAA;EzEw1TV;;EyE/1TM;IAOI,4BAAA;EzE21TV;;EyEl2TM;IAOI,2BAAA;EzE21TV;;EyEl2TM;IAOI,6BAAA;EzE81TV;AACF;;Aez2TI;E0DGI;IAOI,sBAAA;EzEm2TV;;EyE12TM;IAOI,uBAAA;EzEm2TV;;EyE12TM;IAOI,uBAAA;EzEs2TV;;EyE72TM;IAOI,sBAAA;EzEs2TV;;EyE72TM;IAOI,sBAAA;EzEy2TV;;EyEh3TM;IAOI,iCAAA;OAAA,8BAAA;EzE42TV;;EyEn3TM;IAOI,+BAAA;OAAA,4BAAA;EzE+2TV;;EyEt3TM;IAOI,8BAAA;OAAA,2BAAA;EzEk3TV;;EyEz3TM;IAOI,oCAAA;OAAA,iCAAA;EzEq3TV;;EyE53TM;IAOI,8BAAA;OAAA,2BAAA;EzEw3TV;;EyE/3TM;IAOI,0BAAA;EzE23TV;;EyEl4TM;IAOI,gCAAA;EzE83TV;;EyEr4TM;IAOI,yBAAA;EzEi4TV;;EyEx4TM;IAOI,wBAAA;EzEo4TV;;EyE34TM;IAOI,+BAAA;EzEu4TV;;EyE94TM;IAOI,yBAAA;EzE04TV;;EyEj5TM;IAOI,6BAAA;EzE64TV;;EyEp5TM;IAOI,8BAAA;EzEg5TV;;EyEv5TM;IAOI,wBAAA;EzEm5TV;;EyE15TM;IAOI,+BAAA;EzEs5TV;;EyE75TM;IAOI,wBAAA;EzEy5TV;;EyEh6TM;IAOI,yBAAA;EzE45TV;;EyEn6TM;IAOI,8BAAA;EzE+5TV;;EyEt6TM;IAOI,iCAAA;EzEk6TV;;EyEz6TM;IAOI,sCAAA;EzEq6TV;;EyE56TM;IAOI,yCAAA;EzEw6TV;;EyE/6TM;IAOI,uBAAA;EzE26TV;;EyEl7TM;IAOI,uBAAA;EzE86TV;;EyEr7TM;IAOI,yBAAA;EzEi7TV;;EyEx7TM;IAOI,yBAAA;EzEo7TV;;EyE37TM;IAOI,0BAAA;EzEu7TV;;EyE97TM;IAOI,4BAAA;EzE07TV;;EyEj8TM;IAOI,kCAAA;EzE67TV;;EyEp8TM;IAOI,sCAAA;EzEg8TV;;EyEv8TM;IAOI,oCAAA;EzEm8TV;;EyE18TM;IAOI,kCAAA;EzEs8TV;;EyE78TM;IAOI,yCAAA;EzEy8TV;;EyEh9TM;IAOI,wCAAA;EzE48TV;;EyEn9TM;IAOI,wCAAA;EzE+8TV;;EyEt9TM;IAOI,kCAAA;EzEk9TV;;EyEz9TM;IAOI,gCAAA;EzEq9TV;;EyE59TM;IAOI,8BAAA;EzEw9TV;;EyE/9TM;IAOI,gCAAA;EzE29TV;;EyEl+TM;IAOI,+BAAA;EzE89TV;;EyEr+TM;IAOI,oCAAA;EzEi+TV;;EyEx+TM;IAOI,kCAAA;EzEo+TV;;EyE3+TM;IAOI,gCAAA;EzEu+TV;;EyE9+TM;IAOI,uCAAA;EzE0+TV;;EyEj/TM;IAOI,sCAAA;EzE6+TV;;EyEp/TM;IAOI,iCAAA;EzEg/TV;;EyEv/TM;IAOI,2BAAA;EzEm/TV;;EyE1/TM;IAOI,iCAAA;EzEs/TV;;EyE7/TM;IAOI,+BAAA;EzEy/TV;;EyEhgUM;IAOI,6BAAA;EzE4/TV;;EyEngUM;IAOI,+BAAA;EzE+/TV;;EyEtgUM;IAOI,8BAAA;EzEkgUV;;EyEzgUM;IAOI,oBAAA;EzEqgUV;;EyE5gUM;IAOI,mBAAA;EzEwgUV;;EyE/gUM;IAOI,mBAAA;EzE2gUV;;EyElhUM;IAOI,mBAAA;EzE8gUV;;EyErhUM;IAOI,mBAAA;EzEihUV;;EyExhUM;IAOI,mBAAA;EzEohUV;;EyE3hUM;IAOI,mBAAA;EzEuhUV;;EyE9hUM;IAOI,mBAAA;EzE0hUV;;EyEjiUM;IAOI,oBAAA;EzE6hUV;;EyEpiUM;IAOI,0BAAA;EzEgiUV;;EyEviUM;IAOI,yBAAA;EzEmiUV;;EyE1iUM;IAOI,uBAAA;EzEsiUV;;EyE7iUM;IAOI,yBAAA;EzEyiUV;;EyEhjUM;IAOI,uBAAA;EzE4iUV;;EyEnjUM;IAOI,uBAAA;EzE+iUV;;EyEtjUM;IAOI,0BAAA;IAAA,yBAAA;EzEmjUV;;EyE1jUM;IAOI,gCAAA;IAAA,+BAAA;EzEujUV;;EyE9jUM;IAOI,+BAAA;IAAA,8BAAA;EzE2jUV;;EyElkUM;IAOI,6BAAA;IAAA,4BAAA;EzE+jUV;;EyEtkUM;IAOI,+BAAA;IAAA,8BAAA;EzEmkUV;;EyE1kUM;IAOI,6BAAA;IAAA,4BAAA;EzEukUV;;EyE9kUM;IAOI,6BAAA;IAAA,4BAAA;EzE2kUV;;EyEllUM;IAOI,wBAAA;IAAA,2BAAA;EzE+kUV;;EyEtlUM;IAOI,8BAAA;IAAA,iCAAA;EzEmlUV;;EyE1lUM;IAOI,6BAAA;IAAA,gCAAA;EzEulUV;;EyE9lUM;IAOI,2BAAA;IAAA,8BAAA;EzE2lUV;;EyElmUM;IAOI,6BAAA;IAAA,gCAAA;EzE+lUV;;EyEtmUM;IAOI,2BAAA;IAAA,8BAAA;EzEmmUV;;EyE1mUM;IAOI,2BAAA;IAAA,8BAAA;EzEumUV;;EyE9mUM;IAOI,wBAAA;EzE0mUV;;EyEjnUM;IAOI,8BAAA;EzE6mUV;;EyEpnUM;IAOI,6BAAA;EzEgnUV;;EyEvnUM;IAOI,2BAAA;EzEmnUV;;EyE1nUM;IAOI,6BAAA;EzEsnUV;;EyE7nUM;IAOI,2BAAA;EzEynUV;;EyEhoUM;IAOI,2BAAA;EzE4nUV;;EyEnoUM;IAOI,0BAAA;EzE+nUV;;EyEtoUM;IAOI,yBAAA;EzE+nUV;;EyEtoUM;IAOI,gCAAA;EzEkoUV;;EyEzoUM;IAOI,+BAAA;EzEkoUV;;EyEzoUM;IAOI,+BAAA;EzEqoUV;;EyE5oUM;IAOI,8BAAA;EzEqoUV;;EyE5oUM;IAOI,6BAAA;EzEwoUV;;EyE/oUM;IAOI,4BAAA;EzEwoUV;;EyE/oUM;IAOI,+BAAA;EzE2oUV;;EyElpUM;IAOI,8BAAA;EzE2oUV;;EyElpUM;IAOI,6BAAA;EzE8oUV;;EyErpUM;IAOI,4BAAA;EzE8oUV;;EyErpUM;IAOI,6BAAA;EzEipUV;;EyExpUM;IAOI,4BAAA;EzEipUV;;EyExpUM;IAOI,2BAAA;EzEopUV;;EyE3pUM;IAOI,iCAAA;EzEupUV;;EyE9pUM;IAOI,gCAAA;EzE0pUV;;EyEjqUM;IAOI,8BAAA;EzE6pUV;;EyEpqUM;IAOI,gCAAA;EzEgqUV;;EyEvqUM;IAOI,8BAAA;EzEmqUV;;EyE1qUM;IAOI,8BAAA;EzEsqUV;;EyE7qUM;IAOI,yBAAA;EzEyqUV;;EyEhrUM;IAOI,0BAAA;EzEyqUV;;EyEhrUM;IAOI,+BAAA;EzE4qUV;;EyEnrUM;IAOI,gCAAA;EzE4qUV;;EyEnrUM;IAOI,8BAAA;EzE+qUV;;EyEtrUM;IAOI,+BAAA;EzE+qUV;;EyEtrUM;IAOI,4BAAA;EzEkrUV;;EyEzrUM;IAOI,6BAAA;EzEkrUV;;EyEzrUM;IAOI,8BAAA;EzEqrUV;;EyE5rUM;IAOI,+BAAA;EzEqrUV;;EyE5rUM;IAOI,4BAAA;EzEwrUV;;EyE/rUM;IAOI,6BAAA;EzEwrUV;;EyE/rUM;IAOI,4BAAA;EzE2rUV;;EyElsUM;IAOI,6BAAA;EzE2rUV;;EyElsUM;IAOI,qBAAA;EzE8rUV;;EyErsUM;IAOI,2BAAA;EzEisUV;;EyExsUM;IAOI,0BAAA;EzEosUV;;EyE3sUM;IAOI,wBAAA;EzEusUV;;EyE9sUM;IAOI,0BAAA;EzE0sUV;;EyEjtUM;IAOI,wBAAA;EzE6sUV;;EyEptUM;IAOI,2BAAA;IAAA,0BAAA;EzEitUV;;EyExtUM;IAOI,iCAAA;IAAA,gCAAA;EzEqtUV;;EyE5tUM;IAOI,gCAAA;IAAA,+BAAA;EzEytUV;;EyEhuUM;IAOI,8BAAA;IAAA,6BAAA;EzE6tUV;;EyEpuUM;IAOI,gCAAA;IAAA,+BAAA;EzEiuUV;;EyExuUM;IAOI,8BAAA;IAAA,6BAAA;EzEquUV;;EyE5uUM;IAOI,yBAAA;IAAA,4BAAA;EzEyuUV;;EyEhvUM;IAOI,+BAAA;IAAA,kCAAA;EzE6uUV;;EyEpvUM;IAOI,8BAAA;IAAA,iCAAA;EzEivUV;;EyExvUM;IAOI,4BAAA;IAAA,+BAAA;EzEqvUV;;EyE5vUM;IAOI,8BAAA;IAAA,iCAAA;EzEyvUV;;EyEhwUM;IAOI,4BAAA;IAAA,+BAAA;EzE6vUV;;EyEpwUM;IAOI,yBAAA;EzEgwUV;;EyEvwUM;IAOI,+BAAA;EzEmwUV;;EyE1wUM;IAOI,8BAAA;EzEswUV;;EyE7wUM;IAOI,4BAAA;EzEywUV;;EyEhxUM;IAOI,8BAAA;EzE4wUV;;EyEnxUM;IAOI,4BAAA;EzE+wUV;;EyEtxUM;IAOI,2BAAA;EzEkxUV;;EyEzxUM;IAOI,0BAAA;EzEkxUV;;EyEzxUM;IAOI,iCAAA;EzEqxUV;;EyE5xUM;IAOI,gCAAA;EzEqxUV;;EyE5xUM;IAOI,gCAAA;EzEwxUV;;EyE/xUM;IAOI,+BAAA;EzEwxUV;;EyE/xUM;IAOI,8BAAA;EzE2xUV;;EyElyUM;IAOI,6BAAA;EzE2xUV;;EyElyUM;IAOI,gCAAA;EzE8xUV;;EyEryUM;IAOI,+BAAA;EzE8xUV;;EyEryUM;IAOI,8BAAA;EzEiyUV;;EyExyUM;IAOI,6BAAA;EzEiyUV;;EyExyUM;IAOI,4BAAA;EzEoyUV;;EyE3yUM;IAOI,kCAAA;EzEuyUV;;EyE9yUM;IAOI,iCAAA;EzE0yUV;;EyEjzUM;IAOI,+BAAA;EzE6yUV;;EyEpzUM;IAOI,iCAAA;EzEgzUV;;EyEvzUM;IAOI,+BAAA;EzEmzUV;;EyE1zUM;IAOI,0BAAA;EzEszUV;;EyE7zUM;IAOI,2BAAA;EzEszUV;;EyE7zUM;IAOI,gCAAA;EzEyzUV;;EyEh0UM;IAOI,iCAAA;EzEyzUV;;EyEh0UM;IAOI,+BAAA;EzE4zUV;;EyEn0UM;IAOI,gCAAA;EzE4zUV;;EyEn0UM;IAOI,6BAAA;EzE+zUV;;EyEt0UM;IAOI,8BAAA;EzE+zUV;;EyEt0UM;IAOI,+BAAA;EzEk0UV;;EyEz0UM;IAOI,gCAAA;EzEk0UV;;EyEz0UM;IAOI,6BAAA;EzEq0UV;;EyE50UM;IAOI,8BAAA;EzEq0UV;;EyE50UM;IAOI,iBAAA;EzEw0UV;;EyE/0UM;IAOI,uBAAA;EzE20UV;;EyEl1UM;IAOI,sBAAA;EzE80UV;;EyEr1UM;IAOI,oBAAA;EzEi1UV;;EyEx1UM;IAOI,sBAAA;EzEo1UV;;EyE31UM;IAOI,oBAAA;EzEu1UV;;EyE91UM;IAOI,qBAAA;EzE01UV;;EyEj2UM;IAOI,2BAAA;EzE61UV;;EyEp2UM;IAOI,0BAAA;EzEg2UV;;EyEv2UM;IAOI,wBAAA;EzEm2UV;;EyE12UM;IAOI,0BAAA;EzEs2UV;;EyE72UM;IAOI,wBAAA;EzEy2UV;;EyEh3UM;IAOI,6BAAA;SAAA,wBAAA;EzE42UV;;EyEn3UM;IAOI,mCAAA;SAAA,8BAAA;EzE+2UV;;EyEt3UM;IAOI,kCAAA;SAAA,6BAAA;EzEk3UV;;EyEz3UM;IAOI,gCAAA;SAAA,2BAAA;EzEq3UV;;EyE53UM;IAOI,kCAAA;SAAA,6BAAA;EzEw3UV;;EyE/3UM;IAOI,gCAAA;SAAA,2BAAA;EzE23UV;;EyEl4UM;IAOI,2BAAA;EzE83UV;;EyEr4UM;IAOI,4BAAA;EzE83UV;;EyEr4UM;IAOI,4BAAA;EzEi4UV;;EyEx4UM;IAOI,2BAAA;EzEi4UV;;EyEx4UM;IAOI,6BAAA;EzEo4UV;AACF;;Ae/4UI;E0DGI;IAOI,sBAAA;EzEy4UV;;EyEh5UM;IAOI,uBAAA;EzEy4UV;;EyEh5UM;IAOI,uBAAA;EzE44UV;;EyEn5UM;IAOI,sBAAA;EzE44UV;;EyEn5UM;IAOI,sBAAA;EzE+4UV;;EyEt5UM;IAOI,iCAAA;OAAA,8BAAA;EzEk5UV;;EyEz5UM;IAOI,+BAAA;OAAA,4BAAA;EzEq5UV;;EyE55UM;IAOI,8BAAA;OAAA,2BAAA;EzEw5UV;;EyE/5UM;IAOI,oCAAA;OAAA,iCAAA;EzE25UV;;EyEl6UM;IAOI,8BAAA;OAAA,2BAAA;EzE85UV;;EyEr6UM;IAOI,0BAAA;EzEi6UV;;EyEx6UM;IAOI,gCAAA;EzEo6UV;;EyE36UM;IAOI,yBAAA;EzEu6UV;;EyE96UM;IAOI,wBAAA;EzE06UV;;EyEj7UM;IAOI,+BAAA;EzE66UV;;EyEp7UM;IAOI,yBAAA;EzEg7UV;;EyEv7UM;IAOI,6BAAA;EzEm7UV;;EyE17UM;IAOI,8BAAA;EzEs7UV;;EyE77UM;IAOI,wBAAA;EzEy7UV;;EyEh8UM;IAOI,+BAAA;EzE47UV;;EyEn8UM;IAOI,wBAAA;EzE+7UV;;EyEt8UM;IAOI,yBAAA;EzEk8UV;;EyEz8UM;IAOI,8BAAA;EzEq8UV;;EyE58UM;IAOI,iCAAA;EzEw8UV;;EyE/8UM;IAOI,sCAAA;EzE28UV;;EyEl9UM;IAOI,yCAAA;EzE88UV;;EyEr9UM;IAOI,uBAAA;EzEi9UV;;EyEx9UM;IAOI,uBAAA;EzEo9UV;;EyE39UM;IAOI,yBAAA;EzEu9UV;;EyE99UM;IAOI,yBAAA;EzE09UV;;EyEj+UM;IAOI,0BAAA;EzE69UV;;EyEp+UM;IAOI,4BAAA;EzEg+UV;;EyEv+UM;IAOI,kCAAA;EzEm+UV;;EyE1+UM;IAOI,sCAAA;EzEs+UV;;EyE7+UM;IAOI,oCAAA;EzEy+UV;;EyEh/UM;IAOI,kCAAA;EzE4+UV;;EyEn/UM;IAOI,yCAAA;EzE++UV;;EyEt/UM;IAOI,wCAAA;EzEk/UV;;EyEz/UM;IAOI,wCAAA;EzEq/UV;;EyE5/UM;IAOI,kCAAA;EzEw/UV;;EyE//UM;IAOI,gCAAA;EzE2/UV;;EyElgVM;IAOI,8BAAA;EzE8/UV;;EyErgVM;IAOI,gCAAA;EzEigVV;;EyExgVM;IAOI,+BAAA;EzEogVV;;EyE3gVM;IAOI,oCAAA;EzEugVV;;EyE9gVM;IAOI,kCAAA;EzE0gVV;;EyEjhVM;IAOI,gCAAA;EzE6gVV;;EyEphVM;IAOI,uCAAA;EzEghVV;;EyEvhVM;IAOI,sCAAA;EzEmhVV;;EyE1hVM;IAOI,iCAAA;EzEshVV;;EyE7hVM;IAOI,2BAAA;EzEyhVV;;EyEhiVM;IAOI,iCAAA;EzE4hVV;;EyEniVM;IAOI,+BAAA;EzE+hVV;;EyEtiVM;IAOI,6BAAA;EzEkiVV;;EyEziVM;IAOI,+BAAA;EzEqiVV;;EyE5iVM;IAOI,8BAAA;EzEwiVV;;EyE/iVM;IAOI,oBAAA;EzE2iVV;;EyEljVM;IAOI,mBAAA;EzE8iVV;;EyErjVM;IAOI,mBAAA;EzEijVV;;EyExjVM;IAOI,mBAAA;EzEojVV;;EyE3jVM;IAOI,mBAAA;EzEujVV;;EyE9jVM;IAOI,mBAAA;EzE0jVV;;EyEjkVM;IAOI,mBAAA;EzE6jVV;;EyEpkVM;IAOI,mBAAA;EzEgkVV;;EyEvkVM;IAOI,oBAAA;EzEmkVV;;EyE1kVM;IAOI,0BAAA;EzEskVV;;EyE7kVM;IAOI,yBAAA;EzEykVV;;EyEhlVM;IAOI,uBAAA;EzE4kVV;;EyEnlVM;IAOI,yBAAA;EzE+kVV;;EyEtlVM;IAOI,uBAAA;EzEklVV;;EyEzlVM;IAOI,uBAAA;EzEqlVV;;EyE5lVM;IAOI,0BAAA;IAAA,yBAAA;EzEylVV;;EyEhmVM;IAOI,gCAAA;IAAA,+BAAA;EzE6lVV;;EyEpmVM;IAOI,+BAAA;IAAA,8BAAA;EzEimVV;;EyExmVM;IAOI,6BAAA;IAAA,4BAAA;EzEqmVV;;EyE5mVM;IAOI,+BAAA;IAAA,8BAAA;EzEymVV;;EyEhnVM;IAOI,6BAAA;IAAA,4BAAA;EzE6mVV;;EyEpnVM;IAOI,6BAAA;IAAA,4BAAA;EzEinVV;;EyExnVM;IAOI,wBAAA;IAAA,2BAAA;EzEqnVV;;EyE5nVM;IAOI,8BAAA;IAAA,iCAAA;EzEynVV;;EyEhoVM;IAOI,6BAAA;IAAA,gCAAA;EzE6nVV;;EyEpoVM;IAOI,2BAAA;IAAA,8BAAA;EzEioVV;;EyExoVM;IAOI,6BAAA;IAAA,gCAAA;EzEqoVV;;EyE5oVM;IAOI,2BAAA;IAAA,8BAAA;EzEyoVV;;EyEhpVM;IAOI,2BAAA;IAAA,8BAAA;EzE6oVV;;EyEppVM;IAOI,wBAAA;EzEgpVV;;EyEvpVM;IAOI,8BAAA;EzEmpVV;;EyE1pVM;IAOI,6BAAA;EzEspVV;;EyE7pVM;IAOI,2BAAA;EzEypVV;;EyEhqVM;IAOI,6BAAA;EzE4pVV;;EyEnqVM;IAOI,2BAAA;EzE+pVV;;EyEtqVM;IAOI,2BAAA;EzEkqVV;;EyEzqVM;IAOI,0BAAA;EzEqqVV;;EyE5qVM;IAOI,yBAAA;EzEqqVV;;EyE5qVM;IAOI,gCAAA;EzEwqVV;;EyE/qVM;IAOI,+BAAA;EzEwqVV;;EyE/qVM;IAOI,+BAAA;EzE2qVV;;EyElrVM;IAOI,8BAAA;EzE2qVV;;EyElrVM;IAOI,6BAAA;EzE8qVV;;EyErrVM;IAOI,4BAAA;EzE8qVV;;EyErrVM;IAOI,+BAAA;EzEirVV;;EyExrVM;IAOI,8BAAA;EzEirVV;;EyExrVM;IAOI,6BAAA;EzEorVV;;EyE3rVM;IAOI,4BAAA;EzEorVV;;EyE3rVM;IAOI,6BAAA;EzEurVV;;EyE9rVM;IAOI,4BAAA;EzEurVV;;EyE9rVM;IAOI,2BAAA;EzE0rVV;;EyEjsVM;IAOI,iCAAA;EzE6rVV;;EyEpsVM;IAOI,gCAAA;EzEgsVV;;EyEvsVM;IAOI,8BAAA;EzEmsVV;;EyE1sVM;IAOI,gCAAA;EzEssVV;;EyE7sVM;IAOI,8BAAA;EzEysVV;;EyEhtVM;IAOI,8BAAA;EzE4sVV;;EyEntVM;IAOI,yBAAA;EzE+sVV;;EyEttVM;IAOI,0BAAA;EzE+sVV;;EyEttVM;IAOI,+BAAA;EzEktVV;;EyEztVM;IAOI,gCAAA;EzEktVV;;EyEztVM;IAOI,8BAAA;EzEqtVV;;EyE5tVM;IAOI,+BAAA;EzEqtVV;;EyE5tVM;IAOI,4BAAA;EzEwtVV;;EyE/tVM;IAOI,6BAAA;EzEwtVV;;EyE/tVM;IAOI,8BAAA;EzE2tVV;;EyEluVM;IAOI,+BAAA;EzE2tVV;;EyEluVM;IAOI,4BAAA;EzE8tVV;;EyEruVM;IAOI,6BAAA;EzE8tVV;;EyEruVM;IAOI,4BAAA;EzEiuVV;;EyExuVM;IAOI,6BAAA;EzEiuVV;;EyExuVM;IAOI,qBAAA;EzEouVV;;EyE3uVM;IAOI,2BAAA;EzEuuVV;;EyE9uVM;IAOI,0BAAA;EzE0uVV;;EyEjvVM;IAOI,wBAAA;EzE6uVV;;EyEpvVM;IAOI,0BAAA;EzEgvVV;;EyEvvVM;IAOI,wBAAA;EzEmvVV;;EyE1vVM;IAOI,2BAAA;IAAA,0BAAA;EzEuvVV;;EyE9vVM;IAOI,iCAAA;IAAA,gCAAA;EzE2vVV;;EyElwVM;IAOI,gCAAA;IAAA,+BAAA;EzE+vVV;;EyEtwVM;IAOI,8BAAA;IAAA,6BAAA;EzEmwVV;;EyE1wVM;IAOI,gCAAA;IAAA,+BAAA;EzEuwVV;;EyE9wVM;IAOI,8BAAA;IAAA,6BAAA;EzE2wVV;;EyElxVM;IAOI,yBAAA;IAAA,4BAAA;EzE+wVV;;EyEtxVM;IAOI,+BAAA;IAAA,kCAAA;EzEmxVV;;EyE1xVM;IAOI,8BAAA;IAAA,iCAAA;EzEuxVV;;EyE9xVM;IAOI,4BAAA;IAAA,+BAAA;EzE2xVV;;EyElyVM;IAOI,8BAAA;IAAA,iCAAA;EzE+xVV;;EyEtyVM;IAOI,4BAAA;IAAA,+BAAA;EzEmyVV;;EyE1yVM;IAOI,yBAAA;EzEsyVV;;EyE7yVM;IAOI,+BAAA;EzEyyVV;;EyEhzVM;IAOI,8BAAA;EzE4yVV;;EyEnzVM;IAOI,4BAAA;EzE+yVV;;EyEtzVM;IAOI,8BAAA;EzEkzVV;;EyEzzVM;IAOI,4BAAA;EzEqzVV;;EyE5zVM;IAOI,2BAAA;EzEwzVV;;EyE/zVM;IAOI,0BAAA;EzEwzVV;;EyE/zVM;IAOI,iCAAA;EzE2zVV;;EyEl0VM;IAOI,gCAAA;EzE2zVV;;EyEl0VM;IAOI,gCAAA;EzE8zVV;;EyEr0VM;IAOI,+BAAA;EzE8zVV;;EyEr0VM;IAOI,8BAAA;EzEi0VV;;EyEx0VM;IAOI,6BAAA;EzEi0VV;;EyEx0VM;IAOI,gCAAA;EzEo0VV;;EyE30VM;IAOI,+BAAA;EzEo0VV;;EyE30VM;IAOI,8BAAA;EzEu0VV;;EyE90VM;IAOI,6BAAA;EzEu0VV;;EyE90VM;IAOI,4BAAA;EzE00VV;;EyEj1VM;IAOI,kCAAA;EzE60VV;;EyEp1VM;IAOI,iCAAA;EzEg1VV;;EyEv1VM;IAOI,+BAAA;EzEm1VV;;EyE11VM;IAOI,iCAAA;EzEs1VV;;EyE71VM;IAOI,+BAAA;EzEy1VV;;EyEh2VM;IAOI,0BAAA;EzE41VV;;EyEn2VM;IAOI,2BAAA;EzE41VV;;EyEn2VM;IAOI,gCAAA;EzE+1VV;;EyEt2VM;IAOI,iCAAA;EzE+1VV;;EyEt2VM;IAOI,+BAAA;EzEk2VV;;EyEz2VM;IAOI,gCAAA;EzEk2VV;;EyEz2VM;IAOI,6BAAA;EzEq2VV;;EyE52VM;IAOI,8BAAA;EzEq2VV;;EyE52VM;IAOI,+BAAA;EzEw2VV;;EyE/2VM;IAOI,gCAAA;EzEw2VV;;EyE/2VM;IAOI,6BAAA;EzE22VV;;EyEl3VM;IAOI,8BAAA;EzE22VV;;EyEl3VM;IAOI,iBAAA;EzE82VV;;EyEr3VM;IAOI,uBAAA;EzEi3VV;;EyEx3VM;IAOI,sBAAA;EzEo3VV;;EyE33VM;IAOI,oBAAA;EzEu3VV;;EyE93VM;IAOI,sBAAA;EzE03VV;;EyEj4VM;IAOI,oBAAA;EzE63VV;;EyEp4VM;IAOI,qBAAA;EzEg4VV;;EyEv4VM;IAOI,2BAAA;EzEm4VV;;EyE14VM;IAOI,0BAAA;EzEs4VV;;EyE74VM;IAOI,wBAAA;EzEy4VV;;EyEh5VM;IAOI,0BAAA;EzE44VV;;EyEn5VM;IAOI,wBAAA;EzE+4VV;;EyEt5VM;IAOI,6BAAA;SAAA,wBAAA;EzEk5VV;;EyEz5VM;IAOI,mCAAA;SAAA,8BAAA;EzEq5VV;;EyE55VM;IAOI,kCAAA;SAAA,6BAAA;EzEw5VV;;EyE/5VM;IAOI,gCAAA;SAAA,2BAAA;EzE25VV;;EyEl6VM;IAOI,kCAAA;SAAA,6BAAA;EzE85VV;;EyEr6VM;IAOI,gCAAA;SAAA,2BAAA;EzEi6VV;;EyEx6VM;IAOI,2BAAA;EzEo6VV;;EyE36VM;IAOI,4BAAA;EzEo6VV;;EyE36VM;IAOI,4BAAA;EzEu6VV;;EyE96VM;IAOI,2BAAA;EzEu6VV;;EyE96VM;IAOI,6BAAA;EzE06VV;AACF;;Aer7VI;E0DGI;IAOI,sBAAA;EzE+6VV;;EyEt7VM;IAOI,uBAAA;EzE+6VV;;EyEt7VM;IAOI,uBAAA;EzEk7VV;;EyEz7VM;IAOI,sBAAA;EzEk7VV;;EyEz7VM;IAOI,sBAAA;EzEq7VV;;EyE57VM;IAOI,iCAAA;OAAA,8BAAA;EzEw7VV;;EyE/7VM;IAOI,+BAAA;OAAA,4BAAA;EzE27VV;;EyEl8VM;IAOI,8BAAA;OAAA,2BAAA;EzE87VV;;EyEr8VM;IAOI,oCAAA;OAAA,iCAAA;EzEi8VV;;EyEx8VM;IAOI,8BAAA;OAAA,2BAAA;EzEo8VV;;EyE38VM;IAOI,0BAAA;EzEu8VV;;EyE98VM;IAOI,gCAAA;EzE08VV;;EyEj9VM;IAOI,yBAAA;EzE68VV;;EyEp9VM;IAOI,wBAAA;EzEg9VV;;EyEv9VM;IAOI,+BAAA;EzEm9VV;;EyE19VM;IAOI,yBAAA;EzEs9VV;;EyE79VM;IAOI,6BAAA;EzEy9VV;;EyEh+VM;IAOI,8BAAA;EzE49VV;;EyEn+VM;IAOI,wBAAA;EzE+9VV;;EyEt+VM;IAOI,+BAAA;EzEk+VV;;EyEz+VM;IAOI,wBAAA;EzEq+VV;;EyE5+VM;IAOI,yBAAA;EzEw+VV;;EyE/+VM;IAOI,8BAAA;EzE2+VV;;EyEl/VM;IAOI,iCAAA;EzE8+VV;;EyEr/VM;IAOI,sCAAA;EzEi/VV;;EyEx/VM;IAOI,yCAAA;EzEo/VV;;EyE3/VM;IAOI,uBAAA;EzEu/VV;;EyE9/VM;IAOI,uBAAA;EzE0/VV;;EyEjgWM;IAOI,yBAAA;EzE6/VV;;EyEpgWM;IAOI,yBAAA;EzEggWV;;EyEvgWM;IAOI,0BAAA;EzEmgWV;;EyE1gWM;IAOI,4BAAA;EzEsgWV;;EyE7gWM;IAOI,kCAAA;EzEygWV;;EyEhhWM;IAOI,sCAAA;EzE4gWV;;EyEnhWM;IAOI,oCAAA;EzE+gWV;;EyEthWM;IAOI,kCAAA;EzEkhWV;;EyEzhWM;IAOI,yCAAA;EzEqhWV;;EyE5hWM;IAOI,wCAAA;EzEwhWV;;EyE/hWM;IAOI,wCAAA;EzE2hWV;;EyEliWM;IAOI,kCAAA;EzE8hWV;;EyEriWM;IAOI,gCAAA;EzEiiWV;;EyExiWM;IAOI,8BAAA;EzEoiWV;;EyE3iWM;IAOI,gCAAA;EzEuiWV;;EyE9iWM;IAOI,+BAAA;EzE0iWV;;EyEjjWM;IAOI,oCAAA;EzE6iWV;;EyEpjWM;IAOI,kCAAA;EzEgjWV;;EyEvjWM;IAOI,gCAAA;EzEmjWV;;EyE1jWM;IAOI,uCAAA;EzEsjWV;;EyE7jWM;IAOI,sCAAA;EzEyjWV;;EyEhkWM;IAOI,iCAAA;EzE4jWV;;EyEnkWM;IAOI,2BAAA;EzE+jWV;;EyEtkWM;IAOI,iCAAA;EzEkkWV;;EyEzkWM;IAOI,+BAAA;EzEqkWV;;EyE5kWM;IAOI,6BAAA;EzEwkWV;;EyE/kWM;IAOI,+BAAA;EzE2kWV;;EyEllWM;IAOI,8BAAA;EzE8kWV;;EyErlWM;IAOI,oBAAA;EzEilWV;;EyExlWM;IAOI,mBAAA;EzEolWV;;EyE3lWM;IAOI,mBAAA;EzEulWV;;EyE9lWM;IAOI,mBAAA;EzE0lWV;;EyEjmWM;IAOI,mBAAA;EzE6lWV;;EyEpmWM;IAOI,mBAAA;EzEgmWV;;EyEvmWM;IAOI,mBAAA;EzEmmWV;;EyE1mWM;IAOI,mBAAA;EzEsmWV;;EyE7mWM;IAOI,oBAAA;EzEymWV;;EyEhnWM;IAOI,0BAAA;EzE4mWV;;EyEnnWM;IAOI,yBAAA;EzE+mWV;;EyEtnWM;IAOI,uBAAA;EzEknWV;;EyEznWM;IAOI,yBAAA;EzEqnWV;;EyE5nWM;IAOI,uBAAA;EzEwnWV;;EyE/nWM;IAOI,uBAAA;EzE2nWV;;EyEloWM;IAOI,0BAAA;IAAA,yBAAA;EzE+nWV;;EyEtoWM;IAOI,gCAAA;IAAA,+BAAA;EzEmoWV;;EyE1oWM;IAOI,+BAAA;IAAA,8BAAA;EzEuoWV;;EyE9oWM;IAOI,6BAAA;IAAA,4BAAA;EzE2oWV;;EyElpWM;IAOI,+BAAA;IAAA,8BAAA;EzE+oWV;;EyEtpWM;IAOI,6BAAA;IAAA,4BAAA;EzEmpWV;;EyE1pWM;IAOI,6BAAA;IAAA,4BAAA;EzEupWV;;EyE9pWM;IAOI,wBAAA;IAAA,2BAAA;EzE2pWV;;EyElqWM;IAOI,8BAAA;IAAA,iCAAA;EzE+pWV;;EyEtqWM;IAOI,6BAAA;IAAA,gCAAA;EzEmqWV;;EyE1qWM;IAOI,2BAAA;IAAA,8BAAA;EzEuqWV;;EyE9qWM;IAOI,6BAAA;IAAA,gCAAA;EzE2qWV;;EyElrWM;IAOI,2BAAA;IAAA,8BAAA;EzE+qWV;;EyEtrWM;IAOI,2BAAA;IAAA,8BAAA;EzEmrWV;;EyE1rWM;IAOI,wBAAA;EzEsrWV;;EyE7rWM;IAOI,8BAAA;EzEyrWV;;EyEhsWM;IAOI,6BAAA;EzE4rWV;;EyEnsWM;IAOI,2BAAA;EzE+rWV;;EyEtsWM;IAOI,6BAAA;EzEksWV;;EyEzsWM;IAOI,2BAAA;EzEqsWV;;EyE5sWM;IAOI,2BAAA;EzEwsWV;;EyE/sWM;IAOI,0BAAA;EzE2sWV;;EyEltWM;IAOI,yBAAA;EzE2sWV;;EyEltWM;IAOI,gCAAA;EzE8sWV;;EyErtWM;IAOI,+BAAA;EzE8sWV;;EyErtWM;IAOI,+BAAA;EzEitWV;;EyExtWM;IAOI,8BAAA;EzEitWV;;EyExtWM;IAOI,6BAAA;EzEotWV;;EyE3tWM;IAOI,4BAAA;EzEotWV;;EyE3tWM;IAOI,+BAAA;EzEutWV;;EyE9tWM;IAOI,8BAAA;EzEutWV;;EyE9tWM;IAOI,6BAAA;EzE0tWV;;EyEjuWM;IAOI,4BAAA;EzE0tWV;;EyEjuWM;IAOI,6BAAA;EzE6tWV;;EyEpuWM;IAOI,4BAAA;EzE6tWV;;EyEpuWM;IAOI,2BAAA;EzEguWV;;EyEvuWM;IAOI,iCAAA;EzEmuWV;;EyE1uWM;IAOI,gCAAA;EzEsuWV;;EyE7uWM;IAOI,8BAAA;EzEyuWV;;EyEhvWM;IAOI,gCAAA;EzE4uWV;;EyEnvWM;IAOI,8BAAA;EzE+uWV;;EyEtvWM;IAOI,8BAAA;EzEkvWV;;EyEzvWM;IAOI,yBAAA;EzEqvWV;;EyE5vWM;IAOI,0BAAA;EzEqvWV;;EyE5vWM;IAOI,+BAAA;EzEwvWV;;EyE/vWM;IAOI,gCAAA;EzEwvWV;;EyE/vWM;IAOI,8BAAA;EzE2vWV;;EyElwWM;IAOI,+BAAA;EzE2vWV;;EyElwWM;IAOI,4BAAA;EzE8vWV;;EyErwWM;IAOI,6BAAA;EzE8vWV;;EyErwWM;IAOI,8BAAA;EzEiwWV;;EyExwWM;IAOI,+BAAA;EzEiwWV;;EyExwWM;IAOI,4BAAA;EzEowWV;;EyE3wWM;IAOI,6BAAA;EzEowWV;;EyE3wWM;IAOI,4BAAA;EzEuwWV;;EyE9wWM;IAOI,6BAAA;EzEuwWV;;EyE9wWM;IAOI,qBAAA;EzE0wWV;;EyEjxWM;IAOI,2BAAA;EzE6wWV;;EyEpxWM;IAOI,0BAAA;EzEgxWV;;EyEvxWM;IAOI,wBAAA;EzEmxWV;;EyE1xWM;IAOI,0BAAA;EzEsxWV;;EyE7xWM;IAOI,wBAAA;EzEyxWV;;EyEhyWM;IAOI,2BAAA;IAAA,0BAAA;EzE6xWV;;EyEpyWM;IAOI,iCAAA;IAAA,gCAAA;EzEiyWV;;EyExyWM;IAOI,gCAAA;IAAA,+BAAA;EzEqyWV;;EyE5yWM;IAOI,8BAAA;IAAA,6BAAA;EzEyyWV;;EyEhzWM;IAOI,gCAAA;IAAA,+BAAA;EzE6yWV;;EyEpzWM;IAOI,8BAAA;IAAA,6BAAA;EzEizWV;;EyExzWM;IAOI,yBAAA;IAAA,4BAAA;EzEqzWV;;EyE5zWM;IAOI,+BAAA;IAAA,kCAAA;EzEyzWV;;EyEh0WM;IAOI,8BAAA;IAAA,iCAAA;EzE6zWV;;EyEp0WM;IAOI,4BAAA;IAAA,+BAAA;EzEi0WV;;EyEx0WM;IAOI,8BAAA;IAAA,iCAAA;EzEq0WV;;EyE50WM;IAOI,4BAAA;IAAA,+BAAA;EzEy0WV;;EyEh1WM;IAOI,yBAAA;EzE40WV;;EyEn1WM;IAOI,+BAAA;EzE+0WV;;EyEt1WM;IAOI,8BAAA;EzEk1WV;;EyEz1WM;IAOI,4BAAA;EzEq1WV;;EyE51WM;IAOI,8BAAA;EzEw1WV;;EyE/1WM;IAOI,4BAAA;EzE21WV;;EyEl2WM;IAOI,2BAAA;EzE81WV;;EyEr2WM;IAOI,0BAAA;EzE81WV;;EyEr2WM;IAOI,iCAAA;EzEi2WV;;EyEx2WM;IAOI,gCAAA;EzEi2WV;;EyEx2WM;IAOI,gCAAA;EzEo2WV;;EyE32WM;IAOI,+BAAA;EzEo2WV;;EyE32WM;IAOI,8BAAA;EzEu2WV;;EyE92WM;IAOI,6BAAA;EzEu2WV;;EyE92WM;IAOI,gCAAA;EzE02WV;;EyEj3WM;IAOI,+BAAA;EzE02WV;;EyEj3WM;IAOI,8BAAA;EzE62WV;;EyEp3WM;IAOI,6BAAA;EzE62WV;;EyEp3WM;IAOI,4BAAA;EzEg3WV;;EyEv3WM;IAOI,kCAAA;EzEm3WV;;EyE13WM;IAOI,iCAAA;EzEs3WV;;EyE73WM;IAOI,+BAAA;EzEy3WV;;EyEh4WM;IAOI,iCAAA;EzE43WV;;EyEn4WM;IAOI,+BAAA;EzE+3WV;;EyEt4WM;IAOI,0BAAA;EzEk4WV;;EyEz4WM;IAOI,2BAAA;EzEk4WV;;EyEz4WM;IAOI,gCAAA;EzEq4WV;;EyE54WM;IAOI,iCAAA;EzEq4WV;;EyE54WM;IAOI,+BAAA;EzEw4WV;;EyE/4WM;IAOI,gCAAA;EzEw4WV;;EyE/4WM;IAOI,6BAAA;EzE24WV;;EyEl5WM;IAOI,8BAAA;EzE24WV;;EyEl5WM;IAOI,+BAAA;EzE84WV;;EyEr5WM;IAOI,gCAAA;EzE84WV;;EyEr5WM;IAOI,6BAAA;EzEi5WV;;EyEx5WM;IAOI,8BAAA;EzEi5WV;;EyEx5WM;IAOI,iBAAA;EzEo5WV;;EyE35WM;IAOI,uBAAA;EzEu5WV;;EyE95WM;IAOI,sBAAA;EzE05WV;;EyEj6WM;IAOI,oBAAA;EzE65WV;;EyEp6WM;IAOI,sBAAA;EzEg6WV;;EyEv6WM;IAOI,oBAAA;EzEm6WV;;EyE16WM;IAOI,qBAAA;EzEs6WV;;EyE76WM;IAOI,2BAAA;EzEy6WV;;EyEh7WM;IAOI,0BAAA;EzE46WV;;EyEn7WM;IAOI,wBAAA;EzE+6WV;;EyEt7WM;IAOI,0BAAA;EzEk7WV;;EyEz7WM;IAOI,wBAAA;EzEq7WV;;EyE57WM;IAOI,6BAAA;SAAA,wBAAA;EzEw7WV;;EyE/7WM;IAOI,mCAAA;SAAA,8BAAA;EzE27WV;;EyEl8WM;IAOI,kCAAA;SAAA,6BAAA;EzE87WV;;EyEr8WM;IAOI,gCAAA;SAAA,2BAAA;EzEi8WV;;EyEx8WM;IAOI,kCAAA;SAAA,6BAAA;EzEo8WV;;EyE38WM;IAOI,gCAAA;SAAA,2BAAA;EzEu8WV;;EyE98WM;IAOI,2BAAA;EzE08WV;;EyEj9WM;IAOI,4BAAA;EzE08WV;;EyEj9WM;IAOI,4BAAA;EzE68WV;;EyEp9WM;IAOI,2BAAA;EzE68WV;;EyEp9WM;IAOI,6BAAA;EzEg9WV;AACF;;A0EvgXA;ED+CQ;IAOI,4BAAA;EzEq9WV;;EyE59WM;IAOI,0BAAA;EzEw9WV;;EyE/9WM;IAOI,6BAAA;EzE29WV;;EyEl+WM;IAOI,4BAAA;EzE89WV;AACF;;A0ElgXA;ED4BQ;IAOI,0BAAA;EzEm+WV;;EyE1+WM;IAOI,gCAAA;EzEs+WV;;EyE7+WM;IAOI,yBAAA;EzEy+WV;;EyEh/WM;IAOI,wBAAA;EzE4+WV;;EyEn/WM;IAOI,+BAAA;EzE++WV;;EyEt/WM;IAOI,yBAAA;EzEk/WV;;EyEz/WM;IAOI,6BAAA;EzEq/WV;;EyE5/WM;IAOI,8BAAA;EzEw/WV;;EyE//WM;IAOI,wBAAA;EzE2/WV;;EyElgXM;IAOI,+BAAA;EzE8/WV;;EyErgXM;IAOI,wBAAA;EzEigXV;AACF;;AAtkXA;EACE,mBAAA;EACA,SAAA;AAwkXF;;AArkXA;EACE,cAAA;EACA,iBAAA;AAwkXF;;AArkXA;EAEE,sBAAA;AAwkXF;;AAvkXE;EAGE,sBAAA;AAwkXJ;;AApkXA;EACE,sBAAA;AAukXF;;AAtkXE;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AAwkXJ;;AAvkXI;EACE,aAAA;AAykXN;;AAvkXI;EACE,YAAA;AAykXN;;AAxkXM;EACE,YAAA;AA0kXR;;AApkXA;EACE,eAAA;EACA,UAAA;EAEA,qBAAA;EACA,sCAAA;EACA,WAAA;EACA,aAAA;EACA,sCAAA;AAukXF;;AA/kXA;EAGE,SAAA;AA4kXF;;AA/kXA;EAGE,UAAA;AA4kXF;;AApkXA;;4EAAA;AAIA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAskXF;;AAnkXA;;4EAAA;AAIA;EACE,6BAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;AAqkXF;;AApkXE;EACE,6BAAA;EACA,yBAAA;AAskXJ;;AApkXE;EAEE,gBAAA;AAskXJ;;AAlkXA;;4EAAA;AAIA,4DAAA;AACA;EACE,eAAA;AAokXF;;AAjkXA,yBAAA;AAEA;EACE,iBAAA;EACA,yBAAA;AAmkXF;;AAhkXA;EACE,gBAAA;EACA,yBAAA;AAmkXF;;AAhkXA;EACE,4EACE;EAEF,kBAAA;AAikXF;;AA9jXA;EACE,YAAA;EACA,qBAAA;AAikXF;;AA9jXA;EACE,mBAAA;EACA,qBAAA;AAikXF;;AA9jXA;EACE,mBAAA;EACA,oBAAA;AAikXF;;AA9jXA;EACE,qBAAA;AAikXF;;AA9jXA,oBAAA;AAKM;EACE,wBAAA;AA6jXR;;AApjXM;EACE,uBAAA;AAujXR;;AAxjXM;EACE,uBAAA;AA2jXR;;AA5jXM;EACE,uBAAA;AA+jXR;;AAhkXM;EACE,wBAAA;AAmkXR;;AApkXM;EACE,wBAAA;AAukXR;;AAxkXM;EACE,wBAAA;AA2kXR;;AA5kXM;EACE,wBAAA;AA+kXR;;AAhlXM;EACE,wBAAA;AAmlXR;;AAplXM;EACE,wBAAA;AAulXR;;AAxlXM;EACE,yBAAA;AA2lXR;;AAxlXM;EACE,2BAAA;AA2lXR;;AA5lXM;EACE,2BAAA;AA+lXR;;AAhmXM;EACE,4BAAA;AAmmXR;;AApmXM;EACE,4BAAA;AAumXR;;AAxmXM;EACE,4BAAA;AA2mXR;;AA5mXM;EACE,4BAAA;AA+mXR;;AAhnXM;EACE,4BAAA;AAmnXR;;AApnXM;EACE,4BAAA;AAunXR;;AAxnXM;EACE,6BAAA;AA2nXR;;AA5nXM;EACE,8BAAA;AA+nXR;;AAhoXM;EACE,8BAAA;AAmoXR;;AApoXM;EACE,+BAAA;AAuoXR;;AAxoXM;EACE,+BAAA;AA2oXR;;AA5oXM;EACE,+BAAA;AA+oXR;;AAhpXM;EACE,+BAAA;AAmpXR;;AAppXM;EACE,+BAAA;AAupXR;;AAxpXM;EACE,+BAAA;AA2pXR;;AA5pXM;EACE,gCAAA;AA+pXR;;AAhqXM;EACE,6BAAA;AAmqXR;;AApqXM;EACE,4BAAA;AAmqXR;;AApqXM;EACE,8BAAA;AAuqXR;;AAxqXM;EACE,6BAAA;AAuqXR;;AAxqXM;EACE,8BAAA;AA2qXR;;AA5qXM;EACE,6BAAA;AA2qXR;;AA5qXM;EACE,8BAAA;AA+qXR;;AAhrXM;EACE,6BAAA;AA+qXR;;AAhrXM;EACE,8BAAA;AAmrXR;;AAprXM;EACE,6BAAA;AAmrXR;;AAprXM;EACE,8BAAA;AAurXR;;AAxrXM;EACE,6BAAA;AAurXR;;AAxrXM;EACE,8BAAA;AA2rXR;;AA5rXM;EACE,6BAAA;AA2rXR;;AA5rXM;EACE,+BAAA;AA+rXR;;AAhsXM;EACE,8BAAA;AA+rXR;;AAhsXM;EACE,4BAAA;AAmsXR;;AApsXM;EACE,6BAAA;AAmsXR;;AApsXM;EACE,6BAAA;AAusXR;;AAxsXM;EACE,8BAAA;AAusXR;;AAxsXM;EACE,6BAAA;AA2sXR;;AA5sXM;EACE,8BAAA;AA2sXR;;AA5sXM;EACE,6BAAA;AA+sXR;;AAhtXM;EACE,8BAAA;AA+sXR;;AAhtXM;EACE,6BAAA;AAmtXR;;AAptXM;EACE,8BAAA;AAmtXR;;AAptXM;EACE,6BAAA;AAutXR;;AAxtXM;EACE,8BAAA;AAutXR;;AAxtXM;EACE,6BAAA;AA2tXR;;AA5tXM;EACE,8BAAA;AA2tXR;;AA5tXM;EACE,8BAAA;AA+tXR;;AAhuXM;EACE,+BAAA;AA+tXR;;AArqXI;EACE,0BAAA;AAwqXN;;AAzqXI;EACE,2BAAA;AAwqXN;;AAzqXI;EACE,2BAAA;AA4qXN;;AA7qXI;EACE,0BAAA;AA4qXN;;AA7qXI;EACE,yBAAA;AAgrXN;;AAjrXI;EACE,4BAAA;AAorXN;;AAzrXI;EACE,qBAAA;AA4rXN;;AA7qXA,2BAAA;AAEA;EACE,WAAA;AA+qXF;;AA3qXI;EACE,0BAAA;AA8qXN;;AA3qXI;EACE,0BAAA;AA8qXN;;AA/qXI;EACE,2BAAA;AAkrXN;;AAnrXI;EACE,2BAAA;AAsrXN;;AAvrXI;EACE,2BAAA;AA0rXN;;AA3rXI;EACE,2BAAA;AA8rXN;;AA/rXI;EACE,2BAAA;AAksXN;;AAnsXI;EACE,2BAAA;AAssXN;;AAvsXI;EACE,4BAAA;AA0sXN;;AA3sXI;EACE,4BAAA;AA8sXN;;AA9rXA;EACE,sBAAA;EACA,UAAA;AAisXF;;AA9rXA;;4EAAA;AAIA;EACE,eAAA;AAgsXF;;AA7rXA;EACE,eAAA;AAgsXF;;AA7rXA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAgsXF;;AA7rXA;EACE,qBAAA;AAgsXF;;AA7rXA;;4EAAA;AAIA;;EAEE,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AA+rXF;;AA5rXA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA+rXF;;AA5rXA;EACE,kBAAA;AA+rXF;;AAhsXA;EACE,mBAAA;AA+rXF;;AA5rXA;EACE,gBAAA;AA+rXF;;AA5rXA;+EAAA;AAGA;EACE,oBAAA;AA8rXF;;AA3rXA,kEAAA;AAEA;EACE,aAAA;EACA,WAAA;AA6rXF;;AA1rXA;EACE,SAAA;EACA,mBAAA;AA6rXF","sourcesContent":["//app.scss\n// Override Bootstrap variables\n@import 'bootstrap-variables';\n// Import Bootstrap source files from node_modules\n@import 'bootstrap/scss/bootstrap';\nbody {\n  background: #fafafa;\n  margin: 0;\n}\n\na {\n  color: #533f03;\n  font-weight: bold;\n}\n\n* {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  &:after,\n  &::before {\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n}\n\n.app-container {\n  box-sizing: border-box;\n  .view-container {\n    width: 100%;\n    height: calc(100% - 40px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 1rem;\n    .card {\n      padding: 1rem;\n    }\n    .view-routes {\n      height: 100%;\n      > div {\n        height: 100%;\n      }\n    }\n  }\n}\n\n.fullscreen {\n  position: fixed;\n  top: 100px;\n  left: 0px;\n  width: 99% !important;\n  height: calc(100vh - 110px) !important;\n  margin: 5px;\n  z-index: 1000;\n  padding: 5px 25px 50px 25px !important;\n}\n\n/* ==========================================================================\nBrowser Upgrade Prompt\n========================================================================== */\n\n.browserupgrade {\n  margin: 0.2em 0;\n  background: #ccc;\n  color: #000;\n  padding: 0.2em 0;\n}\n\n/* ==========================================================================\nCustom button styles\n========================================================================== */\n\n.icon-button > .btn {\n  background-color: transparent;\n  border-color: transparent;\n  padding: 0.5rem;\n  line-height: 1rem;\n  &:hover {\n    background-color: transparent;\n    border-color: transparent;\n  }\n  &:focus {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n}\n\n/* ==========================================================================\nGeneric styles\n========================================================================== */\n\n/* Temporary workaround for availity-reactstrap-validation */\n.invalid-feedback {\n  display: inline;\n}\n\n/* other generic styles */\n\n.title {\n  font-size: 1.25em;\n  margin: 1px 10px 1px 10px;\n}\n\n.description {\n  font-size: 0.9em;\n  margin: 1px 10px 1px 10px;\n}\n\n.shadow {\n  box-shadow:\n    rgba(0, 0, 0, 0.12) 0px 1px 6px,\n    rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  border-radius: 2px;\n}\n\n.error {\n  color: white;\n  background-color: red;\n}\n\n.break {\n  white-space: normal;\n  word-break: break-all;\n}\n\n.break-word {\n  white-space: normal;\n  word-break: keep-all;\n}\n\n.preserve-space {\n  white-space: pre-wrap;\n}\n\n/* padding helpers */\n\n@mixin pad($size, $side) {\n  @if $size== '' {\n    @if $side== '' {\n      .pad {\n        padding: 10px !important;\n      }\n    } @else {\n      .pad {\n        padding-#{$side}: 10px !important;\n      }\n    }\n  } @else {\n    @if $side== '' {\n      .pad-#{$size} {\n        padding: #{$size}px !important;\n      }\n    } @else {\n      .pad-#{$side}-#{$size} {\n        padding-#{$side}: #{$size}px !important;\n      }\n    }\n  }\n}\n\n@include pad('', '');\n@include pad('2', '');\n@include pad('3', '');\n@include pad('5', '');\n@include pad('10', '');\n@include pad('20', '');\n@include pad('25', '');\n@include pad('30', '');\n@include pad('50', '');\n@include pad('75', '');\n@include pad('100', '');\n@include pad('4', 'top');\n@include pad('5', 'top');\n@include pad('10', 'top');\n@include pad('20', 'top');\n@include pad('25', 'top');\n@include pad('30', 'top');\n@include pad('50', 'top');\n@include pad('75', 'top');\n@include pad('100', 'top');\n@include pad('4', 'bottom');\n@include pad('5', 'bottom');\n@include pad('10', 'bottom');\n@include pad('20', 'bottom');\n@include pad('25', 'bottom');\n@include pad('30', 'bottom');\n@include pad('50', 'bottom');\n@include pad('75', 'bottom');\n@include pad('100', 'bottom');\n@include pad('5', 'right');\n@include pad('10', 'right');\n@include pad('20', 'right');\n@include pad('25', 'right');\n@include pad('30', 'right');\n@include pad('50', 'right');\n@include pad('75', 'right');\n@include pad('100', 'right');\n@include pad('5', 'left');\n@include pad('10', 'left');\n@include pad('20', 'left');\n@include pad('25', 'left');\n@include pad('30', 'left');\n@include pad('50', 'left');\n@include pad('75', 'left');\n@include pad('100', 'left');\n\n@mixin no-padding($side) {\n  @if $side== 'all' {\n    .no-padding {\n      padding: 0 !important;\n    }\n  } @else {\n    .no-padding-#{$side} {\n      padding-#{$side}: 0 !important;\n    }\n  }\n}\n\n@include no-padding('left');\n@include no-padding('right');\n@include no-padding('top');\n@include no-padding('bottom');\n@include no-padding('all');\n\n/* end of padding helpers */\n\n.no-margin {\n  margin: 0px;\n}\n@mixin voffset($size) {\n  @if $size== '' {\n    .voffset {\n      margin-top: 2px !important;\n    }\n  } @else {\n    .voffset-#{$size} {\n      margin-top: #{$size}px !important;\n    }\n  }\n}\n\n@include voffset('');\n@include voffset('5');\n@include voffset('10');\n@include voffset('15');\n@include voffset('30');\n@include voffset('40');\n@include voffset('60');\n@include voffset('80');\n@include voffset('100');\n@include voffset('150');\n\n.readonly {\n  background-color: #eee;\n  opacity: 1;\n}\n\n/* ==========================================================================\nmake sure browsers use the pointer cursor for anchors, even with no href\n========================================================================== */\n\na:hover {\n  cursor: pointer;\n}\n\n.hand {\n  cursor: pointer;\n}\n\nbutton.anchor-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  align-items: initial;\n  text-align: initial;\n  width: 100%;\n}\n\na.anchor-btn:hover {\n  text-decoration: none;\n}\n\n/* ==========================================================================\nMetrics and Health styles\n========================================================================== */\n\n#threadDump .popover,\n#healthCheck .popover {\n  top: inherit;\n  display: block;\n  font-size: 10px;\n  max-width: 1024px;\n}\n\n.thread-dump-modal-lock {\n  max-width: 450px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n#healthCheck .popover {\n  margin-left: -50px;\n}\n\n.health-details {\n  min-width: 400px;\n}\n\n/* bootstrap 3 input-group 100% width\nhttp://stackoverflow.com/questions/23436430/bootstrap-3-input-group-100-width */\n\n.width-min {\n  width: 1% !important;\n}\n\n/* jhipster-needle-scss-add-main JHipster will add new css style */\n\n.map-container {\n  height: 400px; // Hauteur de la carte\n  width: 100%; // Largeur de la carte\n}\n\nbody {\n  margin: 0;\n  background: #fafafa; // Assurez-vous que le fond est clair pour bien voir la carte\n}\n","/*\n* Bootstrap overrides https://v4-alpha.getbootstrap.com/getting-started/options/\n* All values defined in bootstrap source\n* https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss can be overwritten here\n* Make sure not to add !default to values here\n*/\n\n// Options:\n// Quickly modify global styling by enabling or disabling optional features.\n$enable-rounded: true;\n$enable-shadows: false;\n$enable-gradients: false;\n$enable-transitions: true;\n$enable-hover-media-query: false;\n$enable-grid-classes: true;\n$enable-print-styles: true;\n\n// Components:\n// Define common padding and border radius sizes and more.\n\n$border-radius: 0.15rem;\n$border-radius-lg: 0.125rem;\n$border-radius-sm: 0.1rem;\n\n// Body:\n// Settings for the `<body>` element.\n\n$body-bg: #ffffff;\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
